"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3732],{

/***/ 35295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);










var DotSplitedViews = function DotSplitedViews(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var views = props.views,
      dotStyle = props.dotStyle,
      textStyle = props.textStyle,
      isMobileVersion = props.isMobileVersion;

  var renderView = function renderView(view, index, isLast) {
    return [view, !isLast && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default()), {
      style: [styles.dot, isMobileVersion ? {
        height: 2,
        width: 2
      } : {}, dotStyle]
    }, index + "dot")];
  };

  var renderViews = function renderViews(views) {
    return views.map(function (text, index) {
      var isLast = index + 1 == views.length;
      return renderView(text, index, isLast);
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default()), {
    style: [styles.container, props.style],
    children: renderViews(views)
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default().create({
  container: {
    flexDirection: "row",
    alignItems: "center"
  },
  dot: {
    height: 5,
    width: 5,
    borderRadius: 60,
    marginHorizontal: 10,
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.lightGray */ .wL.lightGray
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (DotSplitedViews);

/***/ }),

/***/ 78576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52738);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54176);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85112);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var _atoms_DotSplitedViews__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35295);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var EventCardInfoView = function EventCardInfoView(props) {
  var _ref;

  var isMobileVersion = props.isMobileVersion,
      withoutBadge = props.withoutBadge;
  var _props$item = props.item,
      startDate = _props$item.startDate,
      endDate = _props$item.endDate,
      streetLocation = _props$item.streetLocation,
      location = _props$item.location,
      price = _props$item.price,
      city = _props$item.city,
      totalConnection = _props$item.totalConnection,
      totalRelatedConnection = _props$item.totalRelatedConnection,
      totalFollower = _props$item.totalFollower,
      totalGoing = _props$item.totalGoing,
      totalSaved = _props$item.totalSaved,
      totalLineup = _props$item.totalLineup,
      isOfficial = _props$item.isOfficial,
      isPro = _props$item.isPro;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showPopupOfficial = _useState[0],
      setShowPopupOfficial = _useState[1];

  var festivalStartDate = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(startDate, _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.dateFormat.DATE_FORMAT_SIMPLE */ .gT.dateFormat.DATE_FORMAT_SIMPLE);
  var festivalStartTime = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .diffFormat */ .Jf)(startDate, endDate, "days");
  var dataLocation = streetLocation || city || location;
  var formatedPrice = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)(price, _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.currencyType.USD */ .gT.currencyType.USD);
  var totalShare = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalConnection || totalRelatedConnection);
  var followerCount = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalFollower) === "-" ? (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(Number(totalGoing) + Number(totalSaved)) : (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalFollower);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer],
      onMouseOver: function onMouseOver() {
        return setShowPopupOfficial(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowPopupOfficial(false);
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.title, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}],
        numberOfLines: 1,
        children: props.item.title
      }), (isOfficial === 1 || isPro === 1) && !withoutBadge && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          marginLeft: 6,
          marginTop: 0,
          position: "relative"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadge */ .rU.iconVerifiedBadge,
          alt: "badge official",
          width: 14,
          height: 14,
          layout: "fixed"
        })
      }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          position: "absolute",
          width: isMobileVersion ? 260 : 336,
          height: isMobileVersion ? 140 + 24 : 182 + 24,
          zIndex: 10,
          left: -10,
          top: 0,
          paddingTop: 24
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: (_ref = {
            backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("bg-gray1"),
            width: isMobileVersion ? 260 : 336,
            height: isMobileVersion ? 140 : 182,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 22,
            borderRadius: 18
          }, (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "width", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "height", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
            source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadgeMedium */ .rU.iconVerifiedBadgeMedium,
            alt: "verified account",
            width: isMobileVersion ? 24 : 35,
            height: isMobileVersion ? 24 : 35,
            layout: "fixed"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryBold */ .F3.primaryBold,
              fontSize: isMobileVersion ? 16 : 20,
              lineHeight: isMobileVersion ? 20 : 24,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white */ .wL.white,
              marginVertical: isMobileVersion ? 9 : 14,
              textAlign: "center"
            },
            children: "Official Account"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryRegular */ .F3.primaryRegular,
              fontSize: isMobileVersion ? 12 : 16,
              lineHeight: isMobileVersion ? 16 : 18,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white80 */ .wL.white80,
              textAlign: "center"
            },
            children: ["This is an official account verified by", " ", "Cocktayl"]
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: festivalStartTime
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.dot
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, {
          flex: 1
        }, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        numberOfLines: 1,
        children: dataLocation
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.rowContainer],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconSearchArtist */ .rU.iconSearchArtist,
          width: 18,
          height: 18,
          layout: "fixed",
          alt: "lineup artists"
        }, 1), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.infoText, {
            marginLeft: 4
          }],
          children: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalLineup)
        })]
      })
    })]
  });
};

var FestivalCardInfoView = function FestivalCardInfoView(props) {
  var _ref2;

  var isMobileVersion = props.isMobileVersion,
      withoutBadge = props.withoutBadge;
  var _props$item2 = props.item,
      startDate = _props$item2.startDate,
      endDate = _props$item2.endDate,
      streetLocation = _props$item2.streetLocation,
      location = _props$item2.location,
      price = _props$item2.price,
      city = _props$item2.city,
      totalConnection = _props$item2.totalConnection,
      totalRelatedConnection = _props$item2.totalRelatedConnection,
      totalFollower = _props$item2.totalFollower,
      totalGoing = _props$item2.totalGoing,
      totalSaved = _props$item2.totalSaved,
      totalLineup = _props$item2.totalLineup,
      isOfficial = _props$item2.isOfficial,
      isPro = _props$item2.isPro;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showPopupOfficial = _useState2[0],
      setShowPopupOfficial = _useState2[1];

  var festivalStartDate = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(startDate, _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.dateFormat.DATE_FORMAT_SIMPLE */ .gT.dateFormat.DATE_FORMAT_SIMPLE);
  var festivalStartTime = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .diffFormat */ .Jf)(startDate, endDate, "days");
  var dataLocation = streetLocation || city || location;
  var formatedPrice = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)(price, _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.currencyType.USD */ .gT.currencyType.USD);
  var totalShare = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalConnection || totalRelatedConnection);
  var followerCount = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalFollower) === "-" ? (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(Number(totalGoing) + Number(totalSaved)) : (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalFollower);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer],
      onMouseOver: function onMouseOver() {
        return setShowPopupOfficial(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowPopupOfficial(false);
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.title, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}],
        numberOfLines: 1,
        children: props.item.title
      }), (isOfficial === 1 || isPro === 1) && !withoutBadge && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          marginLeft: 6,
          marginTop: 0,
          position: "relative"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadge */ .rU.iconVerifiedBadge,
          alt: "badge official",
          width: 14,
          height: 14,
          layout: "fixed"
        })
      }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          position: "absolute",
          width: isMobileVersion ? 260 : 336,
          height: isMobileVersion ? 140 + 24 : 182 + 24,
          zIndex: 10,
          left: -10,
          top: 0,
          paddingTop: 24
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: (_ref2 = {
            backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("bg-gray1"),
            width: isMobileVersion ? 260 : 336,
            height: isMobileVersion ? 140 : 182,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 22,
            borderRadius: 18
          }, (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "width", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "height", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref2),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
            source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadgeMedium */ .rU.iconVerifiedBadgeMedium,
            alt: "verified account",
            width: isMobileVersion ? 24 : 35,
            height: isMobileVersion ? 24 : 35,
            layout: "fixed"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryBold */ .F3.primaryBold,
              fontSize: isMobileVersion ? 16 : 20,
              lineHeight: isMobileVersion ? 20 : 24,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white */ .wL.white,
              marginVertical: isMobileVersion ? 9 : 14,
              textAlign: "center"
            },
            children: "Official Account"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryRegular */ .F3.primaryRegular,
              fontSize: isMobileVersion ? 12 : 16,
              lineHeight: isMobileVersion ? 16 : 18,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white80 */ .wL.white80,
              textAlign: "center"
            },
            children: ["This is an official account verified by", " ", "Cocktayl"]
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: festivalStartTime
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.dot
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, {
          flex: 1
        }, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        numberOfLines: 1,
        children: dataLocation
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.rowContainer],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconSearchArtist */ .rU.iconSearchArtist,
          width: 18,
          height: 18,
          layout: "fixed",
          alt: "lineup artists"
        }, 1), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.infoText, {
            marginLeft: 4
          }],
          children: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(totalLineup)
        })]
      })
    })]
  });
};

var ArtistCardInfoView = function ArtistCardInfoView(props) {
  var _props$item$specialis;

  var isMobileVersion = props.isMobileVersion;
  var totalEventString = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(props.item.totalEvent);
  var totalFollowerString = props.item.totalFollower || "-";
  var totalShareString = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(props.item.totalConnection) || "-";
  var totalLineup = props.item.totalLineup || "-";

  var renderViews = function renderViews() {
    return [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: styles.rowContainer,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
        source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconTicket */ .rU.iconTicket,
        width: 16,
        height: 16,
        layout: "fixed",
        alt: "ticket entry"
      }, 1), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.infoText, {
          marginLeft: 4,
          marginRight: 10
        }],
        children: totalEventString
      }, 2)]
    }, 1)];
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
      style: [styles.title, isMobileVersion ? {
        fontSize: 12,
        lineHeight: 18
      } : {}],
      numberOfLines: 1,
      children: props.item.displayName
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getSpecialist */ .Mf)((_props$item$specialis = props.item.specialist) === null || _props$item$specialis === void 0 ? void 0 : _props$item$specialis.split(","))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.dot
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: props.item.country || props.item.location
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms_DotSplitedViews__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        views: renderViews()
      })
    })]
  });
};

var VenueCardInfoView = function VenueCardInfoView(props) {
  var _ref3, _props$item$company_h, _minBy, _minBy2, _minBy3, _props$item$company_h2, _props$item4, _props$item4$tag_cate, _props$item4$tag_cate2, _props$item5, _props$item5$tag_cate, _props$item5$tag_cate2, _props$item6, _props$item6$tag_cate, _props$item7, _props$item7$tag_cate, _props$item8, _props$item8$tag_cate, _props$item8$tag_cate2, _props$item9, _props$item9$tag_cate, _props$item9$tag_cate2, _props$item10, _props$item10$tag_cat, _props$item11, _props$item11$tag_cat, _props$item12, _props$item13, _props$item14, _props$item15, _props$item15$tag_hab, _props$item15$tag_hab2, _props$item16, _props$item16$tag_hab, _props$item16$tag_hab2, _props$item17, _props$item17$tag_hab, _props$item18, _props$item18$tag_hab, _props$item19, _props$item19$tag_fea, _props$item19$tag_fea2, _props$item20, _props$item20$tag_fea, _props$item20$tag_fea2, _props$item21, _props$item21$tag_fea, _props$item22, _props$item22$tag_fea, _props$item23, _props$item24, _props$item24$tag_cat, _props$item24$tag_cat2, _props$item25, _props$item25$tag_cat, _props$item25$tag_cat2, _props$item26, _props$item26$tag_cat, _props$item27, _props$item27$tag_cat, _props$item28, _props$item28$tag_fea, _props$item28$tag_fea2, _props$item29, _props$item29$tag_fea, _props$item29$tag_fea2, _props$item30, _props$item30$tag_fea, _props$item31, _props$item31$tag_fea, _props$item32, _props$item32$tag_fea, _props$item32$tag_fea2, _props$item33, _props$item33$tag_fea, _props$item33$tag_fea2, _props$item34, _props$item34$tag_fea, _props$item35, _props$item35$tag_fea, _props$item36, _props$item36$tag_fea, _props$item36$tag_fea2, _props$item37, _props$item37$tag_fea, _props$item37$tag_fea2, _props$item38, _props$item38$tag_fea, _props$item39, _props$item39$tag_fea, _props$item40, _props$item40$tag_ser, _props$item40$tag_ser2, _props$item41, _props$item41$tag_ser, _props$item41$tag_ser2, _props$item42, _props$item42$tag_ser, _props$item43, _props$item43$tag_ser, _props$item44;

  var isMobileVersion = props.isMobileVersion,
      category = props.category,
      withoutBadge = props.withoutBadge;
  var _props$item3 = props.item,
      isOfficial = _props$item3.isOfficial,
      isPro = _props$item3.isPro;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showPopupOfficial = _useState3[0],
      setShowPopupOfficial = _useState3[1];

  var totalEventString = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(props.item.totalEvent);
  var totalFollowerString = props.item.totalFollower || "-";
  var totalShareString = (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(props.item.totalConnection) || "-";
  var totalLineup = props.item.totalLineup || "-";

  var renderViews = function renderViews() {
    return [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: styles.rowContainer,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
        source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconSearchOther */ .rU.iconSearchOther,
        width: 20,
        height: 20,
        layout: "fixed",
        alt: "followers"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.infoText, {
          marginLeft: 4
        }],
        children: totalFollowerString
      }, 4)]
    }, 1)];
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer],
      onMouseOver: function onMouseOver() {
        return setShowPopupOfficial(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowPopupOfficial(false);
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.title, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}],
        numberOfLines: 1,
        children: props.item.displayName
      }), (isOfficial === 1 || isPro === 1) && !withoutBadge && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          marginLeft: 6,
          marginTop: 0,
          position: "relative"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadge */ .rU.iconVerifiedBadge,
          alt: "badge official",
          width: 14,
          height: 14,
          layout: "fixed"
        })
      }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: {
          position: "absolute",
          width: isMobileVersion ? 260 : 336,
          height: isMobileVersion ? 140 + 24 : 182 + 24,
          zIndex: 10,
          left: -10,
          top: 0,
          paddingTop: 24
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: (_ref3 = {
            backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("bg-gray1"),
            width: isMobileVersion ? 260 : 336,
            height: isMobileVersion ? 140 : 182,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 22,
            borderRadius: 18
          }, (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref3, "width", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref3, "height", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref3, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref3),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
            source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconVerifiedBadgeMedium */ .rU.iconVerifiedBadgeMedium,
            alt: "verified account",
            width: isMobileVersion ? 24 : 35,
            height: isMobileVersion ? 24 : 35,
            layout: "fixed"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryBold */ .F3.primaryBold,
              fontSize: isMobileVersion ? 16 : 20,
              lineHeight: isMobileVersion ? 20 : 24,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white */ .wL.white,
              marginVertical: isMobileVersion ? 9 : 14,
              textAlign: "center"
            },
            children: "Official Account"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
            style: {
              fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryRegular */ .F3.primaryRegular,
              fontSize: isMobileVersion ? 12 : 16,
              lineHeight: isMobileVersion ? 16 : 18,
              color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white80 */ .wL.white80,
              textAlign: "center"
            },
            children: ["This is an official account verified by", " ", "Cocktayl"]
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: props.item.company_name || "-"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: props.item.city || "-"
        })
      })
    }), category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.rowContainer, {
        marginTop: 10
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: "".concat((_props$item$company_h = props.item.company_homes) === null || _props$item$company_h === void 0 ? void 0 : _props$item$company_h.length, " Homes")
      }), ((_minBy = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.minBy)(props.item.company_homes, "minPrice")) === null || _minBy === void 0 ? void 0 : _minBy.minPrice) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.dot
      }), ((_minBy2 = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.minBy)(props.item.company_homes, "minPrice")) === null || _minBy2 === void 0 ? void 0 : _minBy2.minPrice) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: [styles.description, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: "From ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)((_minBy3 = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.minBy)(props.item.company_homes, "minPrice")) === null || _minBy3 === void 0 ? void 0 : _minBy3.minPrice)))
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.rowContainer, {
          marginTop: 10
        }],
        children: ["Venue Cocktail".split(",").find(function (i) {
          return i === "Animals";
        }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: "".concat((_props$item$company_h2 = props.item.company_homes) === null || _props$item$company_h2 === void 0 ? void 0 : _props$item$company_h2.length, " Animals")
        }), "Venue Cocktail".split(",").find(function (i) {
          return i === "Animals";
        }) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: styles.dot
        }), props.item.tag_species_animal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: "Animals ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatTagRange */ .cN)(_config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */ .gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES, props.item.tag_species_animal))
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.rowContainer, {
          marginTop: 10
        }],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? props.item.tag_venue_1 || "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? ((_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : (_props$item4$tag_cate = _props$item4.tag_category) === null || _props$item4$tag_cate === void 0 ? void 0 : (_props$item4$tag_cate2 = _props$item4$tag_cate.filter(function (i, index) {
            return index <= 0;
          })) === null || _props$item4$tag_cate2 === void 0 ? void 0 : _props$item4$tag_cate2.length) > 0 ? ((_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : (_props$item5$tag_cate = _props$item5.tag_category) === null || _props$item5$tag_cate === void 0 ? void 0 : (_props$item5$tag_cate2 = _props$item5$tag_cate.filter(function (i, index) {
            return index <= 0;
          })) === null || _props$item5$tag_cate2 === void 0 ? void 0 : _props$item5$tag_cate2.join(", ")) + (((_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : (_props$item6$tag_cate = _props$item6.tag_category) === null || _props$item6$tag_cate === void 0 ? void 0 : _props$item6$tag_cate.length) > 1 ? " +" + (((_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : (_props$item7$tag_cate = _props$item7.tag_category) === null || _props$item7$tag_cate === void 0 ? void 0 : _props$item7$tag_cate.length) - 1) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? ((_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : (_props$item8$tag_cate = _props$item8.tag_category) === null || _props$item8$tag_cate === void 0 ? void 0 : (_props$item8$tag_cate2 = _props$item8$tag_cate.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item8$tag_cate2 === void 0 ? void 0 : _props$item8$tag_cate2.length) > 0 ? ((_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : (_props$item9$tag_cate = _props$item9.tag_category) === null || _props$item9$tag_cate === void 0 ? void 0 : (_props$item9$tag_cate2 = _props$item9$tag_cate.filter(function (i, index) {
            return index <= 0;
          })) === null || _props$item9$tag_cate2 === void 0 ? void 0 : _props$item9$tag_cate2.join(", ")) + (((_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : (_props$item10$tag_cat = _props$item10.tag_category) === null || _props$item10$tag_cat === void 0 ? void 0 : _props$item10$tag_cat.length) > 1 ? " +" + (((_props$item11 = props.item) === null || _props$item11 === void 0 ? void 0 : (_props$item11$tag_cat = _props$item11.tag_category) === null || _props$item11$tag_cat === void 0 ? void 0 : _props$item11$tag_cat.length) - 1) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? ((_props$item12 = props.item) === null || _props$item12 === void 0 ? void 0 : _props$item12.tag_category) || "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? null : category === // ? props.item?.tag_category || "-"
          _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
            style: {
              flexDirection: "row",
              alignItems: "center",
              marginTop: 2
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
              width: 16,
              height: 16,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconTagStar */ .rU.iconTagStar,
              style: styles.icon,
              resizeMode: "contain",
              alt: "star"
            }, 1), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
              style: {
                marginLeft: 4
              },
              children: ((_props$item13 = props.item) === null || _props$item13 === void 0 ? void 0 : _props$item13.tag_star) || "-"
            })]
          }) : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? ((_props$item14 = props.item) === null || _props$item14 === void 0 ? void 0 : _props$item14.tag_category) || "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? ((_props$item15 = props.item) === null || _props$item15 === void 0 ? void 0 : (_props$item15$tag_hab = _props$item15.tag_habitat) === null || _props$item15$tag_hab === void 0 ? void 0 : (_props$item15$tag_hab2 = _props$item15$tag_hab.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item15$tag_hab2 === void 0 ? void 0 : _props$item15$tag_hab2.length) > 0 ? ((_props$item16 = props.item) === null || _props$item16 === void 0 ? void 0 : (_props$item16$tag_hab = _props$item16.tag_habitat) === null || _props$item16$tag_hab === void 0 ? void 0 : (_props$item16$tag_hab2 = _props$item16$tag_hab.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item16$tag_hab2 === void 0 ? void 0 : _props$item16$tag_hab2.join(", ")) + (((_props$item17 = props.item) === null || _props$item17 === void 0 ? void 0 : (_props$item17$tag_hab = _props$item17.tag_habitat) === null || _props$item17$tag_hab === void 0 ? void 0 : _props$item17$tag_hab.length) > 2 ? " +" + (((_props$item18 = props.item) === null || _props$item18 === void 0 ? void 0 : (_props$item18$tag_hab = _props$item18.tag_habitat) === null || _props$item18$tag_hab === void 0 ? void 0 : _props$item18$tag_hab.length) - 1) : "") || "-" : "-" : props.item.tag_venue_2 || "-"
        }), category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? null :
        /*#__PURE__*/
        // <>{props.item?.tag_price && <View style={styles.dot} />}</>
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: styles.dot
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? ((_props$item19 = props.item) === null || _props$item19 === void 0 ? void 0 : (_props$item19$tag_fea = _props$item19.tag_feature) === null || _props$item19$tag_fea === void 0 ? void 0 : (_props$item19$tag_fea2 = _props$item19$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item19$tag_fea2 === void 0 ? void 0 : _props$item19$tag_fea2.length) > 0 ? ((_props$item20 = props.item) === null || _props$item20 === void 0 ? void 0 : (_props$item20$tag_fea = _props$item20.tag_feature) === null || _props$item20$tag_fea === void 0 ? void 0 : (_props$item20$tag_fea2 = _props$item20$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item20$tag_fea2 === void 0 ? void 0 : _props$item20$tag_fea2.join(", ")) + (((_props$item21 = props.item) === null || _props$item21 === void 0 ? void 0 : (_props$item21$tag_fea = _props$item21.tag_feature) === null || _props$item21$tag_fea === void 0 ? void 0 : _props$item21$tag_fea.length) > 2 ? " +" + (((_props$item22 = props.item) === null || _props$item22 === void 0 ? void 0 : (_props$item22$tag_fea = _props$item22.tag_feature) === null || _props$item22$tag_fea === void 0 ? void 0 : _props$item22$tag_fea.length) - 2) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? (_props$item23 = props.item) !== null && _props$item23 !== void 0 && _props$item23.tag_price ? null : // `From ${formatCurrency(
          //     formatNumber(props.item?.tag_price)
          //   )}`
          null : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? ((_props$item24 = props.item) === null || _props$item24 === void 0 ? void 0 : (_props$item24$tag_cat = _props$item24.tag_category) === null || _props$item24$tag_cat === void 0 ? void 0 : (_props$item24$tag_cat2 = _props$item24$tag_cat.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item24$tag_cat2 === void 0 ? void 0 : _props$item24$tag_cat2.length) > 0 ? ((_props$item25 = props.item) === null || _props$item25 === void 0 ? void 0 : (_props$item25$tag_cat = _props$item25.tag_category) === null || _props$item25$tag_cat === void 0 ? void 0 : (_props$item25$tag_cat2 = _props$item25$tag_cat.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item25$tag_cat2 === void 0 ? void 0 : _props$item25$tag_cat2.join(", ")) + (((_props$item26 = props.item) === null || _props$item26 === void 0 ? void 0 : (_props$item26$tag_cat = _props$item26.tag_category) === null || _props$item26$tag_cat === void 0 ? void 0 : _props$item26$tag_cat.length) > 2 ? " +" + (((_props$item27 = props.item) === null || _props$item27 === void 0 ? void 0 : (_props$item27$tag_cat = _props$item27.tag_category) === null || _props$item27$tag_cat === void 0 ? void 0 : _props$item27$tag_cat.length) - 2) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? ((_props$item28 = props.item) === null || _props$item28 === void 0 ? void 0 : (_props$item28$tag_fea = _props$item28.tag_feature) === null || _props$item28$tag_fea === void 0 ? void 0 : (_props$item28$tag_fea2 = _props$item28$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item28$tag_fea2 === void 0 ? void 0 : _props$item28$tag_fea2.length) > 0 ? ((_props$item29 = props.item) === null || _props$item29 === void 0 ? void 0 : (_props$item29$tag_fea = _props$item29.tag_feature) === null || _props$item29$tag_fea === void 0 ? void 0 : (_props$item29$tag_fea2 = _props$item29$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item29$tag_fea2 === void 0 ? void 0 : _props$item29$tag_fea2.join(", ")) + (((_props$item30 = props.item) === null || _props$item30 === void 0 ? void 0 : (_props$item30$tag_fea = _props$item30.tag_feature) === null || _props$item30$tag_fea === void 0 ? void 0 : _props$item30$tag_fea.length) > 2 ? " +" + (((_props$item31 = props.item) === null || _props$item31 === void 0 ? void 0 : (_props$item31$tag_fea = _props$item31.tag_feature) === null || _props$item31$tag_fea === void 0 ? void 0 : _props$item31$tag_fea.length) - 2) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? null : // ? props.item?.tag_area?.join(", ")
          category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? ((_props$item32 = props.item) === null || _props$item32 === void 0 ? void 0 : (_props$item32$tag_fea = _props$item32.tag_feature) === null || _props$item32$tag_fea === void 0 ? void 0 : (_props$item32$tag_fea2 = _props$item32$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item32$tag_fea2 === void 0 ? void 0 : _props$item32$tag_fea2.length) > 0 ? ((_props$item33 = props.item) === null || _props$item33 === void 0 ? void 0 : (_props$item33$tag_fea = _props$item33.tag_feature) === null || _props$item33$tag_fea === void 0 ? void 0 : (_props$item33$tag_fea2 = _props$item33$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item33$tag_fea2 === void 0 ? void 0 : _props$item33$tag_fea2.join(", ")) + (((_props$item34 = props.item) === null || _props$item34 === void 0 ? void 0 : (_props$item34$tag_fea = _props$item34.tag_feature) === null || _props$item34$tag_fea === void 0 ? void 0 : _props$item34$tag_fea.length) > 2 ? " +" + (((_props$item35 = props.item) === null || _props$item35 === void 0 ? void 0 : (_props$item35$tag_fea = _props$item35.tag_feature) === null || _props$item35$tag_fea === void 0 ? void 0 : _props$item35$tag_fea.length) - 2) : "") || "-" : "-" : category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? ((_props$item36 = props.item) === null || _props$item36 === void 0 ? void 0 : (_props$item36$tag_fea = _props$item36.tag_feature) === null || _props$item36$tag_fea === void 0 ? void 0 : (_props$item36$tag_fea2 = _props$item36$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item36$tag_fea2 === void 0 ? void 0 : _props$item36$tag_fea2.length) > 0 ? ((_props$item37 = props.item) === null || _props$item37 === void 0 ? void 0 : (_props$item37$tag_fea = _props$item37.tag_feature) === null || _props$item37$tag_fea === void 0 ? void 0 : (_props$item37$tag_fea2 = _props$item37$tag_fea.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item37$tag_fea2 === void 0 ? void 0 : _props$item37$tag_fea2.join(", ")) + (((_props$item38 = props.item) === null || _props$item38 === void 0 ? void 0 : (_props$item38$tag_fea = _props$item38.tag_feature) === null || _props$item38$tag_fea === void 0 ? void 0 : _props$item38$tag_fea.length) > 2 ? " +" + (((_props$item39 = props.item) === null || _props$item39 === void 0 ? void 0 : (_props$item39$tag_fea = _props$item39.tag_feature) === null || _props$item39$tag_fea === void 0 ? void 0 : _props$item39$tag_fea.length) - 2) : "") || "-" : "-" : ((_props$item40 = props.item) === null || _props$item40 === void 0 ? void 0 : (_props$item40$tag_ser = _props$item40.tag_service) === null || _props$item40$tag_ser === void 0 ? void 0 : (_props$item40$tag_ser2 = _props$item40$tag_ser.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item40$tag_ser2 === void 0 ? void 0 : _props$item40$tag_ser2.length) > 0 ? ((_props$item41 = props.item) === null || _props$item41 === void 0 ? void 0 : (_props$item41$tag_ser = _props$item41.tag_service) === null || _props$item41$tag_ser === void 0 ? void 0 : (_props$item41$tag_ser2 = _props$item41$tag_ser.filter(function (i, index) {
            return index <= 1;
          })) === null || _props$item41$tag_ser2 === void 0 ? void 0 : _props$item41$tag_ser2.join(", ")) + (((_props$item42 = props.item) === null || _props$item42 === void 0 ? void 0 : (_props$item42$tag_ser = _props$item42.tag_service) === null || _props$item42$tag_ser === void 0 ? void 0 : _props$item42$tag_ser.length) > 2 ? " +" + (((_props$item43 = props.item) === null || _props$item43 === void 0 ? void 0 : (_props$item43$tag_ser = _props$item43.tag_service) === null || _props$item43$tag_ser === void 0 ? void 0 : _props$item43$tag_ser.length) - 2) : "") || "-" : "-"
        }), category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
          style: styles.dot
        }), category === _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: [styles.description, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 18
          } : {}],
          children: [(0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)((_props$item44 = props.item) === null || _props$item44 === void 0 ? void 0 : _props$item44.tag_size), " sqft"]
        })]
      })
    })]
  });
};

var CardInfoView = function CardInfoView(props) {
  var isMobileVersion = props.isMobileVersion;
  if (!props.item) return null;

  if (props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(EventCardInfoView, _objectSpread({}, props));
  } else if (props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_FESTIVAL */ .gT.categoryType.CATEGORY_FESTIVAL) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(FestivalCardInfoView, _objectSpread({}, props));
  } else if (props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ArtistCardInfoView, _objectSpread({}, props));
  } else if (props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL || props.category == _config__WEBPACK_IMPORTED_MODULE_3__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(VenueCardInfoView, _objectSpread({}, props));
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
      style: [styles.title, isMobileVersion ? {
        fontSize: 12,
        lineHeight: 18
      } : {}],
      children: props.item.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
      style: [styles.description, isMobileVersion ? {
        fontSize: 10,
        lineHeight: 18
      } : {}],
      children: props.item.shortDescription
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: styles.rowContainer,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
        style: styles.location,
        children: props.item.city
      }), props.item.gemCount && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.dot
      }), props.item.gemCount && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
          width: 16,
          height: 16,
          layout: "fixed",
          source: _config__WEBPACK_IMPORTED_MODULE_3__/* .Images.iconTicket */ .rU.iconTicket,
          style: styles.icon,
          resizeMode: "contain",
          alt: "ticket entry"
        }, 1), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_10___default()), {
          style: styles.location,
          children: props.item.gemCount
        })]
      })]
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_11___default().create({
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  container: {
    flexDirection: "column"
  },
  title: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.white */ .wL.white,
    textAlign: "left"
  },
  description: {
    fontSize: 14,
    lineHeight: 18,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.darkGray */ .wL.darkGray
  },
  dot: {
    height: 2,
    width: 2,
    borderRadius: 1,
    marginHorizontal: 6,
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.lightGray */ .wL.lightGray
  },
  location: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryMedium */ .F3.primaryMedium,
    color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.lightGray */ .wL.lightGray
  },
  infoText: {
    fontSize: 14,
    lineHeight: 14,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    color: _config__WEBPACK_IMPORTED_MODULE_3__/* .Colors.lightGray */ .wL.lightGray
  },
  row: {
    flexDirection: "row",
    alignItems: "center"
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 4
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (CardInfoView);

/***/ }),

/***/ 51531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CardItem; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/CardInfoView.js
var CardInfoView = __webpack_require__(78576);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/helpers/index.js + 1 modules
var helpers = __webpack_require__(85112);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/CardList/components/PortraitCardItem.js














var PortraitCardItem = function PortraitCardItem(props) {
  var _props$item, _props$item2, _props$item4, _props$item5, _props$item6, _props$item7, _props$item8;

  var isChartsMode = props.isChartsMode,
      chartIndex = props.chartIndex;
  var festivalStartDate = (0,helpers/* formatDate */.p6)(props.item.startDate, config/* Constants.dateFormat.DATE_FORMAT_SIMPLE */.gT.dateFormat.DATE_FORMAT_SIMPLE);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: props.mapFocused === ((_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.id) ? "".concat((0,formatHelpers/* getClass */.ll)("btn-gradient"), " p-1px") : "",
    id: "items-".concat((_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.id),
    style: props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || props.category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT || props.category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || props.category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || props.category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || props.category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || props.category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || props.category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || props.category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || props.category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || props.category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || props.category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || props.category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || props.category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || props.category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || props.category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? {
      width: props.fullWidth ? props.mapView ? 347 : "97%" : 350,
      height: 250,
      borderRadius: 16,
      marginBottom: 20,
      marginRight: 10
    } : {
      width: props.fullWidth ? props.mapView ? 347 : "97%" : 230,
      height: 250,
      borderRadius: 16,
      marginBottom: 20,
      marginRight: 10
    },
    onMouseOver: function onMouseOver() {
      var _props$item3;

      return props.setMapFocused ? props.setMapFocused((_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.id) : null;
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()) // activeOpacity={1}
    , {
      style: [styles.container, {
        width: "100%",
        height: props.mapFocused === ((_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.id) ? 248 : 250
      }, props.itemContainerStyle] // onPress={() => {
      //   onItemAction({
      //     type: Constants.actionType.ACTION_VIEW,
      //     item: props.item,
      //   });
      // }}
      ,
      children: [props.category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER || props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.backgroundImageContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          imgUrl: props.item.avatar || (props.category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER ? "Local:defaultOther" : "Local:defaultArtist"),
          style: styles.backgroundImage,
          resizeMode: "cover",
          alt: "Avatar ".concat(props === null || props === void 0 ? void 0 : (_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.displayName)
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.backgroundImageContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          imgUrl: props.item.avatar ? props.item.avatar : props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? "Local:defaultArtist" : props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "Local:defaultFestival" : props.category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? "Local:defaultEvent" : props.category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? "Local:defaultVenue" : props.category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? "Local:defaultGeneral" //TODO (Garry): Need change to rooftop icon
          : props.category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? "Local:defaultGeneral" //TODO (Garry): Need change to spa icon
          : props.category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Local:defaultGeneral" //TODO (Garry): Need change to venue beachful icon
          : props.category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Local:defaultGeneral" //TODO (Garry): Need change to venue prefab company icon
          : props.category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? "Local:defaultGeneral" //TODO (Garry): Need change to venue prefab home icon
          : props.category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? "Local:defaultGeneral" //TODO (Garry): Need change to zoo icon
          : props.category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? "Local:defaultGeneral" //TODO (Garry): Need change to animal icon
          : props.category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "Local:defaultGeneral" //TODO (Garry): Need change to parkful icon
          : props.category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? "Local:defaultGeneral" //TODO (Garry): Need change to casino icon
          : props.category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? "Local:defaultGeneral" //TODO (Garry): Need change to castle icon
          : props.category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? "Local:defaultGeneral" //TODO (Garry): Need change to resort icon
          : props.category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? "Local:defaultGeneral" //TODO (Garry): Need change to aparthotel icon
          : props.category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Local:defaultGeneral" //TODO (Garry): Need change to venue cocktail icon
          : "Local:defaultOther",
          style: styles.backgroundImage,
          resizeMode: "cover",
          alt: props.category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || props.category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || props.category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || props.category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || props.category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || props.category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || props.category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || props.category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || props.category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || props.category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || props.category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || props.category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || props.category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || props.category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "".concat(props === null || props === void 0 ? void 0 : (_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : _props$item6.displayName, " Logo") : "".concat(props === null || props === void 0 ? void 0 : (_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : _props$item7.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.startDate).format("YYYY"), " Logo")
        })
      }), (props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || props.category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-black9 absolute top-0 left-0 m-4 rounded-xl w-12 h-14 flex flex-col justify-center items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-regular uppercase text-xs text-white40",
          children: festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.substring(0, 3)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-bold uppercase text-xs text-white",
          children: festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.substring((festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.length) - 3, 3)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-regular uppercase text-xs text-white40",
          children: festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.substring((festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.length) - 3, festivalStartDate === null || festivalStartDate === void 0 ? void 0 : festivalStartDate.length)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-gradient-to-t from-realblack to-transparent",
        style: styles.mask
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardInfoView/* default */.Z, {
        item: props.item,
        category: props.category,
        style: styles.info,
        withoutBadge: props.withoutBadge
      }), isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.infoBox,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 0
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [styles.infoBoxText, {
            marginLeft: 0
          }],
          children: chartIndex + 1
        })]
      })]
    })
  });
};

var styles = StyleSheet_default().create({
  plusButton: {
    position: "absolute",
    right: 10,
    top: 10,
    width: 30,
    height: 30
  },
  backgroundImageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    borderRadius: 16,
    overflow: "hidden"
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%"
  },
  mask: {
    position: "absolute",
    bottom: 0,
    height: 175,
    width: "100%",
    borderRadius: 15
  },
  container: {
    width: 180,
    height: 230,
    flexDirection: "column",
    marginRight: 10,
    marginBottom: 20,
    justifyContent: "flex-end",
    // overflow: "hidden",
    position: "relative"
  },
  info: {
    paddingHorizontal: 16,
    paddingBottom: 16,
    alignSelf: "stretch"
  },
  infoBox: {
    position: "absolute",
    right: 15,
    top: 23,
    width: 32,
    height: 32,
    borderRadius: 60,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row"
  },
  infoBoxText: (0,defineProperty/* default */.Z)({
    fontSize: 12,
    lineHeight: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    position: "relative",
    zIndex: 10,
    marginLeft: 8
  }, "zIndex", 0)
});
/* harmony default export */ var components_PortraitCardItem = (PortraitCardItem);
// EXTERNAL MODULE: ./src/components/atoms/DotSplitedViews.js
var DotSplitedViews = __webpack_require__(35295);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/molecules/CardList/components/UserInfoView.js
















var UserInfoView = function UserInfoView(props) {
  var _item$specialist, _ref;

  var categoryType = props.categoryType,
      item = props.item,
      isMobileVersion = props.isMobileVersion,
      firstIndex = props.firstIndex,
      lastIndex = props.lastIndex,
      isGuides = props.isGuides,
      isHeading = props.isHeading,
      withoutBadge = props.withoutBadge;
  var displayName = item.displayName,
      nickname = item.nickname,
      country = item.country,
      location = item.location,
      totalEvent = item.totalEvent,
      totalConnection = item.totalConnection,
      totalFollower = item.totalFollower,
      togetherFollowing = item.togetherFollowing,
      isOfficial = item.isOfficial,
      isPro = item.isPro,
      description = item.description,
      dist = item.dist;

  var _useState = (0,react.useState)(false),
      showPopupOfficial = _useState[0],
      setShowPopupOfficial = _useState[1];

  var specialist = (0,formatHelpers/* getSpecialist */.Mf)((_item$specialist = item.specialist) === null || _item$specialist === void 0 ? void 0 : _item$specialist.split(","));

  if (!item.specialist) {
    specialist = (0,formatHelpers/* getSpecialist */.Mf)(item.genres);
  }

  var totalFollowerString = totalFollower || "-";
  var totalEventString = Number(totalEvent) || "-";
  var totalShareString = (0,helpers/* formatNumber */.uf)(totalConnection) || "-";
  var genreString = specialist || "-";
  var locationString = country || location || "-";

  var getLocation = function getLocation(location) {
    var locationArray = location.split("");

    if (locationArray[0] === ",") {
      if (locationArray.length === 2) {
        return "-";
      } else {
        locationArray.shift();
      }
    }

    return locationArray;
  };

  var renderViews = function renderViews() {
    return isMobileVersion ? [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: UserInfoView_styles.rowContainer,
      children: [categoryType !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && categoryType !== config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && categoryType !== config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && categoryType !== config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && categoryType !== config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && categoryType !== config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && categoryType !== config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && categoryType !== config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && categoryType !== config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && categoryType !== config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && categoryType !== config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && categoryType !== config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && categoryType !== config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && categoryType !== config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        source: config/* Images.iconTicket */.rU.iconTicket,
        width: isMobileVersion ? 12 : 16,
        height: isMobileVersion ? 12 : 16,
        layout: "fixed",
        alt: "ticket entry"
      }, 1), categoryType !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && categoryType !== config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && categoryType !== config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && categoryType !== config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && categoryType !== config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && categoryType !== config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && categoryType !== config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && categoryType !== config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && categoryType !== config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && categoryType !== config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && categoryType !== config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && categoryType !== config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && categoryType !== config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && categoryType !== config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [UserInfoView_styles.infoText, {
          marginLeft: 4,
          marginRight: 10
        }, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 18
        } : {}],
        children: totalEventString
      }, 2)]
    }, 1)] : [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: UserInfoView_styles.rowContainer,
      children: [categoryType !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        source: config/* Images.iconTicket */.rU.iconTicket,
        width: isMobileVersion ? 12 : 16,
        height: isMobileVersion ? 12 : 16,
        layout: "fixed",
        alt: "ticket entry"
      }, 1), categoryType !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [UserInfoView_styles.infoText, {
          marginLeft: 4,
          marginRight: 10
        }],
        children: totalEventString
      }, 2)]
    }, 1)];
  };

  var infoViews = function infoViews() {
    var _props$item$tag_habit, _props$item$tag_habit2, _props$item$tag_habit3, _props$item$tag_habit4, _props$item$tag_categ, _props$item$tag_categ2, _props$item$tag_categ3, _props$item$tag_categ4, _props$item, _props$item2, _props$item3, _props$item3$tag_feat, _props$item3$tag_feat2, _props$item$tag_featu, _props$item$tag_featu2, _props$item$tag_featu3, _props$item$tag_featu4, _props$item4, _props$item4$tag_feat, _props$item4$tag_feat2, _props$item$tag_featu5, _props$item$tag_featu6, _props$item$tag_featu7, _props$item$tag_featu8, _props$item5, _props$item5$tag_feat, _props$item5$tag_feat2, _props$item$tag_featu9, _props$item$tag_featu10, _props$item$tag_featu11, _props$item$tag_featu12, _props$item6, _props$item6$tag_feat, _props$item6$tag_feat2, _props$item$tag_featu13, _props$item$tag_featu14, _props$item$tag_featu15, _props$item$tag_featu16, _props$item7, _props$item7$tag_cate, _props$item7$tag_cate2, _props$item8, _props$item8$tag_cate, _props$item8$tag_cate2, _props$item9, _props$item9$tag_cate, _props$item10, _props$item10$tag_cat, _props$item11, _props$item12, _props$item13, _props$item$company_h, _minBy, _minBy2, _props$item$company_h2, _props$item$tag_servi, _props$item$tag_servi2, _props$item$tag_servi3, _props$item$tag_servi4;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: isMobileVersion ? {} : UserInfoView_styles.rowContainer,
      children: [categoryType === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || categoryType === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || categoryType === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || categoryType === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || categoryType === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || categoryType === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || categoryType === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
        texts: [categoryType === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? ((_props$item$tag_habit = props.item.tag_habitat) === null || _props$item$tag_habit === void 0 ? void 0 : (_props$item$tag_habit2 = _props$item$tag_habit.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_habit2 === void 0 ? void 0 : _props$item$tag_habit2.join(", ")) + (((_props$item$tag_habit3 = props.item.tag_habitat) === null || _props$item$tag_habit3 === void 0 ? void 0 : _props$item$tag_habit3.length) > 2 ? " +" + (((_props$item$tag_habit4 = props.item.tag_habitat) === null || _props$item$tag_habit4 === void 0 ? void 0 : _props$item$tag_habit4.length) - 2) : "") || "-" : props.item.city || "-", categoryType === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? ((_props$item$tag_categ = props.item.tag_category) === null || _props$item$tag_categ === void 0 ? void 0 : (_props$item$tag_categ2 = _props$item$tag_categ.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_categ2 === void 0 ? void 0 : _props$item$tag_categ2.join(", ")) + (((_props$item$tag_categ3 = props.item.tag_category) === null || _props$item$tag_categ3 === void 0 ? void 0 : _props$item$tag_categ3.length) > 2 ? " +" + (((_props$item$tag_categ4 = props.item.tag_category) === null || _props$item$tag_categ4 === void 0 ? void 0 : _props$item$tag_categ4.length) - 2) : "") || "-" : categoryType === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? props.item.tag_category || "-" : categoryType === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? null : categoryType === // ? props.item.tag_category || "-"
        config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: {
            flexDirection: "row",
            alignItems: "center",
            marginTop: 2
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            width: 16,
            height: 16,
            layout: "fixed",
            source: config/* Images.iconTagStar */.rU.iconTagStar,
            style: UserInfoView_styles.icon,
            resizeMode: "contain",
            alt: "star"
          }, 1), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: {
              marginLeft: 4
            },
            children: ((_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.tag_star) || "-"
          })]
        }) : categoryType === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? props.item.tag_category || "-" : categoryType === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? props.item.tag_venue_2 || "-" : props.item.tag_venue_1 || "-", categoryType === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? null : categoryType === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? (_props$item2 = props.item) !== null && _props$item2 !== void 0 && _props$item2.tag_price ? null : // `From ${formatCurrency(
        //     formatNumber(props.item?.tag_price)
        //   )}`
        null : categoryType === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? ((_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : (_props$item3$tag_feat = _props$item3.tag_feature) === null || _props$item3$tag_feat === void 0 ? void 0 : (_props$item3$tag_feat2 = _props$item3$tag_feat.filter(function (i, index) {
          return index <= 0;
        })) === null || _props$item3$tag_feat2 === void 0 ? void 0 : _props$item3$tag_feat2.length) > 0 ? ((_props$item$tag_featu = props.item.tag_feature) === null || _props$item$tag_featu === void 0 ? void 0 : (_props$item$tag_featu2 = _props$item$tag_featu.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_featu2 === void 0 ? void 0 : _props$item$tag_featu2.join(", ")) + (((_props$item$tag_featu3 = props.item.tag_feature) === null || _props$item$tag_featu3 === void 0 ? void 0 : _props$item$tag_featu3.length) > 2 ? " +" + (((_props$item$tag_featu4 = props.item.tag_feature) === null || _props$item$tag_featu4 === void 0 ? void 0 : _props$item$tag_featu4.length) - 2) : "") || "-" : "-" : categoryType === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? null : // ? props.item.tag_area?.join(", ")
        categoryType === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? ((_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : (_props$item4$tag_feat = _props$item4.tag_feature) === null || _props$item4$tag_feat === void 0 ? void 0 : (_props$item4$tag_feat2 = _props$item4$tag_feat.filter(function (i, index) {
          return index <= 0;
        })) === null || _props$item4$tag_feat2 === void 0 ? void 0 : _props$item4$tag_feat2.length) > 0 ? ((_props$item$tag_featu5 = props.item.tag_feature) === null || _props$item$tag_featu5 === void 0 ? void 0 : (_props$item$tag_featu6 = _props$item$tag_featu5.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_featu6 === void 0 ? void 0 : _props$item$tag_featu6.join(", ")) + (((_props$item$tag_featu7 = props.item.tag_feature) === null || _props$item$tag_featu7 === void 0 ? void 0 : _props$item$tag_featu7.length) > 2 ? " +" + (((_props$item$tag_featu8 = props.item.tag_feature) === null || _props$item$tag_featu8 === void 0 ? void 0 : _props$item$tag_featu8.length) - 2) : "") || "-" : "-" : categoryType === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? !isMobileVersion ? ((_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : (_props$item5$tag_feat = _props$item5.tag_feature) === null || _props$item5$tag_feat === void 0 ? void 0 : (_props$item5$tag_feat2 = _props$item5$tag_feat.filter(function (i, index) {
          return index <= 0;
        })) === null || _props$item5$tag_feat2 === void 0 ? void 0 : _props$item5$tag_feat2.length) > 0 ? ((_props$item$tag_featu9 = props.item.tag_feature) === null || _props$item$tag_featu9 === void 0 ? void 0 : (_props$item$tag_featu10 = _props$item$tag_featu9.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_featu10 === void 0 ? void 0 : _props$item$tag_featu10.join(", ")) + (((_props$item$tag_featu11 = props.item.tag_feature) === null || _props$item$tag_featu11 === void 0 ? void 0 : _props$item$tag_featu11.length) > 2 ? " +" + (((_props$item$tag_featu12 = props.item.tag_feature) === null || _props$item$tag_featu12 === void 0 ? void 0 : _props$item$tag_featu12.length) - 2) : "") || "-" : "-" : null : ((_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : (_props$item6$tag_feat = _props$item6.tag_feature) === null || _props$item6$tag_feat === void 0 ? void 0 : (_props$item6$tag_feat2 = _props$item6$tag_feat.filter(function (i, index) {
          return index <= 0;
        })) === null || _props$item6$tag_feat2 === void 0 ? void 0 : _props$item6$tag_feat2.length) > 0 ? ((_props$item$tag_featu13 = props.item.tag_feature) === null || _props$item$tag_featu13 === void 0 ? void 0 : (_props$item$tag_featu14 = _props$item$tag_featu13.filter(function (i, index) {
          return index <= 1;
        })) === null || _props$item$tag_featu14 === void 0 ? void 0 : _props$item$tag_featu14.join(", ")) + (((_props$item$tag_featu15 = props.item.tag_feature) === null || _props$item$tag_featu15 === void 0 ? void 0 : _props$item$tag_featu15.length) > 2 ? " +" + (((_props$item$tag_featu16 = props.item.tag_feature) === null || _props$item$tag_featu16 === void 0 ? void 0 : _props$item$tag_featu16.length) - 2) : "") || "-" : "-"].filter(function (i) {
          return i !== null;
        }),
        style: {
          marginBottom: isMobileVersion && !isGuides ? 10 : 0
        },
        textStyle: {
          color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
          fontSize: isMobileVersion ? 10 : 14
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
          texts: [props.item.company_name || "-", ((_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : (_props$item7$tag_cate = _props$item7.tag_category) === null || _props$item7$tag_cate === void 0 ? void 0 : (_props$item7$tag_cate2 = _props$item7$tag_cate.filter(function (i, index) {
            return index <= 0;
          })) === null || _props$item7$tag_cate2 === void 0 ? void 0 : _props$item7$tag_cate2.length) > 0 ? ((_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : (_props$item8$tag_cate = _props$item8.tag_category) === null || _props$item8$tag_cate === void 0 ? void 0 : (_props$item8$tag_cate2 = _props$item8$tag_cate.filter(function (i, index) {
            return index <= 0;
          })) === null || _props$item8$tag_cate2 === void 0 ? void 0 : _props$item8$tag_cate2.join(", ")) + (((_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : (_props$item9$tag_cate = _props$item9.tag_category) === null || _props$item9$tag_cate === void 0 ? void 0 : _props$item9$tag_cate.length) > 1 ? " +" + (((_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : (_props$item10$tag_cat = _props$item10.tag_category) === null || _props$item10$tag_cat === void 0 ? void 0 : _props$item10$tag_cat.length) - 1) : "") || "-" : "-", (_props$item11 = props.item) !== null && _props$item11 !== void 0 && _props$item11.tag_price ? "From ".concat((0,formatHelpers/* formatCurrency */.xG)((0,helpers/* formatNumber */.uf)((_props$item12 = props.item) === null || _props$item12 === void 0 ? void 0 : _props$item12.tag_price))) : null, "Min ".concat((0,helpers/* formatNumber */.uf)((_props$item13 = props.item) === null || _props$item13 === void 0 ? void 0 : _props$item13.tag_size), " sqft")].filter(function (i) {
            return i !== null;
          }),
          style: {
            marginBottom: isMobileVersion && !isGuides ? 10 : 0
          },
          textStyle: {
            color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
            fontSize: isMobileVersion ? 10 : 14
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: categoryType === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
            texts: [props.item.city || "-", "".concat((_props$item$company_h = props.item.company_homes) === null || _props$item$company_h === void 0 ? void 0 : _props$item$company_h.length, " Homes"), (_minBy = (0,lodash.minBy)(props.item.company_homes, "minPrice")) !== null && _minBy !== void 0 && _minBy.minPrice ? "From ".concat((0,formatHelpers/* formatCurrency */.xG)((0,helpers/* formatNumber */.uf)((_minBy2 = (0,lodash.minBy)(props.item.company_homes, "minPrice")) === null || _minBy2 === void 0 ? void 0 : _minBy2.minPrice))) : null].filter(function (i) {
              return i !== null;
            }),
            style: {
              marginBottom: isMobileVersion && !isGuides ? 10 : 0
            },
            textStyle: {
              color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
              fontSize: isMobileVersion ? 10 : 14
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: categoryType === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
              texts: [props.item.city || "-", "Venue Cocktail".split(",").find(function (i) {
                return i === "Animals";
              }) ? "".concat((_props$item$company_h2 = props.item.company_homes) === null || _props$item$company_h2 === void 0 ? void 0 : _props$item$company_h2.length, " Animals") : null, props.item.tag_price ? null : //  `From ${formatCurrency(
              //     formatNumber(props.item.tag_price)
              //   )}`
              null, props.item.tag_species_animal ? "Animals ".concat((0,formatHelpers/* formatTagRange */.cN)(config/* Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */.gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES, props.item.tag_species_animal)) : null].filter(function (i) {
                return i !== null;
              }),
              style: {
                marginBottom: isMobileVersion && !isGuides ? 10 : 0
              },
              textStyle: {
                color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
                fontSize: isMobileVersion ? 10 : 14
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: categoryType === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
                texts: [genreString,
                /*#__PURE__*/
                // locationString,
                (0,jsx_runtime.jsxs)((View_default()), {
                  style: UserInfoView_styles.rowContainer,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconTicket */.rU.iconTicket,
                    width: 16,
                    height: 16,
                    layout: "fixed",
                    alt: "ticket entry"
                  }, 1), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                    style: [UserInfoView_styles.infoText, {
                      marginLeft: 4,
                      marginRight: 10
                    }],
                    children: totalEventString
                  }, 2)]
                })].filter(function (i) {
                  return i !== null;
                }),
                style: {
                  marginBottom: isMobileVersion && !isGuides ? 10 : 0
                },
                textStyle: {
                  color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
                  fontSize: isMobileVersion ? 10 : 14
                }
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
                texts: [props.item.city || "-", props.item.tag_venue_2 || "-", isGuides ? null : ((_props$item$tag_servi = props.item.tag_service) === null || _props$item$tag_servi === void 0 ? void 0 : (_props$item$tag_servi2 = _props$item$tag_servi.filter(function (i, index) {
                  return index <= 1;
                })) === null || _props$item$tag_servi2 === void 0 ? void 0 : _props$item$tag_servi2.join(", ")) + (((_props$item$tag_servi3 = props.item.tag_service) === null || _props$item$tag_servi3 === void 0 ? void 0 : _props$item$tag_servi3.length) > 2 ? " +" + (((_props$item$tag_servi4 = props.item.tag_service) === null || _props$item$tag_servi4 === void 0 ? void 0 : _props$item$tag_servi4.length) - 2) : "") || "-"].filter(function (i) {
                  return i !== null;
                }),
                style: {
                  marginBottom: isMobileVersion && !isGuides ? 10 : 0
                },
                textStyle: {
                  color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
                  fontSize: isMobileVersion ? 10 : 14
                }
              })
            })
          })
        })
      }), categoryType === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [UserInfoView_styles.rowContainer, {
          marginLeft: isMobileVersion ? 0 : 10
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DotSplitedViews/* default */.Z, {
          views: renderViews()
        })
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [UserInfoView_styles.infoContainer, {
      marginLeft: 10
    }],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [UserInfoView_styles.rowContainer, {
        marginBottom: isGuides && isMobileVersion ? 0 : 11,
        marginRight: 24,
        justifyContent: "space-between",
        alignItems: "center"
      }],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [UserInfoView_styles.rowContainer, {
          flex: 1
        }],
        onMouseOver: function onMouseOver() {
          return setShowPopupOfficial(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setShowPopupOfficial(false);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          ellipsizeMode: "tail",
          numberOfLines: 1,
          style: [UserInfoView_styles.title, isMobileVersion ? {
            fontSize: 12,
            lineHeight: 18
          } : {}, {
            marginBottom: 0,
            marginRight: 10
          }, isGuides && !isMobileVersion ? {
            fontSize: 20,
            lineHeight: 30
          } : {}],
          children: isGuides || isHeading ? /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: displayName || nickname
          }) : displayName || nickname
        }), (isOfficial === 1 || isPro === 1) && !withoutBadge && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: {
            marginLeft: 6,
            marginTop: 0,
            position: "relative"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconVerifiedBadge */.rU.iconVerifiedBadge,
            alt: "badge official",
            width: 14,
            height: 14,
            layout: "fixed"
          }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: {
              position: "absolute",
              width: isMobileVersion ? 260 : 336,
              height: isMobileVersion ? 140 : 182,
              zIndex: 999,
              left: 0,
              top: lastIndex ? -110 : firstIndex ? -20 : -91,
              paddingLeft: 24
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
              style: {
                backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingHorizontal: 22,
                borderRadius: 18,
                width: "100%",
                height: "100%",
                boxShadow: "2px 2px 10px rgba(0,0,0,0.5)"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconVerifiedBadgeMedium */.rU.iconVerifiedBadgeMedium,
                alt: "verified account",
                width: isMobileVersion ? 24 : 35,
                height: isMobileVersion ? 24 : 35,
                layout: "fixed"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: {
                  fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
                  fontSize: isMobileVersion ? 16 : 20,
                  lineHeight: isMobileVersion ? 20 : 24,
                  color: config/* Colors.white */.wL.white,
                  marginVertical: isMobileVersion ? 9 : 14,
                  textAlign: "center"
                },
                children: "Official Account"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
                style: {
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                  fontSize: isMobileVersion ? 12 : 16,
                  lineHeight: isMobileVersion ? 16 : 18,
                  color: config/* Colors.white80 */.wL.white80,
                  textAlign: "center"
                },
                children: ["This is an official account verified by", " ", "Cocktayl"]
              })]
            })
          })]
        }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: lastIndex ? {
            position: "absolute",
            width: isMobileVersion ? 260 : 336,
            height: isMobileVersion ? 140 + 24 : 182 + 24,
            zIndex: 999,
            left: -100,
            bottom: 0,
            paddingBottom: 24
          } : {
            position: "absolute",
            width: isMobileVersion ? 260 : 336,
            height: isMobileVersion ? 140 + 24 : 182 + 24,
            zIndex: 999,
            left: -100,
            top: 0,
            paddingTop: 24
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: (_ref = {
              backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
              width: isMobileVersion ? 260 : 336,
              height: isMobileVersion ? 140 : 182,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 22,
              borderRadius: 18
            }, (0,defineProperty/* default */.Z)(_ref, "width", "100%"), (0,defineProperty/* default */.Z)(_ref, "height", "100%"), (0,defineProperty/* default */.Z)(_ref, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              source: config/* Images.iconVerifiedBadgeMedium */.rU.iconVerifiedBadgeMedium,
              alt: "verified account",
              width: isMobileVersion ? 24 : 35,
              height: isMobileVersion ? 24 : 35,
              layout: "fixed"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: {
                fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
                fontSize: isMobileVersion ? 16 : 20,
                lineHeight: isMobileVersion ? 20 : 24,
                color: config/* Colors.white */.wL.white,
                marginVertical: isMobileVersion ? 9 : 14,
                textAlign: "center"
              },
              children: "Official Account"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: {
                fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                fontSize: isMobileVersion ? 12 : 16,
                lineHeight: isMobileVersion ? 16 : 18,
                color: config/* Colors.white80 */.wL.white80,
                textAlign: "center"
              },
              children: ["This is an official account verified by", " ", "Cocktayl"]
            })]
          })
        })]
      }), dist !== null && dist !== undefined && dist !== 'undefined' && !isMobileVersion && !isGuides && categoryType !== config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [UserInfoView_styles.title, {
          color: (0,formatHelpers/* getClass */.ll)("text-white50")
        }],
        children: "".concat(dist === null || dist === void 0 ? void 0 : dist.toFixed(1), " km")
      }), isGuides && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        children: infoViews()
      })]
    }), isGuides && !isMobileVersion ? null : infoViews(), dist !== null && dist !== undefined && dist !== 'undefined' && isMobileVersion && !isGuides && categoryType !== config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: {
        color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
        fontSize: isMobileVersion ? 10 : 14,
        lineHeight: 18,
        fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
        textAlign: "left"
      },
      children: "".concat(dist === null || dist === void 0 ? void 0 : dist.toFixed(1), " km")
    }), isGuides && description !== null && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* ReadMoreText */.XI, {
      text: description,
      isMobileVersion: isMobileVersion,
      withoutButton: true,
      isDisplayPreview: true,
      minVisibleLines: isMobileVersion ? 1.5 : 4,
      maxLength: 200,
      style: {
        paddingHorizontal: 0,
        marginRight: 24
      }
    })]
  });
};

var UserInfoView_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch"
  },
  icon: {
    width: 12,
    height: 12
  },
  infoText: {
    fontSize: 14,
    lineHeight: 14,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: (0,formatHelpers/* getClass */.ll)("text-darkGray")
  },
  infoContainer: {
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    paddingHorizontal: 10 // overflow: "hidden",

  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  title: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    marginBottom: 11,
    alignSelf: "stretch",
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    marginRight: 24
  }
});
/* harmony default export */ var components_UserInfoView = (UserInfoView);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/SectionView/index.js
var SectionView = __webpack_require__(27199);
;// CONCATENATED MODULE: ./src/components/molecules/CardList/components/LandscapeCardItem.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var DateView = function DateView(props) {
  var date = props.date,
      isMobileVersion = props.isMobileVersion;

  var getWeekDayMonth = function getWeekDayMonth(_date) {
    var dateString = (0,helpers/* formatDate */.p6)(_date, config/* Constants.dateFormat.DATE_FORMAT_SIMPLE */.gT.dateFormat.DATE_FORMAT_SIMPLE);
    if (!dateString) return {
      week: "",
      day: "",
      month: ""
    };
    var dateStringArray = dateString.split(" ");
    if (dateStringArray.length != 3) return {
      week: "",
      day: "",
      month: ""
    };
    return {
      week: dateStringArray[0].toUpperCase(),
      day: dateStringArray[1],
      month: dateStringArray[2].toUpperCase()
    };
  };

  var _getWeekDayMonth = getWeekDayMonth(date),
      week = _getWeekDayMonth.week,
      day = _getWeekDayMonth.day,
      month = _getWeekDayMonth.month;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [LandscapeCardItem_styles.dateContainer, isMobileVersion ? {
      width: 30
    } : {}],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: [LandscapeCardItem_styles.dateMonthText, isMobileVersion ? {
        fontSize: 8,
        lineHeight: 12
      } : {}],
      children: week
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: [LandscapeCardItem_styles.dateDayText, isMobileVersion ? {
        fontSize: 10,
        lineHeight: 12,
        marginVertical: 4
      } : {}],
      children: day
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: [LandscapeCardItem_styles.dateMonthText, isMobileVersion ? {
        fontSize: 8,
        lineHeight: 12
      } : {}],
      children: month
    })]
  });
};

var InfoView = function InfoView(props) {
  var _ref;

  var isMobileVersion = props.isMobileVersion,
      isPlaylistMode = props.isPlaylistMode,
      isChartsMode = props.isChartsMode,
      lastIndex = props.lastIndex,
      firstIndex = props.firstIndex,
      isGuides = props.isGuides,
      isHeading = props.isHeading,
      withoutBadge = props.withoutBadge;
  var _props$item = props.item,
      title = _props$item.title,
      startDate = _props$item.startDate,
      endDate = _props$item.endDate,
      streetLocation = _props$item.streetLocation,
      location = _props$item.location,
      city = _props$item.city,
      nationality = _props$item.nationality,
      price = _props$item.price,
      lineup = _props$item.lineup,
      totalConnection = _props$item.totalConnection,
      totalRelatedConnection = _props$item.totalRelatedConnection,
      totalFollower = _props$item.totalFollower,
      totalGoing = _props$item.totalGoing,
      totalSaved = _props$item.totalSaved,
      totalLineup = _props$item.totalLineup,
      isOfficial = _props$item.isOfficial,
      isPro = _props$item.isPro,
      description = _props$item.description,
      dist = _props$item.dist;

  var _useState = (0,react.useState)(false),
      showPopupOfficial = _useState[0],
      setShowPopupOfficial = _useState[1];

  var time = (0,formatHelpers/* diffFormat */.Jf)(startDate, endDate);

  var renderViews = function renderViews() {
    return isMobileVersion ? [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [LandscapeCardItem_styles.rowContainer],
      children: [dist !== null && dist !== undefined && dist !== 'undefined' && !isGuides && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          color: (0,formatHelpers/* getClass */.ll)("text-darkGray"),
          fontSize: isMobileVersion ? 10 : 14,
          lineHeight: 18,
          fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
          textAlign: "left",
          marginRight: 6
        },
        children: "".concat(dist === null || dist === void 0 ? void 0 : dist.toFixed(1), " km")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: LandscapeCardItem_styles.rowContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
          width: isMobileVersion ? 14 : 18,
          height: isMobileVersion ? 14 : 18,
          layout: "fixed",
          alt: "lineup artists"
        }, 1), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LandscapeCardItem_styles.infoText, {
            marginLeft: 4
          }, isMobileVersion ? {
            fontSize: 10
          } : {}],
          children: (0,formatHelpers/* formatNumber */.uf)(totalLineup || (lineup === null || lineup === void 0 ? void 0 : lineup.totalLineup) || 0)
        }, 2)]
      })]
    })] : [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [LandscapeCardItem_styles.rowContainer],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [LandscapeCardItem_styles.rowContainer, {
          marginLeft: 10
        }],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
          width: 18,
          height: 18,
          layout: "fixed",
          alt: "lineup artists"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LandscapeCardItem_styles.infoText, {
            marginLeft: 4
          }],
          children: (0,formatHelpers/* formatNumber */.uf)(totalLineup || (lineup === null || lineup === void 0 ? void 0 : lineup.totalLineup) || 0)
        })]
      })
    })];
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [LandscapeCardItem_styles.infoContainer, {
      marginLeft: isMobileVersion ? 4 : 20
    }],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [{
        marginBottom: isGuides && isMobileVersion ? 0 : 10,
        marginRight: 24,
        justifyContent: "space-between",
        alignItems: "center"
      }, isGuides && isMobileVersion ? {
        alignItems: "flex-start"
      } : LandscapeCardItem_styles.rowContainer],
      onMouseOver: function onMouseOver() {
        return setShowPopupOfficial(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setShowPopupOfficial(false);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        ellipsizeMode: "tail",
        numberOfLines: 1,
        style: [LandscapeCardItem_styles.title, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 16
        } : {}, isPlaylistMode || isChartsMode ? {
          marginRight: 60,
          maxWidth: "75%"
        } : {}, {
          marginBottom: 0,
          marginRight: 0
        }],
        children: isGuides || isHeading ? /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: title
        }) : title
      }), (isOfficial === 1 || isPro === 1) && !withoutBadge && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          marginLeft: 6,
          marginTop: 0,
          position: "relative"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconVerifiedBadge */.rU.iconVerifiedBadge,
          alt: "badge official",
          width: 14,
          height: 14,
          layout: "fixed"
        }), showPopupOfficial && (isOfficial === 1 || isPro === 1) && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            position: "absolute",
            width: isMobileVersion ? 260 + 24 : 336 + 24,
            height: isMobileVersion ? 140 : 182,
            zIndex: 999,
            left: 0,
            top: firstIndex ? -20 : lastIndex ? -110 : -91,
            paddingLeft: 24
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: (_ref = {
              backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
              width: isMobileVersion ? 260 : 336,
              height: isMobileVersion ? 140 : 182,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 22,
              borderRadius: 18
            }, (0,defineProperty/* default */.Z)(_ref, "width", "100%"), (0,defineProperty/* default */.Z)(_ref, "height", "100%"), (0,defineProperty/* default */.Z)(_ref, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              source: config/* Images.iconVerifiedBadgeMedium */.rU.iconVerifiedBadgeMedium,
              alt: "verified account",
              width: isMobileVersion ? 24 : 35,
              height: isMobileVersion ? 24 : 35,
              layout: "fixed"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: {
                fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
                fontSize: isMobileVersion ? 16 : 20,
                lineHeight: isMobileVersion ? 20 : 24,
                color: config/* Colors.white */.wL.white,
                marginVertical: isMobileVersion ? 9 : 14,
                textAlign: "center"
              },
              children: "Official Account"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: {
                fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                fontSize: isMobileVersion ? 12 : 16,
                lineHeight: isMobileVersion ? 16 : 18,
                color: config/* Colors.white80 */.wL.white80,
                textAlign: "center"
              },
              children: ["This is an official account verified by", " ", "Cocktayl"]
            })]
          })
        })]
      }), dist !== null && dist !== undefined && dist !== 'undefined' && !isMobileVersion && !isGuides && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [LandscapeCardItem_styles.title, {
          color: (0,formatHelpers/* getClass */.ll)("text-white50")
        }],
        children: "".concat(dist === null || dist === void 0 ? void 0 : dist.toFixed(1), " km")
      }), isGuides && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: LandscapeCardItem_styles.rowContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
          texts: [time, (streetLocation || city || location) + (nationality ? ", " + nationality : "")],
          style: {
            marginBottom: 0
          },
          textStyle: {
            color: config/* Colors.darkGray */.wL.darkGray,
            fontSize: isMobileVersion ? 9 : 14
          },
          isMobileVersion: isMobileVersion
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DotSplitedViews/* default */.Z, {
          views: renderViews(),
          style: isMobileVersion ? {
            marginLeft: 6,
            marginTop: 0
          } : {
            marginLeft: 0
          },
          isMobileVersion: isMobileVersion
        })]
      })]
    }), !isGuides && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: isMobileVersion ? {} : LandscapeCardItem_styles.rowContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
        texts: [time, (streetLocation || city || location) + (nationality ? ", " + nationality : "")],
        style: {
          marginBottom: 0
        },
        textStyle: {
          color: config/* Colors.darkGray */.wL.darkGray,
          fontSize: isMobileVersion ? 9 : 14
        },
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DotSplitedViews/* default */.Z, {
        views: renderViews(),
        style: isMobileVersion ? {
          marginLeft: 0,
          marginTop: 10
        } : {
          marginLeft: 0
        },
        isMobileVersion: isMobileVersion
      })]
    }), isGuides && description !== null && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* ReadMoreText */.XI, {
      text: description,
      isMobileVersion: isMobileVersion,
      withoutButton: true,
      isDisplayPreview: true // withoutHTML={isGuides}
      ,
      minVisibleLines: isMobileVersion ? 1.5 : 4,
      maxLength: 200,
      style: {
        paddingHorizontal: 0,
        marginRight: 24
      }
    })]
  });
};

var LandscapeCardItem = function LandscapeCardItem(props) {
  var _props$item2, _props$item3, _props$item4, _props$item5;

  var general = props.general,
      marginBottom = props.marginBottom,
      isMobileVersion = props.isMobileVersion,
      isPlaylistMode = props.isPlaylistMode,
      isChartsMode = props.isChartsMode,
      isGuides = props.isGuides,
      isHeading = props.isHeading,
      chartIndex = props.chartIndex,
      firstIndex = props.firstIndex,
      lastIndex = props.lastIndex,
      withoutBadge = props.withoutBadge;
  var item = props.item,
      category = props.category,
      showYear = props.showYear;
  var avatar = item.avatar,
      lineup = item.lineup,
      totalLineup = item.totalLineup;

  var renderYear = function renderYear() {
    if (showYear) {
      var yearString = (0,helpers/* formatDate */.p6)(item.startDate, "YYYY");
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SectionView/* default */.Z, {
        section: {
          title: yearString
        },
        isMobileVersion: isMobileVersion
      });
    }

    return null;
  };

  var renderInfoView = function renderInfoView() {
    if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST || category === config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS || category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_UserInfoView, {
        categoryType: category,
        item: item,
        isMobileVersion: isMobileVersion,
        firstIndex: firstIndex,
        lastIndex: lastIndex,
        isGuides: isGuides,
        isHeading: isHeading,
        withoutBadge: withoutBadge
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(InfoView, {
      style: {
        flex: 1
      },
      item: item,
      isMobileVersion: isMobileVersion,
      isPlaylistMode: isPlaylistMode,
      isChartsMode: isChartsMode,
      firstIndex: firstIndex,
      lastIndex: lastIndex,
      isGuides: isGuides,
      isHeading: isHeading,
      withoutBadge: withoutBadge
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: {
      alignSelf: "stretch"
    },
    children: [renderYear(), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [LandscapeCardItem_styles.container, isMobileVersion ? {
        borderRadius: 0,
        marginBottom: 7
      } : {}, showYear && {
        marginBottom: 0
      }, {
        marginBottom: marginBottom !== null ? marginBottom : 12
      }, isGuides && !isMobileVersion ? {
        height:  false ? 0 : 170
      } : {}] // onPress={() => {
      //   onItemAction({
      //     type: Constants.actionType.ACTION_VIEW,
      //     item: props.item,
      //   });
      // }}
      ,
      children: [category !== config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && category !== config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS && category !== config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER && category !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && category !== config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && category !== config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && category !== config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && category !== config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && category !== config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && category !== config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && category !== config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && category !== config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && category !== config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && category !== config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && category !== config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && category !== config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && category !== config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && /*#__PURE__*/(0,jsx_runtime.jsx)(DateView, {
        date: item.startDate,
        isMobileVersion: isMobileVersion
      }), category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER || category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [LandscapeCardItem_styles.imageContainer, isMobileVersion ? {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0
        } : {}],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          imgUrl: avatar || (category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER ? "Local:defaultOther" : "Local:defaultArtist"),
          width: 100,
          height: 100,
          layout: "fixed",
          alt: "Avatar ".concat(props === null || props === void 0 ? void 0 : (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.displayName)
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [LandscapeCardItem_styles.imageContainer, category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT || isMobileVersion ? {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0
        } : {}, isGuides && !isMobileVersion ? {
          width: category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? 170 : 250,
          height: 170
        } : {}],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          imgUrl: avatar ? avatar : category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? "Local:defaultArtist" : category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "Local:defaultFestival" : category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? "Local:defaultEvent" : category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? "Local:defaultVenue" : category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? "Local:defaultGeneral" //TODO (Garry): Need change to rooftop icon
          : category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? "Local:defaultGeneral" //TODO (Garry): Need change to spa icon
          : category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Local:defaultGeneral" //TODO (Garry): Need change to venue beachful icon
          : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Local:defaultGeneral" //TODO (Garry): Need change to prefab company icon
          : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? "Local:defaultGeneral" //TODO (Garry): Need change to prefab home icon
          : category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? "Local:defaultGeneral" //TODO (Garry): Need change to zoo icon
          : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? "Local:defaultGeneral" //TODO (Garry): Need change to animal icon
          : category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "Local:defaultGeneral" //TODO (Garry): Need change to parkful icon
          : category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? "Local:defaultGeneral" //TODO (Garry): Need change to casino icon
          : category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? "Local:defaultGeneral" //TODO (Garry): Need change to castle icon
          : category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? "Local:defaultGeneral" //TODO (Garry): Need change to resort icon
          : category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? "Local:defaultGeneral" //TODO (Garry): Need change to aparthotel icon
          : category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Local:defaultGeneral" //TODO (Garry): Need change to venue cocktail icon
          : "Local:defaultOther",
          style: LandscapeCardItem_styles.imageView,
          resizeMode: "cover",
          width: isGuides && !isMobileVersion ? category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? 170 : 250 : 100,
          height: isGuides && !isMobileVersion ? 170 : 100,
          layout: "fixed",
          alt: category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "".concat(props === null || props === void 0 ? void 0 : (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.displayName, " Logo") : "".concat(props === null || props === void 0 ? void 0 : (_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.startDate).format("YYYY"), " Logo")
        })
      }), renderInfoView(), isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [LandscapeCardItem_styles.infoBox, isMobileVersion ? {
          width: 40,
          height: 16,
          top: 12,
          right: 16
        } : {}],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1",
          style: {
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LandscapeCardItem_styles.infoBoxText, {
            marginLeft: 0
          }, isMobileVersion ? {
            fontSize: 10,
            lineHeight: 10
          } : {}],
          children: chartIndex + 1
        })]
      })]
    })]
  });
};

var LandscapeCardItem_styles = StyleSheet_default().create({
  container: _objectSpread(_objectSpread({
    height: 100,
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-tab-gray1")
  }, (0,formatHelpers/* getClass */.ll)("border-card-landscape")), {}, {
    alignSelf: "stretch",
    flexDirection: "row",
    marginBottom: 12,
    borderRadius: 16 // overflow: "hidden",

  }),
  dateContainer: {
    marginHorizontal: 5,
    width: 56,
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center"
  },
  dateMonthText: {
    fontSize: 12,
    lineHeight: 12,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.white40 */.wL.white40
  },
  dateDayText: {
    fontSize: 14,
    lineHeight: 15,
    textAlign: "center",
    marginVertical: 10,
    color: config/* Colors.white */.wL.white
  },
  imageContainer: {
    width: 100,
    height: 100,
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,
    overflow: "hidden"
  },
  imageView: {
    width: "100%",
    height: "100%"
  },
  infoContainer: {
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    paddingHorizontal: 10 // overflow: "hidden",

  },
  title: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 18,
    lineHeight: 22,
    marginBottom: 11,
    alignSelf: "stretch",
    color: config/* Colors.white */.wL.white,
    marginRight: 36,
    textAlign: "left"
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  icon: {
    width: 12,
    height: 12
  },
  infoText: {
    fontSize: 14,
    lineHeight: 14,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.darkGray */.wL.darkGray
  },
  yearText: {
    fontSize: 18,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white
  },
  infoBox: {
    position: "absolute",
    right: 56,
    top: 34,
    width: 100,
    height: 32,
    borderRadius: 60,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row"
  },
  infoBoxText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    position: "relative",
    zIndex: 10,
    marginLeft: 8
  },
  plusButton: {
    position: "absolute",
    right: 16,
    top: 12,
    width: 24,
    height: 24
  },
  plusIcon: {
    width: 7.68,
    height: 7.68
  }
});
/* harmony default export */ var components_LandscapeCardItem = (LandscapeCardItem);
;// CONCATENATED MODULE: ./src/components/molecules/CardList/components/CardItem.js


function CardItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var CardItem = function CardItem(props) {
  if (props.portrait) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_PortraitCardItem, CardItem_objectSpread({}, props));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_LandscapeCardItem, CardItem_objectSpread({}, props));
};

/* harmony default export */ var components_CardItem = (CardItem);

/***/ }),

/***/ 27199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);










var SectionView = function SectionView(props) {
  var isMobileVersion = props.isMobileVersion;
  var _props$section = props.section,
      title = _props$section.title,
      suffix = _props$section.suffix;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3___default()), {
    style: {
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      height: isMobileVersion ? 24 : 40,
      paddingLeft: 1,
      paddingRight: 1,
      borderRadius: 20,
      overflow: "hidden",
      marginBottom: isMobileVersion ? 16 : 30,
      marginTop: isMobileVersion ? 16 : 16
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1",
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        justifyContent: "center",
        alignItems: "center"
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3___default()), {
      style: {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        height: isMobileVersion ? 22 : 38,
        paddingLeft: 29,
        paddingRight: 29,
        borderRadius: 20,
        backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.black */ .wL.black,
        overflow: "hidden"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_4___default()), {
        style: {
          fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
          fontSize: isMobileVersion ? 12 : 18,
          lineHeight: isMobileVersion ? 12 : 32,
          color: "white",
          marginBottom: 32,
          marginTop: 32
        },
        children: title
      }), suffix != undefined && suffix != null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_4___default()), {
        style: {
          fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
          fontSize: isMobileVersion ? 12 : 18,
          lineHeight: isMobileVersion ? 12 : 32,
          color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.grayText2 */ .wL.grayText2,
          marginBottom: 32,
          marginTop: 32,
          marginLeft: 10
        },
        children: suffix
      })]
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_5___default().create({
  container: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "center",
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.black */ .wL.black
  },
  text: {
    fontSize: 18,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    lineHeight: 32,
    marginVertical: 32
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (SectionView);

/***/ }),

/***/ 41540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77058);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52738);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85112);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);













var LineupCountView = function LineupCountView(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var avatarSize = props.avatarSize;

  var _avatarSize = avatarSize || 16;

  var lineup = props.lineup;
  var headlinerCount = "";

  if (lineup && lineup.headlinerCount) {
    headlinerCount = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(lineup.headlinerCount);
  }

  var renderAvatar = function renderAvatar(avatar, index) {
    var avatarUrl = avatar.avatar;

    if (index == 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CAvatar */ .cU, {
        url: avatarUrl,
        size: _avatarSize
      }, index + "avatar");
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CAvatar */ .cU, {
      url: avatarUrl,
      size: _avatarSize,
      style: {
        marginLeft: -(_avatarSize / 2)
      }
    }, index + "avatar");
  };

  var renderAvatars = function renderAvatars(avatars) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: [styles.rowContainer],
      children: avatars.slice(0).reverse().map(function (avatar, index) {
        return renderAvatar(avatar, index);
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
    style: [styles.rowContainer, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: [styles.description, props.textStyle, {
        color: "#939393"
      }],
      children: headlinerCount
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: [styles.description, props.textStyle],
      children: t("key_lineup_headliners")
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  popularityIcon: {
    width: 16,
    height: 16,
    resizeMode: "contain"
  },
  popularityIconText: {
    fontSize: 15,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryMedium */ .F3.primaryMedium,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.grayText2 */ .wL.grayText2
  },
  rowContainer: {
    flexDirection: "row"
  },
  description: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: "white",
    marginLeft: 0
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (LineupCountView);

/***/ }),

/***/ 94843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77058);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_Modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17666);
/* harmony import */ var react_native_web_dist_cjs_exports_Modal__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Modal__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52738);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);















var MenuItem = function MenuItem(props) {
  var _props$item$title;

  var isMobileVersion = props.isMobileVersion;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5___default()), {
    style: styles.menuItemContainer,
    onPress: function onPress() {
      return props.onPressItem(props.item);
    },
    children: [props.item.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
      width: props.item.title === "Insights" ? 18 : 16,
      height: props.item.title === "Insights" ? 18 : 16,
      layout: "fixed",
      source: props.item.icon,
      style: styles.icon,
      alt: (_props$item$title = props.item.title) === null || _props$item$title === void 0 ? void 0 : _props$item$title.toLowerCase()
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: [styles.menuItemText, isMobileVersion ? {
        fontSize: 12,
        lineHeight: 12
      } : {}],
      children: props.item.title
    }), props.item.suffix && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: [styles.menuItemSuffixText, isMobileVersion ? {
        fontSize: 12,
        lineHeight: 12
      } : {}],
      children: props.item.suffix
    })]
  });
};

var PopupMenuListModal = function PopupMenuListModal(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onPressItem = function onPressItem(item) {
    if (props.onPressItem) {
      props.onPressItem(item);
    }
  };

  var renderItems = function renderItems() {
    if (!props.items) return [];
    return props.items.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MenuItem, {
        item: item,
        onPressItem: onPressItem,
        isMobileVersion: isMobileVersion
      }, index + "item");
    });
  };

  var onClose = function onClose() {
    if (props.onClose) {
      document.body.style.overflow = "auto";
      props.onClose();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (props.isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [props.isVisible]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
    style: [props.style],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Modal__WEBPACK_IMPORTED_MODULE_9___default()), {
      transparent: true,
      visible: props.isVisible,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: styles.dim,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
          style: [styles.modalContainer, isMobileVersion ? {
            width: "90%"
          } : {}],
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
            style: styles.bodyContainer,
            children: renderItems()
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
            style: [styles.bottomContainer, isMobileVersion ? {
              height: 72
            } : {}],
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* .IconizedButton */ .YJ, {
              buttonTitle: t("key_close"),
              onPress: function onPress() {
                onClose();
              },
              fontSize: isMobileVersion ? 12 : 16,
              style: [styles.buttonStyle, isMobileVersion ? {
                height: 32
              } : {}],
              filled: true,
              filledColor:  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 : null,
              filledTextColor:  false ? 0 : null
            })
          })]
        })
      })
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default().create({
  dim: {
    backgroundColor: "rgba(89, 89, 89, 0.45)",
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  },
  modalContainer: {
    margin: 32,
    position: "absolute",
    flex: 1,
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("background"),
    borderWidth: 0,
    justifyContent: "center",
    borderRadius: 25,
    maxWidth: 480,
    width: "100%",
    zIndex: 500
  },
  bodyContainer: {
    flex: 1
  },
  bottomContainer: {
    height: 90,
    alignSelf: "stretch"
  },
  title: {
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.gray */ .wL.gray,
    fontSize: _config__WEBPACK_IMPORTED_MODULE_1__/* .Values.fontSize.medium */ .$m.fontSize.medium,
    marginTop: 8,
    marginBottom: 8
  },
  check: {
    width: 16,
    height: 16,
    marginStart: 10,
    marginEnd: 10
  },
  closeButton: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 50,
    alignSelf: "center"
  },
  menuItemContainer: {
    paddingLeft: 30,
    height: 60,
    borderBottomColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("border-tabBottomColor"),
    borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center"
  },
  icon: {
    height: 16,
    width: 16,
    resizeMode: "contain",
    marginRight: 6
  },
  menuItemText: {
    marginLeft: 15,
    fontSize: 16,
    lineHeight: 20,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-white")
  },
  menuItemSuffixText: {
    fontSize: 16,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-white70"),
    marginLeft: 6
  },
  buttonStyle: {
    height: 50,
    margin: 20
  }
});
/* harmony default export */ __webpack_exports__["default"] = (PopupMenuListModal);

/***/ }),

/***/ 52755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TagItem; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableWithoutFeedback/index.js
var TouchableWithoutFeedback = __webpack_require__(15248);
var TouchableWithoutFeedback_default = /*#__PURE__*/__webpack_require__.n(TouchableWithoutFeedback);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/components/AvatarTagItem.js











var AvatarTagItem = function AvatarTagItem(props) {
  var item = props.item,
      isMobileVersion = props.isMobileVersion;

  var onPressItem = function onPressItem(item) {
    if (props.onPressItem) {
      props.onPressItem(item);
    }
  };

  if (!item) return null;
  var avatar = item.avatar,
      name = item.name,
      isHeadliner = item.isHeadliner;
  var title = name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableWithoutFeedback_default()), {
    onPress: function onPress() {
      onPressItem(item);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [styles.tagItemContainer, isMobileVersion ? {
        height: 24
      } : {}],
      children: [isHeadliner && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1",
        style: {
          position: "absolute",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          zIndex: -1
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [styles.iconContainerStyle, isMobileVersion ? {
          width: 22,
          height: 22
        } : {}],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          imgUrl: avatar,
          style: {
            width: "100%",
            height: "100%"
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        numberOfLines: 1,
        ellipsizeMode: "tail",
        style: [isHeadliner ? styles.selectedTagItemText : styles.tagItemText, isMobileVersion ? {
          fontSize: 12
        } : {}],
        children: title
      })]
    })
  });
};

var styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch"
  },
  tagItemContainer: {
    cursor: "pointer",
    flexDirection: "row",
    height: 42,
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderRadius: 20,
    marginRight: 10,
    overflow: "hidden",
    marginBottom: 14,
    alignItems: "center"
  },
  iconContainerStyle: {
    margin: 1,
    height: 40,
    width: 40,
    borderRadius: 20,
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: config/* Colors.white10 */.wL.white10
  },
  tagItemText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    color: config/* Colors.white */.wL.white,
    marginRight: 15,
    marginLeft: 10
  },
  selectedTagItemText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    color: config/* Colors.white */.wL.white,
    marginRight: 15,
    marginLeft: 10
  },
  icon: {
    width: 14,
    height: 14
  }
});
/* harmony default export */ var components_AvatarTagItem = (AvatarTagItem);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/components/TagItem.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var TagItem = function TagItem(props) {
  var _item$minValue, _item$minValue$toStri, _title, _title2;

  var item = props.item,
      isMobileVersion = props.isMobileVersion;

  var onPressItem = function onPressItem(item) {
    if (props.onPressItem) {
      props.onPressItem(item);
    }
  };

  if (!item) return null;
  var isPicked = item.isHeadliner || item.isSelected;
  var icon = item.icon,
      name = item.name,
      avatar = item.avatar,
      categoryType = item.categoryType;
  var isArtist = categoryType == config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST;
  var title = name || item.title || item.label || (item === null || item === void 0 ? void 0 : (_item$minValue = item.minValue) === null || _item$minValue === void 0 ? void 0 : (_item$minValue$toStri = _item$minValue.toString()) === null || _item$minValue$toStri === void 0 ? void 0 : _item$minValue$toStri.split(".")[0]);
  var subtitle = null;

  if (title == "N/A") {
    // title = "   ";
    title = "N/A";
  }

  if ((_title = title) !== null && _title !== void 0 && _title.includes(" - ") && !item.isHeading) {
    subtitle = title.split(" - ");
  }

  if ((_title2 = title) !== null && _title2 !== void 0 && _title2.includes(" | ") && item.isHeading) {
    subtitle = title.split(" | ");
  }

  if (false) {}

  if (false) { var _item$title, _item$title$split$; }

  var isSection = item.children;

  if (isSection) {
    var _item$title2, _item$title2$replace;

    return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      activeOpacity: 1,
      onPress: function onPress() {
        if (item.title !== "Website") {
          onPressItem(item);
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [TagItem_styles.iconContainerStyle, isMobileVersion ? {
          height: 24,
          width: 24
        } : {}],
        children: [item.title === "Website" && item.value !== null ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: item.value,
          children: item.contactWebsite_follow_link ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            style: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              width: isMobileVersion ? 14 : 20,
              height: isMobileVersion ? 14 : 20,
              layout: "fixed",
              style: TagItem_styles.icon,
              imgUrl: icon
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "nofollow",
            target: "_blank",
            style: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              width: isMobileVersion ? 14 : 20,
              height: isMobileVersion ? 14 : 20,
              layout: "fixed",
              style: TagItem_styles.icon,
              imgUrl: icon
            })
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          width: isMobileVersion ? 14 : 20,
          height: isMobileVersion ? 14 : 20,
          layout: "fixed",
          style: TagItem_styles.icon,
          imgUrl: icon
        }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "hidden",
          children:  false ? 0 : (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : (_item$title2$replace = _item$title2.replace("Venue_1", "Venue")) === null || _item$title2$replace === void 0 ? void 0 : _item$title2$replace.replace("Venue_2", "Venue")
        })]
      })
    });
  }

  var renderTagView = function renderTagView(isPicked, title) {
    if (props.renderTagItemView) {
      return props.renderTagItemView({
        isPicked: isPicked,
        title: title
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [TagItem_styles.tagItemContainer, isMobileVersion ? {
        height: 24
      } : {}],
      children: [isPicked && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1 rounded-full",
        style: {
          position: "absolute",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }
      }), subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          flexDirection: "row"
        },
        children: [ false && /*#__PURE__*/0, /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [isPicked ? TagItem_styles.selectedTagItemText : TagItem_styles.tagItemText, isMobileVersion ? {
            fontSize: 10
          } : {}, item !== null && item !== void 0 && item.isHeading ? {
            fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium
          } : {},  false ? 0 : {}],
          children: subtitle[0]
        }), subtitle[1] && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [[isPicked ? TagItem_styles.selectedTagItemText : TagItem_styles.tagItemText, isMobileVersion ? {
            fontSize: 10
          } : {}],  false ? 0 : {
            marginLeft: 3,
            color: "#676767"
          }],
          children: subtitle[1]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [isPicked ? TagItem_styles.selectedTagItemText : TagItem_styles.tagItemText, isMobileVersion ? {
          fontSize: 10
        } : {}],
        children: title
      })]
    });
  };

  if (avatar || isArtist) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_AvatarTagItem, _objectSpread({}, props));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
    activeOpacity: 1,
    onPress: function onPress() {
      onPressItem(item);
    },
    children: renderTagView(isPicked, title)
  });
};

var TagItem_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch"
  },
  tagItemContainer: {
    cursor: "pointer",
    flexDirection: "row",
    height: 30,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 5,
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-black"),
    borderRadius: 15,
    marginRight: 6,
    overflow: "hidden",
    marginBottom: 16
  },
  iconContainerStyle: {
    marginRight: 6,
    marginLeft: 6,
    height: 30,
    width: 30,
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-icon-tag")
  },
  tagItemText: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  },
  selectedTagItemText: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  },
  icon: {
    width: 14,
    height: 14
  }
});
/* harmony default export */ var components_TagItem = (TagItem);

/***/ }),

/***/ 53732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VF": function() { return /* reexport */ molecules_AlertModal; },
  "gy": function() { return /* reexport */ molecules_CardGrid; },
  "CS": function() { return /* reexport */ CardList; },
  "QT": function() { return /* reexport */ CardGrid_CardSectionGrid; },
  "F8": function() { return /* reexport */ molecules_LocationModal; },
  "pU": function() { return /* reexport */ molecules_Media; },
  "sQ": function() { return /* reexport */ molecules_MediaGrid; },
  "G7": function() { return /* reexport */ molecules_MultipleCheckModal; },
  "Y6": function() { return /* reexport */ molecules_PlaylistModal; },
  "Fl": function() { return /* reexport */ PopupMenuListModal["default"]; },
  "c2": function() { return /* reexport */ molecules_SingleSelectModal; },
  "U4": function() { return /* reexport */ TagList_TagCategoryViewModal; },
  "qM": function() { return /* reexport */ TagList_TagIconSectionList; },
  "PS": function() { return /* reexport */ molecules_TagList; },
  "nL": function() { return /* reexport */ TagList_TagSectionList; }
});

// UNUSED EXPORTS: BottomActionBar, ConfirmationModal, FollowModal, LineupCountView, NotificationSwitch, VerificationCodeModal

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var exports_StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(exports_StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var exports_View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(exports_View);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/FlatList/index.js
var FlatList = __webpack_require__(70035);
var FlatList_default = /*#__PURE__*/__webpack_require__.n(FlatList);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ActivityIndicator/index.js
var ActivityIndicator = __webpack_require__(89009);
var ActivityIndicator_default = /*#__PURE__*/__webpack_require__.n(ActivityIndicator);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/RefreshControl/index.js
var RefreshControl = __webpack_require__(77818);
var RefreshControl_default = /*#__PURE__*/__webpack_require__.n(RefreshControl);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var exports_Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(exports_Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var exports_TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(exports_TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var exports_ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(exports_ScrollView);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/CardItem.js + 3 modules
var CardItem = __webpack_require__(51531);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(60651);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(22641);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./src/components/molecules/TagList/components/TagItem.js + 1 modules
var TagItem = __webpack_require__(52755);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/index.js








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var TagList = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(TagList, _Component);

  var _super = _createSuper(TagList);

  function TagList(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, TagList);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onPressItem", function (item) {
      if (_this.props.onPressItem) {
        _this.props.onPressItem(item);
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTagItem", function (item, index) {
      if (!item) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        prefetch: false,
        href: (0,helpers/* generateURLSlug */.ZF)(item.id, item.displayName, item.startDate, config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST, "about"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          style: {
            maxWidth: "100%"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagItem/* default */.Z, {
            item: item,
            onPressItem: _this.onPressItem,
            renderTagItemView: _this.props.renderTagItemView,
            isMobileVersion: _this.props.isMobileVersion
          }, index + "tag")
        })
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTags", function (items) {
      if (!items) return null;
      return _this.renderTagsInView(items);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTagsInView", function (items) {
      return items.map(function (item, index) {
        return _this.renderTagItem(item, index);
      });
    });

    return _this;
  }

  (0,createClass/* default */.Z)(TagList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [styles.tagContainer, this.props.style],
        children: this.renderTags(this.props.items)
      });
    }
  }]);

  return TagList;
}(react.Component);
var styles = StyleSheet_default().create({
  tagContainer: {
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start"
  }
});
/* harmony default export */ var molecules_TagList = (TagList);
// EXTERNAL MODULE: ./src/modules/lineup/components/LineupStatusView.js
var LineupStatusView = __webpack_require__(19834);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
;// CONCATENATED MODULE: ./src/components/molecules/CardList/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var WrappedCardList = /*#__PURE__*/react.forwardRef(function (wrapperProps, ref) {
  var CardList = function CardList(props) {
    var _useState = (0,react.useState)(null),
        showSelectedItem = _useState[0],
        setShowSelectedItem = _useState[1];

    var _useState2 = (0,react.useState)([]),
        artistSelectedItem = _useState2[0],
        setArtistSelectedItem = _useState2[1];

    var _useState3 = (0,react.useState)(false),
        isLoadingLineup = _useState3[0],
        setIsLoadingLineup = _useState3[1];

    var findFestivalLineup = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _artists$data, artists, newData;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoadingLineup(true);
                _context.prev = 1;
                _context.next = 4;
                return new Promise(function (resolve, reject) {
                  DAO/* ArtistDao.findWeb */.uf.findWeb({
                    pageSize: 999,
                    eventId: showSelectedItem
                  }).then(function (result) {
                    return resolve(result);
                  })["catch"](function (err) {
                    return reject(err);
                  });
                });

              case 4:
                artists = _context.sent;
                newData = artists === null || artists === void 0 ? void 0 : (_artists$data = artists.data) === null || _artists$data === void 0 ? void 0 : _artists$data.map(function (item) {
                  var _props$playlistArtist;

                  return _objectSpread(_objectSpread({}, item), {}, {
                    name: item.displayName,
                    isMatch: (_props$playlistArtist = props.playlistArtist) === null || _props$playlistArtist === void 0 ? void 0 : _props$playlistArtist.find(function (i) {
                      return i.id === item.id;
                    })
                  });
                });
                setArtistSelectedItem( // newData.sort((a, b) => b.isHeadliner - a.isHeadliner)
                newData.filter(function (i) {
                  return i.isMatch;
                }));
                setIsLoadingLineup(false);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);
                setIsLoadingLineup(false);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function findFestivalLineup() {
        return _ref.apply(this, arguments);
      };
    }();

    (0,react.useEffect)(function () {
      if (showSelectedItem) {
        findFestivalLineup();
      }
    }, [showSelectedItem]);

    var onItemAction = function onItemAction(data) {
      if (props.onItemAction) {
        props.onItemAction(data);
      }
    };

    var _renderItem = function renderItem(item, index) {
      if (!item || props.isChartsMode && parseInt(props.currentPageIndex) + index >= 100) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          prefetch: false,
          href: (0,helpers/* generateURLSlug */.ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, props.category, "about"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
              item: item,
              showYear: props.showYear,
              category: props.category,
              portrait: props.horizontal || props.gridView,
              fullWidth: props.gridView,
              mapView: props.mapView,
              isMobileVersion: props.isMobileVersion,
              mapFocused: props.mapFocused,
              setMapFocused: props.setMapFocused,
              isPlaylistMode: props.isPlaylistMode,
              isChartsMode: props.isChartsMode,
              isGuides: props.isGuides,
              isHeading: props.isHeading,
              withoutBadge: props.withoutBadge,
              chartIndex: parseInt(props.currentPageIndex) + index,
              marginBottom: props.marginBottom,
              firstIndex: index === 0,
              lastIndex: index === props.items.length - 1 // onItemAction={onItemAction}

            }, "tab" + index)
          })
        }), props.isPlaylistMode && /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
          style: [CardList_styles.infoBox, props.isMobileVersion ? {
            width: 50,
            height: 16,
            top: 12,
            right: 16
          } : {}],
          onPress: function onPress() {
            if ((item === null || item === void 0 ? void 0 : item.id) !== showSelectedItem) {
              setShowSelectedItem(item === null || item === void 0 ? void 0 : item.id);
              setArtistSelectedItem([]);
            } else {
              setShowSelectedItem(null);
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1",
            style: {
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              bottom: 0
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: props.isMobileVersion ? 8 : 12,
            height: props.isMobileVersion ? 10 : 16,
            src: "/icons/ic_search_artist_white_web.png",
            alt: "lineup",
            layout: "fixed"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: [CardList_styles.infoBoxText, props.isMobileVersion ? {
              fontSize: 10,
              lineHeight: 10,
              marginLeft: 4
            } : {}],
            children: item === null || item === void 0 ? void 0 : item.matchedLineup
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "bg-black7 -mt-8 py-4 rounded-2xl mb-4 ".concat(showSelectedItem === (item === null || item === void 0 ? void 0 : item.id) ? "block" : "hidden"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineupStatusView/* default */.Z, {
            artistCount: item === null || item === void 0 ? void 0 : item.totalLineup,
            headlinerCount: item === null || item === void 0 ? void 0 : item.matchedLineup,
            isMatchedLineup: true,
            isMobileVersion: props.isMobileVersion,
            style: {
              height: "auto",
              paddingVertical: props.isMobileVersion ? 15 : 40
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
            style: {
              flex: 1
            },
            children: [isLoadingLineup && /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {
              color: config/* Colors.white */.wL.white,
              size: props.isMobileVersion ? "small" : "large",
              style: {
                marginBottom: 20
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_TagList, {
              items: artistSelectedItem // onPressItem={onPressItem}
              ,
              style: {
                marginHorizontal: 16,
                justifyContent: "center"
              },
              onRefresh: function onRefresh() {},
              onLoadMore: function onLoadMore() {},
              isMobileVersion: props.isMobileVersion
            })]
          })]
        })]
      });
    };

    var onLoadMore = function onLoadMore() {
      if (props.onLoadMore && !props.isLoadingNextPage) {
        props.onLoadMore();
      }
    };

    var _onRefresh = function onRefresh() {
      if (props.onRefresh) {
        props.onRefresh();
      }
    };

    var loadingSkeleton = function loadingSkeleton() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "animate-pulse ".concat(props.isMobileVersion ? "" : "rounded-2xl", " ").concat(props.gridView ? "mr-3 mb-6" : "mb-3", " overflow-hidden relative"),
        children: [props.gridView && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full bg-grayText h-250px"
        }), props.category !== config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && props.gridView && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute top-0 p-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-14 h-16 bg-white3 rounded-xl"
          })
        }), props.gridView ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "absolute bottom-0 p-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-36 bg-white3 h-3 rounded-md mb-3"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-16 bg-white3 h-3 rounded-md mb-3"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-32 bg-white3 h-3 rounded-md"
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-row items-center bg-grayText",
          children: [props.category !== config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center justify-center sm:w-16 w-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sm:w-8 w-6 bg-white3 sm:h-2 h-1 rounded-md sm:mb-3 mb-2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sm:w-6 w-4 bg-white3 sm:h-2 h-1 rounded-md sm:mb-3 mb-2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sm:w-8 w-6 bg-white3 sm:h-2 h-1 rounded-md"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-24 h-24 bg-white3"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "sm:ml-8 ml-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sm:w-36 w-20 bg-white3 sm:h-3 h-2 rounded-md mb-4"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sm:w-64 w-40 bg-white3 sm:h-3 h-2 rounded-md"
            })]
          })]
        })]
      });
    };

    var renderItemList = function renderItemList(items) {
      var forwardedRef = props.forwardedRef;
      if (!items) return null;

      if (props.showInView) {
        return renderItemListInView(items);
      }

      return props.horizontal ? /*#__PURE__*/(0,jsx_runtime.jsx)((FlatList_default()), {
        ref: forwardedRef,
        data: items,
        bounces: !props.horizontal,
        horizontal: props.horizontal,
        renderItem: function renderItem(_ref2) {
          var item = _ref2.item,
              index = _ref2.index;
          return _renderItem(item, index);
        },
        keyExtractor: function keyExtractor(item, index) {
          return index.toString();
        },
        showsHorizontalScrollIndicator: false,
        showsVerticalScrollIndicator: false,
        extraData: props,
        ListHeaderComponent: props.ListHeaderComponent,
        numColumns: props.gridView ? props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? 6 : props.mapView ? 3 : config/* Values.deviceWidth */.$m.deviceWidth < 1850 ? 3 : 4 : null,
        ListEmptyComponent: !props.isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: !props.horizontal ? {
            paddingHorizontal: 20
          } : {},
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: {
              color: config/* Colors.white50 */.wL.white50,
              fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
              fontSize: 16,
              lineHeight: 20
            }
          })
        }),
        ListFooterComponent: props.isLoadingNextPage ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            height: props.gapHeight || 0
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {})
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            height: props.gapHeight || 0
          }
        }),
        refreshControl: /*#__PURE__*/(0,jsx_runtime.jsx)((RefreshControl_default()), {
          refreshing: props.isExploreSearch ? false : props.isLoading,
          onRefresh: function onRefresh() {
            _onRefresh();
          },
          tintColor: "#fff",
          titleColor: "#fff"
        }),
        onEndReachedThreshold: 0.01,
        onEndReached: props.disabledInfiniteScroll ? null : onLoadMore(),
        style: [!props.horizontal ? {
          paddingBottom: 30
        } : {}, props.gridView ? {
          marginRight: "-3%"
        } : {}]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [props.isFlatList ? /*#__PURE__*/(0,jsx_runtime.jsx)((FlatList_default()), {
          ref: forwardedRef,
          data: items,
          bounces: !props.horizontal,
          horizontal: props.horizontal,
          renderItem: function renderItem(_ref3) {
            var item = _ref3.item,
                index = _ref3.index;
            return _renderItem(item, index);
          },
          keyExtractor: function keyExtractor(item, index) {
            return index.toString();
          },
          showsHorizontalScrollIndicator: false,
          showsVerticalScrollIndicator: false,
          extraData: props,
          ListHeaderComponent: props.ListHeaderComponent,
          numColumns: props.gridView ? props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? 6 : props.mapView ? 3 : config/* Values.deviceWidth */.$m.deviceWidth < 1850 ? 3 : 4 : null,
          ListEmptyComponent: !props.isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: !props.horizontal ? {
              paddingHorizontal: 20
            } : {},
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: {
                color: config/* Colors.white50 */.wL.white50,
                fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                fontSize: 16,
                lineHeight: 20
              }
            })
          }),
          ListFooterComponent: props.isLoadingNextPage ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: {
              height: props.gapHeight || 0
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {})
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: {
              height: props.gapHeight || 0
            }
          }),
          refreshControl: /*#__PURE__*/(0,jsx_runtime.jsx)((RefreshControl_default()), {
            refreshing: props.isExploreSearch ? false : props.isLoading,
            onRefresh: function onRefresh() {
              _onRefresh();
            },
            tintColor: "#fff",
            titleColor: "#fff"
          }),
          onEndReachedThreshold: 0.01,
          onEndReached: props.disabledInfiniteScroll ? null : onLoadMore(),
          style: [!props.horizontal ? {
            paddingBottom: 30
          } : {}, props.gridView ? {
            marginRight: "-3%"
          } : {}]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(index_es/* default */.Z, {
          dataLength: items.length / 2,
          next: function next() {
            return props.disabledInfiniteScroll ? null : onLoadMore();
          },
          hasMore: true,
          className: " \n                 ".concat(props.gridView ? props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? "grid 2xl:grid-cols-6 grid-cols-4 gap-0" : props.mapView ? "grid 2xl:grid-cols-1 grid-cols-1 gap-0" : "grid 2xl:grid-cols-4 grid-cols-3 gap-0" : null, " ").concat(props.gridView ? "-mr-2" : ""),
          scrollThreshold: 0.2,
          children: [items.map(function (item, index) {
            return _renderItem(item, index);
          }), (props.isLoadingNextPage || props.isLoading) && loadingSkeleton(), (props.isLoadingNextPage || props.isLoading) && loadingSkeleton(), (props.isLoadingNextPage || props.isLoading) && loadingSkeleton(), (props.isLoadingNextPage || props.isLoading) && loadingSkeleton(), (props.isLoadingNextPage || props.isLoading) && props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && loadingSkeleton(), (props.isLoadingNextPage || props.isLoading) && props.category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && loadingSkeleton()]
        }), props.isLoadingNextPage || props.isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            height: props.gapHeight || 0
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            height: props.gapHeight || 0
          }
        })]
      });
    };

    var renderItemListInView = function renderItemListInView(items) {
      return items.map(function (item, index) {
        return _renderItem(item, index);
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [CardList_styles.cardListContainer, {
        flexDirection: props.horizontal ? "row" : "column"
      }, props.style],
      children: renderItemList(props.items)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardList, _objectSpread(_objectSpread({}, wrapperProps), {}, {
    forwardedRef: ref
  }));
});
var CardList_styles = StyleSheet_default().create({
  cardListContainer: {
    flexDirection: "row",
    alignSelf: "stretch"
  },
  infoBox: {
    position: "absolute",
    right: 56,
    top: 34,
    width: 100,
    height: 32,
    borderRadius: 60,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    cursor: "pointer"
  },
  infoBoxText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    position: "relative",
    zIndex: 10,
    marginLeft: 8
  }
});
/* harmony default export */ var CardList = (WrappedCardList);
// EXTERNAL MODULE: ./src/components/molecules/PopupMenuListModal/index.js
var PopupMenuListModal = __webpack_require__(94843);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/TagIconSectionList.js









function TagIconSectionList_createSuper(Derived) { var hasNativeReflectConstruct = TagIconSectionList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function TagIconSectionList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var TagIconSectionList = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(TagIconSectionList, _Component);

  var _super = TagIconSectionList_createSuper(TagIconSectionList);

  function TagIconSectionList(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, TagIconSectionList);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onPressItem", function (item) {
      if (_this.props.onPressItem) {
        _this.props.onPressItem(item);
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTagItem", function (item, index) {
      if (_this.props.renderTagItem) {
        return _this.props.renderTagItem();
      }

      if (!item) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TagItem/* default */.Z, {
        item: item,
        onPressItem: _this.onPressItem,
        isMobileVersion: _this.props.isMobileVersion
      }, index + "tag");
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTags", function (items) {
      if (!items) return null;
      return _this.renderTagsInView(items);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderTagsInView", function (items) {
      return items.map(function (item, index) {
        return _this.renderTagItem(item, index);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderSections", function (sections) {
      var tags = [];
      if (!sections) return null;
      sections.forEach(function (section) {
        tags.push(section);

        if (section.children) {
          tags.push.apply(tags, (0,toConsumableArray/* default */.Z)(section.children));
        }
      });
      return _this.renderTags(tags);
    });

    return _this;
  }

  (0,createClass/* default */.Z)(TagIconSectionList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [TagIconSectionList_styles.tagContainer, this.props.style],
        children: this.renderSections(orderBy_default()(this.props.items, "order"))
      });
    }
  }]);

  return TagIconSectionList;
}(react.Component);
var TagIconSectionList_styles = StyleSheet_default().create({
  tagContainer: {
    flexWrap: "wrap",
    flexDirection: "row",
    paddingRight: 20
  }
});
/* harmony default export */ var TagList_TagIconSectionList = (TagIconSectionList);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/TagSectionList.js








function TagSectionList_createSuper(Derived) { var hasNativeReflectConstruct = TagSectionList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function TagSectionList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var TagSection = function TagSection(props) {
  var isMobileVersion = props.isMobileVersion;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: (0,defineProperty/* default */.Z)({
      alignSelf: "center",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      height: isMobileVersion ? 24 : 40,
      paddingLeft: 1,
      paddingRight: 1,
      borderRadius: 20,
      overflow: "hidden",
      marginBottom: 16,
      marginTop: isMobileVersion ? 0 : 20
    }, "marginTop", 20),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1",
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        justifyContent: "center",
        alignItems: "center"
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        height: isMobileVersion ? 22 : 38,
        paddingLeft: 29,
        paddingRight: 29,
        borderRadius: 20,
        backgroundColor: config/* Colors.black */.wL.black,
        overflow: "hidden"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
          fontSize: isMobileVersion ? 12 : 18,
          lineHeight: isMobileVersion ? 12 : 32,
          color: "white",
          marginBottom: 32,
          marginTop: 32
        },
        children: props.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
          fontSize: isMobileVersion ? 12 : 18,
          lineHeight: isMobileVersion ? 12 : 32,
          color: config/* Colors.grayText2 */.wL.grayText2,
          marginBottom: 32,
          marginTop: 32,
          marginLeft: 10
        },
        children: props.suffix
      })]
    })]
  });
};

var TagSectionList = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(TagSectionList, _Component);

  var _super = TagSectionList_createSuper(TagSectionList);

  function TagSectionList(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, TagSectionList);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onPressItem", function (item) {
      if (_this.props.onPressItem) {
        _this.props.onPressItem(item);
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderSections", function (sections) {
      var tagViews = [];
      if (!sections) return null;
      sections.forEach(function (section, index) {
        tagViews.push( /*#__PURE__*/(0,jsx_runtime.jsx)(TagSection, {
          title: section.title,
          suffix: section.suffix,
          isMobileVersion: _this.props.isMobileVersion
        }, "section" + index));

        if (section.data) {
          section.data.map(function (listData) {
            tagViews.push( /*#__PURE__*/(0,jsx_runtime.jsx)(molecules_TagList, {
              renderTagItemView: _this.props.renderTagItemView,
              items: listData.list,
              onPressItem: _this.onPressItem,
              style: _this.props.tagListContainerStyle,
              isMobileVersion: _this.props.isMobileVersion
            }, "tag" + index));
          });
        }
      });
      return tagViews;
    });

    return _this;
  }

  (0,createClass/* default */.Z)(TagSectionList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [TagSectionList_styles.tagContainer, this.props.style],
        children: this.renderSections(this.props.items)
      });
    }
  }]);

  return TagSectionList;
}(react.Component);
var TagSectionList_styles = StyleSheet_default().create({
  tagContainer: {
    alignSelf: "stretch",
    flexDirection: "column"
  }
});
/* harmony default export */ var TagList_TagSectionList = (TagSectionList);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Modal/index.js
var Modal = __webpack_require__(17666);
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
;// CONCATENATED MODULE: ./src/components/molecules/TagList/TagCategoryViewModal.js















var TagCategoryViewModal = function TagCategoryViewModal(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  (0,react.useEffect)(function () {
    if (props.isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [props.isVisible]);
  if (!props.item) return null;
  var _props$item = props.item,
      icon = _props$item.icon,
      name = _props$item.name,
      children = _props$item.children;
  var title = props.item.name || props.item.title;
  var contentText = "";

  if (children) {
    if (false) {} else if (false) {} else {
      contentText = children.map(function (item) {
        var _item$minValue, _item$minValue$toStri;

        var result = item.name || item.title || item.label || (item === null || item === void 0 ? void 0 : (_item$minValue = item.minValue) === null || _item$minValue === void 0 ? void 0 : (_item$minValue$toStri = _item$minValue.toString()) === null || _item$minValue$toStri === void 0 ? void 0 : _item$minValue$toStri.split(".")[0]);
        return result === null || result === void 0 ? void 0 : result.replace("|", "-");
      }).join(", ");
    }
  }

  var onClose = function onClose() {
    document.body.style.overflow = "auto";

    if (props.onClose) {
      props.onClose();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((Modal_default()), {
      transparent: true,
      visible: props.isVisible,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        style: {
          backgroundColor: "rgba(89, 89, 89, 0.45)",
          width: "100%",
          height: "100%",
          position: "absolute",
          left: 0,
          top: 0
        },
        onPress: onClose
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: TagCategoryViewModal_styles.dim,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
          activeOpacity: 1,
          onPress: onClose,
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: [TagCategoryViewModal_styles.modalContainer, isMobileVersion ? {
            width: 300,
            height: 82
          } : {}],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: [TagCategoryViewModal_styles.bodyContainer, isMobileVersion ? {
              padding: 0,
              justifyContent: "center",
              alignItems: "center"
            } : {}],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
              style: [TagCategoryViewModal_styles.closeIconContainer, isMobileVersion ? {
                width: 20,
                height: 20,
                top: 16
              } : {}],
              onPress: onClose,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                width: isMobileVersion ? 16 : 24,
                height: isMobileVersion ? 16 : 24,
                layout: "fixed",
                source: config/* Images.iconClose */.rU.iconClose,
                style: TagCategoryViewModal_styles.closeIcon,
                resizeMode: "contain"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
              style: TagCategoryViewModal_styles.titleContainer,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: {
                  marginRight: isMobileVersion ? 8 : 15
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                  imgUrl: icon,
                  objectFit: "contain",
                  width: isMobileVersion ? 16 : 24,
                  height: isMobileVersion ? 16 : 24,
                  layout: "fixed",
                  style: TagCategoryViewModal_styles.titleIcon,
                  alt: title === null || title === void 0 ? void 0 : title.toLowerCase()
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: [TagCategoryViewModal_styles.title, isMobileVersion ? {
                  fontSize: 16
                } : {}],
                children: title
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [TagCategoryViewModal_styles.contentText, isMobileVersion ? {
                fontSize: 12,
                marginBottom: 5
              } : {}],
              children: contentText
            })]
          })
        })]
      })]
    })
  });
};

var TagCategoryViewModal_styles = StyleSheet_default().create({
  dim: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    maxWidth: 480,
    width: "100%",
    height: "auto"
  },
  modalContainer: {
    margin: 32,
    position: "absolute",
    flex: 1,
    backgroundColor: (0,formatHelpers/* getClass */.ll)("background"),
    borderWidth: 0,
    justifyContent: "center",
    borderRadius: 25,
    maxWidth: 480,
    width: "100%",
    zIndex: 500
  },
  title: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 24,
    lineHeight: 20,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    textAlign: "center"
  },
  titleContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  titleIcon: {
    width: 16,
    height: 16,
    marginRight: 8
  },
  bodyContainer: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 16,
    paddingBottom: 20,
    paddingTop: 30
  },
  icon: {
    height: 16,
    width: 16,
    resizeMode: "contain",
    marginRight: 6
  },
  contentText: {
    fontSize: 16,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    textAlign: "center",
    marginTop: 12,
    marginBottom: 16
  },
  closeIconContainer: {
    position: "absolute",
    top: 20,
    right: 16,
    width: 32,
    height: 32
  },
  closeIcon: {
    width: 16,
    height: 16
  }
});
/* harmony default export */ var TagList_TagCategoryViewModal = (TagCategoryViewModal);
;// CONCATENATED MODULE: ./src/components/molecules/MediaGrid/AlbumInfoView.js












var AlbumInfoView = function AlbumInfoView(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  if (!props.item) return null;
  var _props$item = props.item,
      name = _props$item.name,
      totalCount = _props$item.totalCount;
  var countPhotoString = "".concat(t(totalCount), " media");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [AlbumInfoView_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: [AlbumInfoView_styles.title, isMobileVersion ? {
        fontSize: 12,
        lineHeight: 12
      } : {}],
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: [AlbumInfoView_styles.description, isMobileVersion ? {
        fontSize: 10,
        lineHeight: 12.19
      } : {}],
      children: countPhotoString
    })]
  });
};

var AlbumInfoView_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignItems: "center"
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white
  },
  description: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.placeholder */.wL.placeholder,
    marginTop: 10,
    marginBottom: 15
  }
});
/* harmony default export */ var MediaGrid_AlbumInfoView = (AlbumInfoView);
;// CONCATENATED MODULE: ./src/components/molecules/MediaGrid/index.js















var MediaGrid = function MediaGrid(props) {
  var items = props.items,
      isAlbum = props.isAlbum,
      isMobileVersion = props.isMobileVersion;
  var ITEM_WIDTH = isMobileVersion ? "33%" : 350;
  var ITEM_HEIGHT = isMobileVersion ? (config/* Values.deviceWidth */.$m.deviceWidth - 6) / 3 : 350;

  var onItemAction = function onItemAction(type, item) {
    if (props.onItemAction) {
      props.onItemAction(type, item);
    }
  };

  var onLoadMore = function onLoadMore() {
    if (props.onLoadMore) {
      props.onLoadMore();
    }
  };

  var onRefresh = function onRefresh() {
    if (props.onRefresh) {
      props.onRefresh();
    }
  };

  var renderAlbumInfoView = function renderAlbumInfoView(item) {
    return [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-gradient-to-t from-realblack to-transparent",
      style: MediaGrid_styles.mask
    }, "mask"), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaGrid_AlbumInfoView, {
      item: item,
      isMobileVersion: isMobileVersion
    }, "album-info")];
  };

  var renderItem = function renderItem(_ref) {
    var item = _ref.item,
        index = _ref.index;

    if (props.renderItem) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: [MediaGrid_styles.itemContainer, {
          width: ITEM_WIDTH,
          height: ITEM_HEIGHT
        }, isLastItem && {
          marginRight: 0
        }],
        children: props.renderItem({
          item: item,
          index: index
        })
      });
    }

    var isLastItem = index % 3 == 2;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      activeOpacity: 1,
      style: [MediaGrid_styles.itemContainer, {
        width: ITEM_WIDTH,
        height: ITEM_HEIGHT
      }, isLastItem && {
        marginRight: 0
      }, isMobileVersion ? {
        borderRadius: 4,
        marginRight: 3,
        marginBottom: 3
      } : {}],
      onPress: function onPress() {
        return onItemAction("view", item);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        imgUrl: item.image,
        style: MediaGrid_styles.backgroundImage,
        layout: "fill",
        objectFit: "cover",
        blurDataURL: "/images/black.png"
      }), item.mediaType == config/* Constants.mediaType.MEDIA_TYPE_VIDEO */.gT.mediaType.MEDIA_TYPE_VIDEO && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          alignItems: "center",
          justifyContent: "center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            width: isMobileVersion ? 50 : 100,
            height: isMobileVersion ? 50 : 100,
            borderRadius: 50,
            backgroundColor: "rgba(0,0,0,0.7)",
            alignItems: "center",
            justifyContent: "center"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            imgUrl: "Local:iconVideoPlay",
            style: MediaGrid_styles.playIcon,
            height: isMobileVersion ? 19 : 50,
            width: isMobileVersion ? 19 : 50,
            layout: "fixed",
            objectFit: "contain"
          })
        })
      }), isAlbum && renderAlbumInfoView(item)]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)((FlatList_default()), {
    numColumns: 3,
    data: items,
    renderItem: renderItem,
    ListFooterComponent: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        height: isMobileVersion ? 0 : 50
      }
    }),
    refreshControl: /*#__PURE__*/(0,jsx_runtime.jsx)((RefreshControl_default()), {
      refreshing: props.isLoading || false,
      onRefresh: onRefresh,
      tintColor: "#fff",
      titleColor: "#fff"
    }),
    style: [MediaGrid_styles.container, props.style],
    keyExtractor: function keyExtractor(item, index) {
      return index.toString();
    },
    onEndReachedThreshold: 0.4,
    onEndReached: onLoadMore
  });
};

var MediaGrid_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch"
  },
  itemContainer: {
    borderRadius: 16,
    flexDirection: "column",
    marginRight: 10,
    marginBottom: 10,
    justifyContent: "flex-end",
    overflow: "hidden",
    backgroundColor: "black"
  },
  backgroundImage: {
    position: "absolute",
    borderRadius: 16,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "black"
  },
  mask: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  playIcon: {
    width: 40,
    height: 40
  }
});
/* harmony default export */ var molecules_MediaGrid = (MediaGrid);
// EXTERNAL MODULE: ./src/components/molecules/LineupCountView.js
var LineupCountView = __webpack_require__(41540);
;// CONCATENATED MODULE: ./src/components/molecules/SingleSelectModal/SingleSelectContainer.js








var SingleSelectContainer = function SingleSelectContainer(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      setSearch = _useState[1];

  var onPressItem = function onPressItem(item) {
    if (props.onPressItem) {
      props.onPressItem(item);
    }
  };

  var isChecked = function isChecked(item) {
    if (item.id == props.checkedItemId) {
      return true;
    }

    return false;
  };

  var renderItems = function renderItems(items) {
    return items.map(function (item, index) {
      var isLast = index == items.length - 1;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCheckBox */.ku, {
        label: item.label,
        suffix: item.suffix,
        checked: isChecked(item),
        onPress: function onPress() {
          onPressItem(item);
        },
        style: [!isLast && SingleSelectContainer_styles.itemStyle],
        isMobileVersion: isMobileVersion
      }, "check" + index);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: [SingleSelectContainer_styles.container, props.style],
    children: [props.isSearchable && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedTextInput */.LA, {
      placeholder: t("key_search"),
      bordered: true,
      onChangeText: function onChangeText(text) {
        return setSearch(text);
      },
      value: search,
      maxLength: 64,
      autoCapitalize: "none",
      autoCorrect: false,
      containerStyle: {
        marginBottom: 16,
        marginTop: 16
      },
      returnKeyType: "search",
      showClose: search !== "",
      onPressClose: function onPressClose() {
        return setSearch("");
      }
    }), renderItems(props.items.filter(function (item) {
      return item.label.toLowerCase().includes(search.toLowerCase());
    }).filter(function (item, index) {
      return index < 20;
    }))]
  });
};

var SingleSelectContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
    maxHeight: 350,
    overflow: "hidden"
  },
  itemStyle: {
    marginBottom: 14
  }
});
/* harmony default export */ var SingleSelectModal_SingleSelectContainer = (SingleSelectContainer);
;// CONCATENATED MODULE: ./src/components/molecules/SingleSelectModal/index.js


function SingleSelectModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SingleSelectModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SingleSelectModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SingleSelectModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SingleSelectModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, SingleSelectModal_objectSpread(SingleSelectModal_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SingleSelectModal_SingleSelectContainer, SingleSelectModal_objectSpread(SingleSelectModal_objectSpread({}, props), {}, {
      style: {
        marginTop: 14
      }
    }))
  }));
});
/* harmony default export */ var molecules_SingleSelectModal = (SingleSelectModal);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/styled-jsx/style.js
var style = __webpack_require__(60536);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Dimensions/index.js
var Dimensions = __webpack_require__(13256);
var Dimensions_default = /*#__PURE__*/__webpack_require__.n(Dimensions);
;// CONCATENATED MODULE: ./components_web/ScrollPicker.js


var _excluded = (/* unused pure expression or super */ null && (["itemHeight", "style", "containerStyle", "highlightStyle", "scrollViewComponent"]));

function ScrollPicker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ScrollPicker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ScrollPicker_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ScrollPicker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function isNumeric(str) {
  if (typeof str === "number") return true;
  if (typeof str !== "string") return false;
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
}

var deviceWidth = Dimensions_default().get("window").width;

var isViewStyle = function isViewStyle(style) {
  return typeof style === "object" && style !== null && Object.keys(style).includes("height");
};

function ScrollPicker(_ref) {
  var _ref$itemHeight = _ref.itemHeight,
      itemHeight = _ref$itemHeight === void 0 ? 30 : _ref$itemHeight,
      style = _ref.style,
      containerStyle = _ref.containerStyle,
      highlightStyle = _ref.highlightStyle,
      scrollViewComponent = _ref.scrollViewComponent,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      initialized = _useState[0],
      setInitialized = _useState[1];

  var _useState2 = useState(props.selectedIndex && props.selectedIndex >= 0 ? props.selectedIndex : 0),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  var sView = useRef(null);

  var _useState3 = useState(false),
      isScrollTo = _useState3[0],
      setIsScrollTo = _useState3[1];

  var _useState4 = useState(false),
      dragStarted = _useState4[0],
      setDragStarted = _useState4[1];

  var _useState5 = useState(false),
      momentumStarted = _useState5[0],
      setMomentumStarted = _useState5[1];

  var _useState6 = useState(null),
      timer = _useState6[0],
      setTimer = _useState6[1];

  var wrapperHeight = props.wrapperHeight || (isViewStyle(style) && isNumeric(style.height) ? Number(style.height) : 0) || itemHeight * 5;
  useEffect(function initialize() {
    if (initialized) return;
    setInitialized(true);
    setTimeout(function () {
      var _sView$current;

      var y = itemHeight * selectedIndex;
      sView === null || sView === void 0 ? void 0 : (_sView$current = sView.current) === null || _sView$current === void 0 ? void 0 : _sView$current.scrollTo({
        y: y
      });
    }, 0);
    return function () {
      timer && clearTimeout(timer);
    };
  }, [initialized, itemHeight, selectedIndex, sView, timer]);

  var renderPlaceHolder = function renderPlaceHolder() {
    var h = (wrapperHeight - itemHeight) / 2;

    var header = /*#__PURE__*/_jsx(View, {
      style: {
        height: h,
        flex: 1
      }
    });

    var footer = /*#__PURE__*/_jsx(View, {
      style: {
        height: h,
        flex: 1
      }
    });

    return {
      header: header,
      footer: footer
    };
  };

  var renderItem = function renderItem(data, index) {
    var isSelected = index === selectedIndex;
    var item = props.renderItem ? props.renderItem(data, index, isSelected) : /*#__PURE__*/_jsx(Text, {
      style: isSelected ? [ScrollPicker_styles.itemText, ScrollPicker_styles.itemTextSelected] : ScrollPicker_styles.itemText,
      children: data
    });
    return /*#__PURE__*/_jsx(View, {
      style: [ScrollPicker_styles.itemWrapper, {
        height: itemHeight
      }],
      children: item
    }, index);
  };

  var scrollFix = useCallback(function (e) {
    var y = 0;
    var h = itemHeight;

    if (e.nativeEvent.contentOffset) {
      y = e.nativeEvent.contentOffset.y;
    }

    var _selectedIndex = Math.round(y / h);

    var _y = _selectedIndex * h;

    if (_y !== y) {
      var _sView$current2;

      // using scrollTo in ios, onMomentumScrollEnd will be invoked
      if (Platform.OS === "ios") {
        setIsScrollTo(true);
      }

      sView === null || sView === void 0 ? void 0 : (_sView$current2 = sView.current) === null || _sView$current2 === void 0 ? void 0 : _sView$current2.scrollTo({
        y: _y
      });
    }

    if (selectedIndex === _selectedIndex) {
      return;
    } // onValueChange


    if (props.onValueChange) {
      var selectedValue = props.dataSource[_selectedIndex];
      setSelectedIndex(_selectedIndex);
      props.onValueChange(selectedValue, _selectedIndex);
    }
  }, [itemHeight, props, selectedIndex]);

  var _onScrollBeginDrag = function onScrollBeginDrag() {
    setDragStarted(true);

    if (Platform.OS === "ios") {
      setIsScrollTo(false);
    }

    timer && clearTimeout(timer);
  };

  var _onScrollEndDrag = function onScrollEndDrag(e) {
    setDragStarted(false); // if not used, event will be garbaged

    var _e = ScrollPicker_objectSpread({}, e);

    timer && clearTimeout(timer);
    setTimer(setTimeout(function () {
      if (!momentumStarted) {
        scrollFix(_e);
      }
    }, 50));
  };

  var onMomentumScrollBegin = function onMomentumScrollBegin() {
    setMomentumStarted(true);
    timer && clearTimeout(timer);
  };

  var _onMomentumScrollEnd = function onMomentumScrollEnd(e) {
    setMomentumStarted(false);

    if (!isScrollTo && !dragStarted) {
      scrollFix(e);
    }
  };

  var _renderPlaceHolder = renderPlaceHolder(),
      header = _renderPlaceHolder.header,
      footer = _renderPlaceHolder.footer;

  var highlightWidth = (isViewStyle(style) ? style.width : 0) || deviceWidth;
  var highlightColor = props.highlightColor || "#333";
  var highlightBorderWidth = props.highlightBorderWidth || StyleSheet.hairlineWidth;
  var wrapperStyle = {
    height: wrapperHeight,
    flex: 1,
    backgroundColor: props.wrapperColor || "#fafafa",
    overflow: "hidden"
  };
  var currentHighlightStyle = {
    position: "absolute",
    top: (wrapperHeight - itemHeight) / 2,
    height: itemHeight,
    width: highlightWidth,
    borderTopColor: highlightColor,
    borderBottomColor: highlightColor,
    borderTopWidth: highlightBorderWidth,
    borderBottomWidth: highlightBorderWidth
  };
  var CustomScrollViewComponent = scrollViewComponent || ScrollView;
  return /*#__PURE__*/_jsxs(View, {
    style: [wrapperStyle, containerStyle],
    children: [/*#__PURE__*/_jsx(View, {
      style: [currentHighlightStyle, highlightStyle]
    }), /*#__PURE__*/_jsxs(CustomScrollViewComponent, {
      ref: sView,
      bounces: false,
      showsVerticalScrollIndicator: false,
      nestedScrollEnabled: true,
      onMomentumScrollBegin: function onMomentumScrollBegin(_e) {
        return alert(JSON.stringify(_e));
      },
      onMomentumScrollEnd: function onMomentumScrollEnd(e) {
        return _onMomentumScrollEnd(e);
      },
      onScrollBeginDrag: function onScrollBeginDrag(_e) {
        return _onScrollBeginDrag();
      },
      onScrollEndDrag: function onScrollEndDrag(e) {
        return _onScrollEndDrag(e);
      },
      children: [header, props.dataSource.map(renderItem), footer]
    })]
  });
}
var ScrollPicker_styles = StyleSheet_default().create({
  itemWrapper: {
    height: 30,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden"
  },
  itemText: {
    color: "#999"
  },
  itemTextSelected: {
    color: "#333"
  }
});
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/PanResponder/index.js
var PanResponder = __webpack_require__(44090);
var PanResponder_default = /*#__PURE__*/__webpack_require__.n(PanResponder);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Platform/index.js
var exports_Platform = __webpack_require__(98842);
var Platform_default = /*#__PURE__*/__webpack_require__.n(exports_Platform);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/I18nManager/index.js
var I18nManager = __webpack_require__(4020);
var I18nManager_default = /*#__PURE__*/__webpack_require__.n(I18nManager);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ImageBackground/index.js
var ImageBackground = __webpack_require__(75296);
var ImageBackground_default = /*#__PURE__*/__webpack_require__.n(ImageBackground);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableHighlight/index.js
var TouchableHighlight = __webpack_require__(28865);
var TouchableHighlight_default = /*#__PURE__*/__webpack_require__.n(TouchableHighlight);
;// CONCATENATED MODULE: ./components_web/MultiSlider/DefaultMarker.js







function DefaultMarker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DefaultMarker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DefaultMarker_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DefaultMarker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DefaultMarker_createSuper(Derived) { var hasNativeReflectConstruct = DefaultMarker_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DefaultMarker_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var DefaultMarker = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DefaultMarker, _React$Component);

  var _super = DefaultMarker_createSuper(DefaultMarker);

  function DefaultMarker() {
    (0,classCallCheck/* default */.Z)(this, DefaultMarker);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DefaultMarker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableHighlight_default()), {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: this.props.enabled ? [DefaultMarker_styles.markerStyle, this.props.markerStyle, this.props.pressed && DefaultMarker_styles.pressedMarkerStyle, this.props.pressed && this.props.pressedMarkerStyle] : [DefaultMarker_styles.markerStyle, DefaultMarker_styles.disabled, this.props.disabledMarkerStyle]
        })
      });
    }
  }]);

  return DefaultMarker;
}(react.Component);

var DefaultMarker_styles = StyleSheet_default().create({
  markerStyle: DefaultMarker_objectSpread({}, Platform_default().select({
    ios: {
      height: 30,
      width: 30,
      borderRadius: 30,
      borderWidth: 1,
      borderColor: '#DDDDDD',
      backgroundColor: '#FFFFFF',
      shadowColor: '#000000',
      shadowOffset: {
        width: 0,
        height: 3
      },
      shadowRadius: 1,
      shadowOpacity: 0.2
    },
    android: {
      height: 12,
      width: 12,
      borderRadius: 12,
      backgroundColor: '#0D8675'
    },
    web: {
      height: 30,
      width: 30,
      borderRadius: 30,
      borderWidth: 1,
      borderColor: '#DDDDDD',
      backgroundColor: '#FFFFFF',
      shadowColor: '#000000',
      shadowOffset: {
        width: 0,
        height: 3
      },
      shadowRadius: 1,
      shadowOpacity: 0.2
    }
  })),
  pressedMarkerStyle: DefaultMarker_objectSpread({}, Platform_default().select({
    web: {},
    ios: {},
    android: {
      height: 20,
      width: 20,
      borderRadius: 20
    }
  })),
  disabled: {
    backgroundColor: '#d3d3d3'
  }
});
/* harmony default export */ var MultiSlider_DefaultMarker = (DefaultMarker);
;// CONCATENATED MODULE: ./components_web/MultiSlider/DefaultLabel.js






function DefaultLabel_createSuper(Derived) { var hasNativeReflectConstruct = DefaultLabel_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DefaultLabel_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var sliderRadius = 3;
var width = 50;

var DefaultLabel = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DefaultLabel, _React$Component);

  var _super = DefaultLabel_createSuper(DefaultLabel);

  function DefaultLabel() {
    (0,classCallCheck/* default */.Z)(this, DefaultLabel);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DefaultLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          oneMarkerValue = _this$props.oneMarkerValue,
          twoMarkerValue = _this$props.twoMarkerValue,
          oneMarkerLeftPosition = _this$props.oneMarkerLeftPosition,
          twoMarkerLeftPosition = _this$props.twoMarkerLeftPosition,
          oneMarkerPressed = _this$props.oneMarkerPressed,
          twoMarkerPressed = _this$props.twoMarkerPressed;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          position: 'relative'
        },
        children: [Number.isFinite(oneMarkerLeftPosition) && Number.isFinite(oneMarkerValue) && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: [DefaultLabel_styles.sliderLabel, {
            left: oneMarkerLeftPosition - width / 2
          }, oneMarkerPressed && DefaultLabel_styles.markerPressed],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: DefaultLabel_styles.sliderLabelText,
            children: oneMarkerValue
          })
        }), Number.isFinite(twoMarkerLeftPosition) && Number.isFinite(twoMarkerValue) && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: [DefaultLabel_styles.sliderLabel, {
            left: twoMarkerLeftPosition - width / 2
          }, twoMarkerPressed && DefaultLabel_styles.markerPressed],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: DefaultLabel_styles.sliderLabelText,
            children: twoMarkerValue
          })
        })]
      });
    }
  }]);

  return DefaultLabel;
}(react.Component);


var DefaultLabel_styles = StyleSheet_default().create({
  sliderLabel: {
    position: 'absolute',
    bottom: 0,
    minWidth: width,
    padding: 8,
    backgroundColor: '#f1f1f1'
  },
  sliderLabelText: {
    alignItems: 'center',
    textAlign: 'center',
    fontStyle: 'normal',
    fontSize: 11
  },
  markerPressed: {
    borderWidth: 2,
    borderColor: '#999'
  }
});
;// CONCATENATED MODULE: ./components_web/MultiSlider/converters.js
// Find closest index for a given value
var closest = function closest(array, n) {
  var minI = 0;
  var maxI = array.length - 1;

  if (array[minI] > n) {
    return minI;
  } else if (array[maxI] < n) {
    return maxI;
  } else if (array[minI] <= n && n <= array[maxI]) {
    var closestIndex = null;

    while (closestIndex === null) {
      var midI = Math.round((minI + maxI) / 2);
      var midVal = array[midI];

      if (midVal === n) {
        closestIndex = midI;
      } else if (maxI === minI + 1) {
        var minValue = array[minI];
        var maxValue = array[maxI];
        var deltaMin = Math.abs(minValue - n);
        var deltaMax = Math.abs(maxValue - n);
        closestIndex = deltaMax <= deltaMin ? maxI : minI;
      } else if (midVal < n) {
        minI = midI;
      } else if (midVal > n) {
        maxI = midI;
      } else {
        closestIndex = -1;
      }
    }

    return closestIndex;
  }

  return -1;
};

function valueToPosition(value, valuesArray, sliderLength) {
  var markerSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (value === undefined) return undefined;
  var index = closest(valuesArray, value);
  var arrLength = valuesArray.length - 1;
  var validIndex = index === -1 ? arrLength : index;
  var output = (sliderLength - markerSize) * validIndex / arrLength + markerSize / 2;
  return output;
}
function positionToValue(position, valuesArray, sliderLength) {
  var markerSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (position < 0 || sliderLength < position) {
    return null;
  } else {
    var arrLength = valuesArray.length - 1;
    var offset = (position - markerSize / 2) / (sliderLength - markerSize);
    var index = arrLength * (position - markerSize / 2 + offset * markerSize) / sliderLength;
    var output = valuesArray[Math.round(index)];
    return output;
  }
}
function createArray(start, end, step) {
  var direction = start - end > 0 ? -1 : 1;
  var result = [];

  if (!step) {
    return result;
  } else {
    var length = Math.abs((start - end) / step) + 1;

    for (var i = 0; i < length; i++) {
      result.push(start + i * Math.abs(step) * direction);
    }

    return result;
  }
}
;// CONCATENATED MODULE: ./components_web/MultiSlider/index.js









function MultiSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MultiSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MultiSlider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MultiSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function MultiSlider_createSuper(Derived) { var hasNativeReflectConstruct = MultiSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function MultiSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


 // import LinearGradient from 'react-native-linear-gradient'















var MultiSlider = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(MultiSlider, _React$Component);

  var _super = MultiSlider_createSuper(MultiSlider);

  function MultiSlider(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MultiSlider);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "subscribePanResponder", function () {
      var customPanResponder = function customPanResponder(start, move, end) {
        return PanResponder_default().create({
          onStartShouldSetPanResponder: function onStartShouldSetPanResponder(evt, gestureState) {
            return true;
          },
          onStartShouldSetPanResponderCapture: function onStartShouldSetPanResponderCapture(evt, gestureState) {
            return true;
          },
          onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(evt, gestureState) {
            return true;
          },
          onMoveShouldSetPanResponderCapture: function onMoveShouldSetPanResponderCapture(evt, gestureState) {
            return true;
          },
          onPanResponderGrant: function onPanResponderGrant(evt, gestureState) {
            return start();
          },
          onPanResponderMove: function onPanResponderMove(evt, gestureState) {
            return move(gestureState);
          },
          onPanResponderTerminationRequest: function onPanResponderTerminationRequest(evt, gestureState) {
            return false;
          },
          onPanResponderRelease: function onPanResponderRelease(evt, gestureState) {
            return end(gestureState);
          },
          onPanResponderTerminate: function onPanResponderTerminate(evt, gestureState) {
            return end(gestureState);
          },
          onShouldBlockNativeResponder: function onShouldBlockNativeResponder(evt, gestureState) {
            return true;
          }
        });
      };

      _this._panResponderBetween = customPanResponder(function (gestureState) {
        _this.startOne(gestureState);

        _this.startTwo(gestureState);
      }, function (gestureState) {
        _this.moveOne(gestureState);

        _this.moveTwo(gestureState);
      }, function (gestureState) {
        _this.endOne(gestureState);

        _this.endTwo(gestureState);
      });
      _this._panResponderOne = customPanResponder(_this.startOne, _this.moveOne, _this.endOne);
      _this._panResponderTwo = customPanResponder(_this.startTwo, _this.moveTwo, _this.endTwo);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "startOne", function () {
      if (_this.props.enabledOne) {
        _this.props.onValuesChangeStart();

        _this.setState({
          onePressed: !_this.state.onePressed
        });
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "startTwo", function () {
      if (_this.props.enabledTwo) {
        _this.props.onValuesChangeStart();

        _this.setState({
          twoPressed: !_this.state.twoPressed
        });
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "moveOne", function (gestureState) {
      if (!_this.props.enabledOne) {
        return;
      }

      var accumDistance = _this.props.vertical ? -gestureState.dy : gestureState.dx;
      var accumDistanceDisplacement = _this.props.vertical ? gestureState.dx : gestureState.dy;
      var unconfined = (I18nManager_default()).isRTL ? _this.state.pastOne - accumDistance : accumDistance + _this.state.pastOne;
      var bottom = _this.props.markerSize / 2;
      var trueTop = _this.state.positionTwo - (_this.props.allowOverlap ? 0 : _this.props.minMarkerOverlapDistance > 0 ? _this.props.minMarkerOverlapDistance : (_this.props.minMarkerOverlapStepDistance || 1) * _this.stepLength);
      var top = trueTop === 0 ? 0 : trueTop || _this.props.sliderLength - _this.props.markerSize / 2;
      var confined = unconfined < bottom ? bottom : unconfined > top ? top : unconfined;
      var slipDisplacement = _this.props.touchDimensions.slipDisplacement;

      if (Math.abs(accumDistanceDisplacement) < slipDisplacement || !slipDisplacement) {
        var value = positionToValue(confined, _this.optionsArray, _this.props.sliderLength, _this.props.markerSize);
        var snapped = valueToPosition(value, _this.optionsArray, _this.props.sliderLength, _this.props.markerSize);

        _this.setState({
          positionOne: _this.props.snapped ? snapped : confined
        });

        if (value !== _this.state.valueOne) {
          _this.setState({
            valueOne: value
          }, function () {
            var change = [_this.state.valueOne];

            if (_this.state.valueTwo) {
              change.push(_this.state.valueTwo);
            }

            _this.props.onValuesChange(change);

            _this.props.onMarkersPosition([_this.state.positionOne, _this.state.positionTwo]);
          });
        }
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "moveTwo", function (gestureState) {
      if (!_this.props.enabledTwo) {
        return;
      }

      var accumDistance = _this.props.vertical ? -gestureState.dy : gestureState.dx;
      var accumDistanceDisplacement = _this.props.vertical ? gestureState.dx : gestureState.dy;
      var unconfined = (I18nManager_default()).isRTL ? _this.state.pastTwo - accumDistance : accumDistance + _this.state.pastTwo;
      var bottom = _this.state.positionOne + (_this.props.allowOverlap ? 0 : _this.props.minMarkerOverlapDistance > 0 ? _this.props.minMarkerOverlapDistance : (_this.props.minMarkerOverlapStepDistance || 1) * _this.stepLength);
      var top = _this.props.sliderLength - _this.props.markerSize / 2;
      var confined = unconfined < bottom ? bottom : unconfined > top ? top : unconfined;
      var slipDisplacement = _this.props.touchDimensions.slipDisplacement;

      if (Math.abs(accumDistanceDisplacement) < slipDisplacement || !slipDisplacement) {
        var value = positionToValue(confined, _this.optionsArray, _this.props.sliderLength, _this.props.markerSize);
        var snapped = valueToPosition(value, _this.optionsArray, _this.props.sliderLength, _this.props.markerSize);

        _this.setState({
          positionTwo: _this.props.snapped ? snapped : confined
        });

        if (value !== _this.state.valueTwo) {
          _this.setState({
            valueTwo: value
          }, function () {
            _this.props.onValuesChange([_this.state.valueOne, _this.state.valueTwo]);

            _this.props.onMarkersPosition([_this.state.positionOne, _this.state.positionTwo]);
          });
        }
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "endOne", function (gestureState) {
      if (gestureState.moveX === 0 && _this.props.onToggleOne) {
        _this.props.onToggleOne();

        return;
      }

      var snapped = valueToPosition(_this.state.valueOne, _this.optionsArray, _this.props.sliderLength);

      _this.setState(MultiSlider_objectSpread(MultiSlider_objectSpread({
        pastOne: _this.props.smoothSnapped ? snapped : _this.state.positionOne
      }, _this.props.smoothSnapped ? {
        positionOne: snapped
      } : {}), {}, {
        onePressed: !_this.state.onePressed
      }), function () {
        var change = [_this.state.valueOne];

        if (_this.state.valueTwo) {
          change.push(_this.state.valueTwo);
        }

        _this.props.onValuesChangeFinish(change);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "endTwo", function (gestureState) {
      if (gestureState.moveX === 0 && _this.props.onToggleTwo) {
        _this.props.onToggleTwo();

        return;
      }

      var snapped = valueToPosition(_this.state.valueTwo, _this.optionsArray, _this.props.sliderLength);

      _this.setState(MultiSlider_objectSpread({
        twoPressed: !_this.state.twoPressed,
        pastTwo: _this.props.smoothSnapped ? snapped : _this.state.positionTwo
      }, _this.props.smoothSnapped ? {
        positionTwo: snapped
      } : {}), function () {
        _this.props.onValuesChangeFinish([_this.state.valueOne, _this.state.valueTwo]);
      });
    });

    if (_this.props.minMarkerOverlapDistance > 0 && _this.props.minMarkerOverlapStepDistance > 0) {
      console.error('You should provide either "minMarkerOverlapDistance" or "minMarkerOverlapStepDistance", not both. Expect unreliable results.');
    }

    _this.optionsArray = _this.props.optionsArray || createArray(_this.props.min, _this.props.max, _this.props.step);
    _this.stepLength = _this.props.sliderLength / (_this.optionsArray.length - 1);

    var initialValues = _this.props.values.map(function (value) {
      return valueToPosition(value, _this.optionsArray, _this.props.sliderLength, _this.props.markerSize);
    });

    var tempStepsAs = {};

    _this.props.stepsAs.forEach(function (step) {
      if ((step === null || step === void 0 ? void 0 : step.index) !== undefined) {
        tempStepsAs[step === null || step === void 0 ? void 0 : step.index] = step;
      }
    });

    _this.stepsAs = {};

    _this.optionsArray.forEach(function (ops, index) {
      if (tempStepsAs[index]) {
        var step = tempStepsAs[index];
        _this.stepsAs[index] = {
          stepLabel: step !== null && step !== void 0 && step.stepLabel ? step.stepLabel : ops,
          suffix: step !== null && step !== void 0 && step.suffix ? step.suffix : "",
          prefix: step !== null && step !== void 0 && step.prefix ? step.prefix : ""
        };
      } else {
        _this.stepsAs[index] = {
          stepLabel: ops,
          suffix: "",
          prefix: ""
        };
      }
    });

    _this.state = {
      pressedOne: true,
      valueOne: _this.props.values[0],
      valueTwo: _this.props.values[1],
      pastOne: initialValues[0],
      pastTwo: initialValues[1],
      positionOne: initialValues[0],
      positionTwo: initialValues[1]
    };

    _this.subscribePanResponder();

    return _this;
  }

  (0,createClass/* default */.Z)(MultiSlider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevPositionOne = prevState.positionOne,
          prevPositionTwo = prevState.positionTwo;
      var _this$state = this.state,
          positionOne = _this$state.positionOne,
          positionTwo = _this$state.positionTwo;

      if (typeof positionOne === "undefined" && typeof positionTwo !== "undefined") {
        return;
      }

      if (positionOne !== prevPositionOne || positionTwo !== prevPositionTwo) {
        this.props.onMarkersPosition([positionOne, positionTwo]);
      }

      if (this.state.onePressed || this.state.twoPressed) {
        return;
      }

      var nextState = {};

      if (prevProps.min !== this.props.min || prevProps.max !== this.props.max || prevProps.step !== this.props.step || prevProps.values[0] !== this.props.values[0] || prevProps.sliderLength !== this.props.sliderLength || prevProps.values[1] !== this.props.values[1] || prevProps.sliderLength !== this.props.sliderLength && prevProps.values[1]) {
        this.optionsArray = this.props.optionsArray || createArray(this.props.min, this.props.max, this.props.step);
        this.stepLength = this.props.sliderLength / this.optionsArray.length;

        var _positionOne = valueToPosition(this.props.values[0], this.optionsArray, this.props.sliderLength, this.props.markerSize);

        nextState.valueOne = this.props.values[0];
        nextState.pastOne = _positionOne;
        nextState.positionOne = _positionOne;

        var _positionTwo = valueToPosition(this.props.values[1], this.optionsArray, this.props.sliderLength, this.props.markerSize);

        nextState.valueTwo = this.props.values[1];
        nextState.pastTwo = _positionTwo;
        nextState.positionTwo = _positionTwo;
        this.setState(nextState);
      }
    }
  }, {
    key: "getSteps",
    value: function getSteps() {
      var _this$props,
          _this$props$trackStyl,
          _this2 = this;

      var stepLength = this.props.sliderLength / (this.optionsArray.length - 1);
      var textStyles = [MultiSlider_styles.stepLabel, this.props.stepLabelStyle].concat((0,toConsumableArray/* default */.Z)(this.props.vertical ? [{
        transform: [{
          rotate: "90deg"
        }]
      }] : []));
      var markerHeight = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$trackStyl = _this$props.trackStyle) === null || _this$props$trackStyl === void 0 ? void 0 : _this$props$trackStyl.height) || MultiSlider_styles.track.height;
      var markerStyles = [MultiSlider_styles.stepMarker, {
        height: markerHeight,
        width: markerHeight,
        borderRadius: markerHeight / 2
      }, this.props.stepMarkerStyle];
      return this.optionsArray.map(function (number, index) {
        var step = _this2.stepsAs[index];
        return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [MultiSlider_styles.step, _this2.props.stepStyle, {
            left: stepLength * index
          }],
          children: [_this2.props.showStepMarkers && index !== 0 && index !== _this2.optionsArray.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: markerStyles
          }), _this2.props.showStepLabels && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: textStyles,
            children: "".concat(step.prefix).concat(step.stepLabel).concat(step.suffix)
          })]
        }, number);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state2 = this.state,
          positionOne = _this$state2.positionOne,
          positionTwo = _this$state2.positionTwo;
      var _this$props2 = this.props,
          selectedStyle = _this$props2.selectedStyle,
          unselectedStyle = _this$props2.unselectedStyle,
          sliderLength = _this$props2.sliderLength,
          markerOffsetX = _this$props2.markerOffsetX,
          markerOffsetY = _this$props2.markerOffsetY;
      var twoMarkers = this.props.values.length == 2; // when allowOverlap, positionTwo could be 0, identified as string '0' and throwing 'RawText 0 needs to be wrapped in <Text>' error

      var trackOneLength = positionOne;
      var trackOneStyle = twoMarkers ? unselectedStyle : selectedStyle || MultiSlider_styles.selectedTrack;
      var trackThreeLength = twoMarkers ? sliderLength - positionTwo : 0;
      var trackThreeStyle = unselectedStyle;
      var trackTwoLength = sliderLength - trackOneLength - trackThreeLength;
      var trackTwoStyle = twoMarkers ? selectedStyle || MultiSlider_styles.selectedTrack : unselectedStyle;
      var Marker = this.props.customMarker;
      var MarkerLeft = this.props.customMarkerLeft;
      var MarkerRight = this.props.customMarkerRight;
      var isMarkersSeparated = this.props.isMarkersSeparated || false;
      var Label = this.props.customLabel;
      var _this$props$touchDime = this.props.touchDimensions,
          slipDisplacement = _this$props$touchDime.slipDisplacement,
          height = _this$props$touchDime.height,
          width = _this$props$touchDime.width,
          borderRadius = _this$props$touchDime.borderRadius;

      var touchStyle = MultiSlider_objectSpread(MultiSlider_objectSpread({
        borderRadius: borderRadius || 0
      }, height && {
        height: height
      }), width && {
        width: width
      });

      var markerContainerOne = {
        top: markerOffsetY - 24,
        left: trackOneLength + markerOffsetX - 24
      };
      var markerContainerTwo = {
        top: markerOffsetY - 24,
        right: trackThreeLength + markerOffsetX - 24
      };
      var containerStyle = [MultiSlider_styles.container, this.props.containerStyle];

      if (this.props.vertical) {
        containerStyle.push({
          transform: [{
            rotate: "-90deg"
          }]
        });
      }

      var body = /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [MultiSlider_styles.fullTrack, {
            width: sliderLength
          }],
          children: [twoMarkers ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: [MultiSlider_styles.track, this.props.trackStyle, trackOneStyle, {
              width: trackOneLength
            }]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: [MultiSlider_styles.track, this.props.trackStyle, trackOneStyle, {
                width: trackOneLength
              }]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((0,formatHelpers/* getClass */.ll)("btn-gradient2"), " rounded-full"),
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }
            })]
          }), twoMarkers ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), MultiSlider_objectSpread({
              style: [MultiSlider_styles.track, this.props.trackStyle, trackTwoStyle, {
                width: trackTwoLength
              }]
            }, twoMarkers ? this._panResponderBetween.panHandlers : {})), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1 rounded-full",
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), MultiSlider_objectSpread({
            style: [MultiSlider_styles.track, this.props.trackStyle, trackTwoStyle, {
              width: trackTwoLength
            }]
          }, twoMarkers ? this._panResponderBetween.panHandlers : {})), twoMarkers && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: [MultiSlider_styles.track, this.props.trackStyle, trackThreeStyle, {
              width: trackThreeLength
            }]
          }), this.props.showSteps && this.getSteps(), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: [MultiSlider_styles.markerContainer, markerContainerOne, this.props.markerContainerStyle, positionOne > sliderLength / 2 && MultiSlider_styles.topMarkerContainer],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), MultiSlider_objectSpread(MultiSlider_objectSpread({
              style: [MultiSlider_styles.touch, touchStyle],
              ref: function ref(component) {
                return _this3._markerOne = component;
              }
            }, this._panResponderOne.panHandlers), {}, {
              children: isMarkersSeparated === false ? /*#__PURE__*/(0,jsx_runtime.jsx)(Marker, {
                enabled: this.props.enabledOne,
                pressed: this.state.onePressed,
                markerStyle: this.props.markerStyle,
                pressedMarkerStyle: this.props.pressedMarkerStyle,
                disabledMarkerStyle: this.props.disabledMarkerStyle,
                currentValue: this.state.valueOne,
                valuePrefix: this.props.valuePrefix,
                valueSuffix: this.props.valueSuffix
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(MarkerLeft, {
                enabled: this.props.enabledOne,
                pressed: this.state.onePressed,
                markerStyle: this.props.markerStyle,
                pressedMarkerStyle: this.props.pressedMarkerStyle,
                disabledMarkerStyle: this.props.disabledMarkerStyle,
                currentValue: this.state.valueOne,
                valuePrefix: this.props.valuePrefix,
                valueSuffix: this.props.valueSuffix
              })
            }))
          }), twoMarkers && positionOne !== this.props.sliderLength && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: [MultiSlider_styles.markerContainer, markerContainerTwo, this.props.markerContainerStyle],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), MultiSlider_objectSpread(MultiSlider_objectSpread({
              style: [MultiSlider_styles.touch, touchStyle],
              ref: function ref(component) {
                return _this3._markerTwo = component;
              }
            }, this._panResponderTwo.panHandlers), {}, {
              children: isMarkersSeparated === false ? /*#__PURE__*/(0,jsx_runtime.jsx)(Marker, {
                pressed: this.state.twoPressed,
                markerStyle: this.props.markerStyle,
                pressedMarkerStyle: this.props.pressedMarkerStyle,
                disabledMarkerStyle: this.props.disabledMarkerStyle,
                currentValue: this.state.valueTwo,
                enabled: this.props.enabledTwo,
                valuePrefix: this.props.valuePrefix,
                valueSuffix: this.props.valueSuffix
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(MarkerRight, {
                pressed: this.state.twoPressed,
                markerStyle: this.props.markerStyle,
                pressedMarkerStyle: this.props.pressedMarkerStyle,
                disabledMarkerStyle: this.props.disabledMarkerStyle,
                currentValue: this.state.valueTwo,
                enabled: this.props.enabledTwo,
                valuePrefix: this.props.valuePrefix,
                valueSuffix: this.props.valueSuffix
              })
            }))
          })]
        })
      });

      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        testID: this.props.testID,
        children: [this.props.enableLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          oneMarkerValue: this.state.valueOne,
          twoMarkerValue: this.state.valueTwo,
          minValue: this.props.min,
          maxValue: this.props.max,
          oneMarkerLeftPosition: positionOne,
          twoMarkerLeftPosition: positionTwo,
          oneMarkerPressed: this.state.onePressed,
          twoMarkerPressed: this.state.twoPressed
        }), this.props.imageBackgroundSource && /*#__PURE__*/(0,jsx_runtime.jsx)((ImageBackground_default()), {
          source: this.props.imageBackgroundSource,
          style: [{
            width: "100%",
            height: "100%"
          }, containerStyle],
          children: body
        }), !this.props.imageBackgroundSource && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: containerStyle,
          children: body
        })]
      });
    }
  }]);

  return MultiSlider;
}(react.Component);

(0,defineProperty/* default */.Z)(MultiSlider, "defaultProps", {
  values: [0],
  onValuesChangeStart: function onValuesChangeStart() {},
  onValuesChange: function onValuesChange(values) {},
  onValuesChangeFinish: function onValuesChangeFinish(values) {},
  onMarkersPosition: function onMarkersPosition(values) {},
  step: 1,
  min: 0,
  max: 10,
  touchDimensions: {
    height: 50,
    width: 50,
    borderRadius: 15,
    slipDisplacement: 200
  },
  customMarker: MultiSlider_DefaultMarker,
  customMarkerLeft: MultiSlider_DefaultMarker,
  customMarkerRight: MultiSlider_DefaultMarker,
  customLabel: DefaultLabel,
  markerOffsetX: 0,
  markerOffsetY: 0,
  markerSize: 0,
  sliderLength: 280,
  onToggleOne: undefined,
  onToggleTwo: undefined,
  stepsAs: [],
  showSteps: false,
  showStepMarkers: true,
  showStepLabels: true,
  enabledOne: true,
  enabledTwo: true,
  allowOverlap: false,
  snapped: false,
  smoothSnapped: false,
  vertical: false,
  minMarkerOverlapDistance: 0,
  minMarkerOverlapStepDistance: 0,
  testID: ""
});


var MultiSlider_styles = StyleSheet_default().create({
  container: {
    position: "relative",
    height: 50,
    justifyContent: "center"
  },
  fullTrack: {
    flexDirection: "row",
    borderRadius: 60
  },
  track: MultiSlider_objectSpread({}, Platform_default().select({
    ios: {
      height: 2,
      borderRadius: 60,
      backgroundColor: "#A7A7A7"
    },
    android: {
      height: 2,
      backgroundColor: "#CECECE"
    },
    web: {
      height: 2,
      borderRadius: 60,
      backgroundColor: "#A7A7A7"
    }
  })),
  selectedTrack: MultiSlider_objectSpread({}, Platform_default().select({
    ios: {
      backgroundColor: "#095FFF"
    },
    android: {
      backgroundColor: "#0D8675"
    },
    web: {
      backgroundColor: "#095FFF"
    }
  })),
  markerContainer: {
    position: "absolute",
    width: 48,
    height: 48,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center"
  },
  topMarkerContainer: {
    zIndex: 1
  },
  touch: {
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center"
  },
  step: {
    position: "absolute",
    marginLeft: -5
  },
  stepMarker: {
    position: "absolute",
    left: 2,
    width: 6,
    height: 6,
    backgroundColor: "#0000008c",
    borderRadius: 3
  },
  stepLabel: {
    position: "absolute",
    top: 15,
    color: "#333"
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/MultipleCheckModal/MultipleCheckContainer.js






function MultipleCheckContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MultipleCheckContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MultipleCheckContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MultipleCheckContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var MultipleCheckContainer = function MultipleCheckContainer(props) {
  var _props$checkedItemIds, _props$checkedItemIds2, _props$checkedItemIds3, _props$checkedItemIds4, _props$checkedItemIds5, _props$checkedItemIds6, _props$checkedItemIds7, _props$checkedItemIds8, _props$checkedItemIds9, _props$checkedItemIds10;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      category = props.category;

  var _React$useState = react.useState(props.checkedItemIds && ((_props$checkedItemIds = props.checkedItemIds) === null || _props$checkedItemIds === void 0 ? void 0 : _props$checkedItemIds.length) > 0 ? props.checkedItemIds : [0, 1000]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      multiSliderValue = _React$useState2[0],
      setMultiSliderValue = _React$useState2[1];

  var _React$useState3 = react.useState(props.checkedItemIds && ((_props$checkedItemIds2 = props.checkedItemIds) === null || _props$checkedItemIds2 === void 0 ? void 0 : _props$checkedItemIds2.length) > 0 ? props.checkedItemIds : ["Minimum", 0, "Or lower"]),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      ageValue = _React$useState4[0],
      setAgeValue = _React$useState4[1];

  var _React$useState5 = react.useState(props.dimensionLengthSelected || 0),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      dimensionLengthValue = _React$useState6[0],
      setDimensionLengthValue = _React$useState6[1];

  var _React$useState7 = react.useState(props.dimensionWidthSelected || 0),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      dimensionWidthValue = _React$useState8[0],
      setDimensionWidthValue = _React$useState8[1];

  var _React$useState9 = react.useState("All"),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      dateAvailable = _React$useState10[0],
      setDateAvailable = _React$useState10[1];

  var _React$useState11 = react.useState(props.dateType === "available" ? "Open" : (_props$checkedItemIds3 = props.checkedItemIds) !== null && _props$checkedItemIds3 !== void 0 && _props$checkedItemIds3.isUpcoming ? "Upcoming" : (_props$checkedItemIds4 = props.checkedItemIds) !== null && _props$checkedItemIds4 !== void 0 && _props$checkedItemIds4.isAnytime ? "Anytime" : category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? null : "Upcoming"),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      dateSelection = _React$useState12[0],
      setDateSelection = _React$useState12[1];

  var _React$useState13 = react.useState(!((_props$checkedItemIds5 = props.checkedItemIds) !== null && _props$checkedItemIds5 !== void 0 && _props$checkedItemIds5.isUpcoming) && !((_props$checkedItemIds6 = props.checkedItemIds) !== null && _props$checkedItemIds6 !== void 0 && _props$checkedItemIds6.isAnytime) ? ((_props$checkedItemIds7 = props.checkedItemIds) === null || _props$checkedItemIds7 === void 0 ? void 0 : _props$checkedItemIds7.start) || new Date() : new Date()),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      startingDate = _React$useState14[0],
      setStartingDate = _React$useState14[1];

  var _React$useState15 = react.useState(!((_props$checkedItemIds8 = props.checkedItemIds) !== null && _props$checkedItemIds8 !== void 0 && _props$checkedItemIds8.isUpcoming) && !((_props$checkedItemIds9 = props.checkedItemIds) !== null && _props$checkedItemIds9 !== void 0 && _props$checkedItemIds9.isAnytime) ? (_props$checkedItemIds10 = props.checkedItemIds) === null || _props$checkedItemIds10 === void 0 ? void 0 : _props$checkedItemIds10.end : null),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      endingDate = _React$useState16[0],
      setEndingDate = _React$useState16[1];

  var _React$useState17 = react.useState(null),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      markedDate = _React$useState18[0],
      setMarkedDate = _React$useState18[1];

  var getDaysArray = function getDaysArray(start, end) {
    var arr = [];
    var dt = new Date(start);

    for (; dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
    }

    return arr;
  };

  var handlePickDays = function handlePickDays(days) {
    setDateSelection("");
    setStartingDate(moment_default()(days[0]).format("YYYY-MM-DD"));
    setEndingDate(moment_default()(days[1]).format("YYYY-MM-DD"));
  };

  var onLoadCountry = function onLoadCountry() {
    var params = {
      keyword: search,
      isCountryOnly: 1,
      pageSize: 1000
    };
    DAO/* LocationDao.find */.c0.find(params).then(function (locations) {
      setDataList(locations.filter(function (item) {
        return item.country;
      }).map(function (item) {
        return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, item), {}, {
          id: item.country_id,
          label: item.country,
          isSelected: props.checkedItemIds.includes(item.country_id) || false
        });
      }));
    });
  };

  (0,react.useEffect)(function () {
    selectDate().then(function (date) {
      setMarkedDate(date);
    });
  }, [startingDate, endingDate]);
  (0,react.useEffect)(function () {
    if (props.isCountry) {
      onLoadCountry();
    }
  }, []);

  var handlePickUpcoming = function handlePickUpcoming() {
    setDateSelection("Upcoming");
    setMarkedDate(null);
    setStartingDate(null);
    setEndingDate(null);
  };

  var handlePickAnytime = function handlePickAnytime() {
    setDateSelection("Anytime");
    setMarkedDate(null);
    setStartingDate(null);
    setEndingDate(null);
  };

  var selectDate = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var daylist, _markedDates;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              daylist = endingDate ? getDaysArray(new Date(startingDate), new Date(endingDate)) : [new Date(startingDate)];
              daylist.map(function (v) {
                return v.toISOString().slice(0, 10);
              }).join("");
              _markedDates = {};
              daylist.forEach(function (item, index) {
                var _date;

                if (index === 0) {
                  _date = (0,defineProperty/* default */.Z)({}, new Date(item).toISOString().slice(0, 10), {
                    startingDay: endingDate ? true : false,
                    endingDay: moment_default()(startingDate).format("YYYY-MM-DD") === moment_default()(endingDate).format("YYYY-MM-DD") ? true : false,
                    color: config/* Colors.gradient2 */.wL.gradient2
                  });
                  Object.assign(_markedDates, _date);
                } else if (index === daylist.length - 1) {
                  _date = (0,defineProperty/* default */.Z)({}, new Date(item).toISOString().slice(0, 10), {
                    endingDay: true,
                    color: config/* Colors.gradient2 */.wL.gradient2
                  });
                  Object.assign(_markedDates, _date);
                } else {
                  _date = (0,defineProperty/* default */.Z)({}, new Date(item).toISOString().slice(0, 10), {
                    color: "gray"
                  });
                  Object.assign(_markedDates, _date);
                }
              });
              return _context.abrupt("return", _markedDates);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function selectDate() {
      return _ref.apply(this, arguments);
    };
  }();

  var _React$useState19 = react.useState(""),
      _React$useState20 = (0,slicedToArray/* default */.Z)(_React$useState19, 2),
      search = _React$useState20[0],
      setSearch = _React$useState20[1];

  var _React$useState21 = react.useState(props.items.map(function (item) {
    var _props$checkedItemIds11;

    return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, item), {}, {
      isSelected: props.isLineup || props.isEventSize || props.isCompanyHomeSize || props.isRangeValue ? (_props$checkedItemIds11 = props.checkedItemIds) === null || _props$checkedItemIds11 === void 0 ? void 0 : _props$checkedItemIds11.some(function (i) {
        var _item$value, _item$value2;

        return i.value === ((_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.value) && i.minValue === ((_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2.minValue);
      }) : props.checkedItemIds.includes(item.tagId ? item.tagId : item.id) || false
    });
  }) || []),
      _React$useState22 = (0,slicedToArray/* default */.Z)(_React$useState21, 2),
      dataList = _React$useState22[0],
      setDataList = _React$useState22[1];

  var onPressItem = function onPressItem(item) {
    if (props.onPressItem) {
      props.onPressItem(item);
    }
  };

  var renderPickerItem = function renderPickerItem(data, index, isSelected) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        height: 44,
        alignSelf: "stretch",
        justifyContent: "center",
        alignItems: "center"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [MultipleCheckContainer_styles.pickerItemLabel, isSelected && {
          color: config/* Colors.white */.wL.white
        }],
        children: data
      })
    });
  };

  var pad = function pad(n, width, z) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  };

  var constructArray = function constructArray(startNum, endNum) {
    var yearArr = [];

    for (var i = startNum; i <= endNum; i++) {
      yearArr.push(pad(i, 2, "0"));
    }

    return yearArr;
  };

  var renderItems = function renderItems() {
    if (props.isDate) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          marginBottom: -20
        },
        children: [props.dateType === "available" && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: MultipleCheckContainer_styles.row,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCheckBox */.ku, {
            label: "All",
            checked: dateAvailable === "All",
            onPress: function onPress() {
              return setDateAvailable("All");
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCheckBox */.ku, {
            label: "Available",
            checked: dateAvailable === "Available",
            onPress: function onPress() {
              return setDateAvailable("Available");
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCheckBox */.ku, {
            label: "Not Available",
            checked: dateAvailable === "Not Available",
            onPress: function onPress() {
              return setDateAvailable("Not Available");
            }
          })]
        }), props.dateType === "available" && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: MultipleCheckContainer_styles.row2,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            buttonTitle: "Open",
            colored: dateSelection === "Open",
            filled: dateSelection !== "Open",
            filledColor: config/* Colors.grayBackground */.wL.grayBackground,
            filledTextColor: config/* Colors.grey2 */.wL.grey2,
            onPress: function onPress() {
              return setDateSelection("Open");
            },
            borderRadius: 4,
            style: {
              height: 24,
              flex: 1,
              marginRight: 10
            },
            isMobileVersion: isMobileVersion
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            buttonTitle: "Closed",
            colored: dateSelection === "Closed",
            filled: dateSelection !== "Closed",
            filledColor: config/* Colors.grayBackground */.wL.grayBackground,
            filledTextColor: config/* Colors.grey2 */.wL.grey2,
            onPress: function onPress() {
              return setDateSelection("Closed");
            },
            borderRadius: 4,
            style: {
              height: 24,
              flex: 1
            },
            isMobileVersion: isMobileVersion
          })]
        }), props.dateType === "anytime" && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: MultipleCheckContainer_styles.row2,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            buttonTitle: "Upcoming",
            colored: dateSelection === "Upcoming",
            filled: dateSelection !== "Upcoming",
            filledColor: config/* Colors.grayBackground */.wL.grayBackground,
            filledTextColor: config/* Colors.grey2 */.wL.grey2,
            onPress: function onPress() {
              return handlePickUpcoming();
            },
            borderRadius: 4,
            style: {
              height: isMobileVersion ? 24 : 40,
              flex: 1,
              marginRight: 10
            },
            isMobileVersion: isMobileVersion
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            buttonTitle: "Anytime",
            colored: dateSelection === "Anytime",
            filled: dateSelection !== "Anytime",
            filledColor: config/* Colors.grayBackground */.wL.grayBackground,
            filledTextColor: config/* Colors.grey2 */.wL.grey2,
            onPress: function onPress() {
              return handlePickAnytime();
            },
            borderRadius: 4,
            style: {
              height: isMobileVersion ? 24 : 40,
              flex: 1,
              marginRight: 0
            },
            isMobileVersion: isMobileVersion
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCalendar */.hR, {
          markingType: "period",
          markedDates: markedDate,
          selected: [moment_default()(startingDate).toDate(), moment_default()(endingDate).toDate()],
          isSmall: true,
          withRange: true,
          onDayPress: function onDayPress(value) {
            return handlePickDays(value);
          },
          isMobileVersion: isMobileVersion
        })]
      });
    } else if (props.isAge) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: MultipleCheckContainer_styles.ageContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [MultipleCheckContainer_styles.ageLabel, {
            color: "white"
          }, isMobileVersion ? {
            fontSize: 10
          } : {}],
          children: ageValue[0] || "Minimum"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingHorizontal: isMobileVersion ? 6 : 12,
            flex: 1
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: [MultipleCheckContainer_styles.arrowContainer, isMobileVersion ? {
                width: 30,
                height: 30
              } : {}],
              onClick: function onClick() {
                return setAgeValue([ageValue[0] || "Minimum", ageValue[1] - 1 < 0 ? 0 : parseInt(ageValue[1] - 1), ageValue[2] || "Or lower"]);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconAngleLeftWhite */.rU.iconAngleLeftWhite,
                width: 16,
                height: 16,
                layout: "fixed"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bg-grayBackground rounded-full flex flex-row items-center justify-center px-3 mx-2 ".concat(isMobileVersion ? "h-8" : "h-10", " w-full"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "text",
                className: "bg-grayBackground font-regular sm:text-base text-xs text-white outline-0 text-center w-full",
                value: ageValue[1],
                onChange: function onChange(e) {
                  setAgeValue([ageValue[0] || "Minimum", e.target.value > 60 ? 60 : e.target.value < 0 ? 0 : parseInt(e.target.value || 0), ageValue[2] || "Or lower"]);
                },
                min: 0,
                max: 60
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: [MultipleCheckContainer_styles.arrowContainer, isMobileVersion ? {
                width: 30,
                height: 30
              } : {}],
              onClick: function onClick() {
                return setAgeValue([ageValue[0] || "Minimum", ageValue[1] + 1 > 60 ? 60 : parseInt(ageValue[1] + 1), ageValue[2] || "Or lower"]);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconAngleRight */.rU.iconAngleRight,
                width: 16,
                height: 16,
                layout: "fixed"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [MultipleCheckContainer_styles.ageLabel, {
            color: "white"
          }, isMobileVersion ? {
            fontSize: 10
          } : {}],
          children: ageValue[2] || "Or lower"
        })]
      });
    } else if (props.isPrice) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: MultipleCheckContainer_styles.sliderContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
          style: MultipleCheckContainer_styles.sliderTitle,
          children: [multiSliderValue[0] === 0 ? "Free" : "".concat(multiSliderValue[0] ? "$" + multiSliderValue[0] : "Free"), " ", "-", " ", multiSliderValue[1] === 1000 ? "Max" : "$".concat(multiSliderValue[1] || 50)]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MultiSlider, {
          values: [multiSliderValue[0] || 0, multiSliderValue[1] || 50],
          trackGradientColors: ["#F526D6", "#A408FE", "#44B3F8"],
          markerStyle: [MultipleCheckContainer_styles.sliderMarker, isMobileVersion ? {
            height: 16,
            width: 16,
            top: 2
          } : {}],
          onValuesChange: function onValuesChange(value) {
            return setMultiSliderValue(value);
          },
          min: 0,
          max: 1000,
          step: 5,
          sliderLength: isMobileVersion ? config/* Values.deviceWidth */.$m.deviceWidth - 145 : 364,
          trackStyle: {
            height: isMobileVersion ? 4 : 10,
            backgroundColor: "#343434"
          }
        })]
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        children: [dataList.filter(function (item) {
          var _item$label;

          return props.isCountry ? search !== "" && search.length > 2 ? item === null || item === void 0 ? void 0 : (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toLowerCase().includes(search === null || search === void 0 ? void 0 : search.toLocaleLowerCase()) : false : item;
        }).map(function (item, index) {
          var isLast = index == dataList.length - 1;

          if (item.isSeparator) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "relative w-full mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: MultipleCheckContainer_styles.separatorLine
              })
            });
          }

          if (item.isTextOnly) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "relative w-full mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: {
                  color: config/* Colors.grayText2 */.wL.grayText2,
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                  fontSize: isMobileVersion ? 12 : 14,
                  lineHeight: isMobileVersion ? 16 : 18
                },
                children: item.label
              })
            });
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CCheckBox */.ku, {
            isMobileVersion: isMobileVersion,
            label: item.label,
            prefixIcon: item.prefixIcon,
            suffix: item.suffix,
            isDisabled: item.isDisabled,
            type: props.isSingle ? "radio" : "check",
            checked: item.isSelected,
            onPress: function onPress() {
              var _dataList$find;

              var currentSelected = (_dataList$find = dataList.find(function (item) {
                return item.isSelected;
              })) === null || _dataList$find === void 0 ? void 0 : _dataList$find.tagId;
              var newData = dataList.map(function (row) {
                if (row.tagId ? row.tagId === item.tagId : row.id === item.id) {
                  if (props.isMinimumOneSelect) {
                    if (currentSelected !== row.tagId) {
                      return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, row), {}, {
                        isSelected: !row.isSelected
                      });
                    }
                  } else {
                    return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, row), {}, {
                      isSelected: !row.isSelected
                    });
                  }
                } else {
                  if (props.isSingle) {
                    return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, row), {}, {
                      isSelected: false
                    });
                  }
                }

                return row;
              });
              setDataList(newData);
            },
            style: [!isLast && MultipleCheckContainer_styles.itemStyle, isMobileVersion ? {
              marginBottom: 18
            } : {}]
          }, "check" + index);
        }), props.isDimension && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: {
            flexDirection: "row",
            alignItems: "center"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [MultipleCheckContainer_styles.ageLabel, {
                color: "white",
                marginTop: 20
              }, isMobileVersion ? {
                fontSize: 10
              } : {}],
              children: "Length"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: MultipleCheckContainer_styles.ageContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: {
                  marginRight: 10,
                  flex: 1
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex flex-row items-center",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "bg-grayBackground rounded-full flex flex-row items-center justify-center px-3 ".concat(isMobileVersion ? "h-8" : "h-10", " w-[150px]"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                      type: "text",
                      className: "bg-grayBackground font-regular sm:text-base text-xs text-white outline-0 text-center w-full",
                      value: dimensionLengthValue,
                      onChange: function onChange(e) {
                        setDimensionLengthValue(parseInt(e.target.value || 0));
                      },
                      min: 0,
                      max: 60
                    })
                  })
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [MultipleCheckContainer_styles.ageLabel, {
                color: "white",
                marginTop: 20
              }, isMobileVersion ? {
                fontSize: 10
              } : {}],
              children: "Width"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: MultipleCheckContainer_styles.ageContainer,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: {
                  flex: 1
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex flex-row items-center",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "bg-grayBackground rounded-full flex flex-row items-center justify-center px-3 ".concat(isMobileVersion ? "h-8" : "h-10", " w-[150px]"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                      type: "text",
                      className: "bg-grayBackground font-regular sm:text-base text-xs text-white outline-0 text-center w-full",
                      value: dimensionWidthValue,
                      onChange: function onChange(e) {
                        setDimensionWidthValue(parseInt(e.target.value || 0));
                      },
                      min: 0,
                      max: 60
                    })
                  })
                })
              })
            })]
          })]
        })]
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [MultipleCheckContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "269966376",
      dynamic: [(0,formatHelpers/* getClass */.ll)("scrollbar"), (0,formatHelpers/* getClass */.ll)("scrollbar")],
      children: ["*{-webkit-scrollbar-width:thin;-moz-scrollbar-width:thin;-ms-scrollbar-width:thin;scrollbar-width:thin;-webkit-scrollbar-color:".concat((0,formatHelpers/* getClass */.ll)("scrollbar"), " transparent;-moz-scrollbar-color:").concat((0,formatHelpers/* getClass */.ll)("scrollbar"), " transparent;-ms-scrollbar-color:").concat((0,formatHelpers/* getClass */.ll)("scrollbar"), " transparent;scrollbar-color:").concat((0,formatHelpers/* getClass */.ll)("scrollbar"), " transparent;}"), "*::-webkit-scrollbar{width:8px;height:8px;}", "*::-webkit-scrollbar-track{background:transparent;border-radius:0px;}", "*::-webkit-scrollbar-thumb{background-color:".concat((0,formatHelpers/* getClass */.ll)("scrollbar"), ";border-radius:14px;border:3px solid transparent;}")]
    }), props.isSearchable && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedTextInput */.LA, {
      placeholder: t("key_search"),
      bordered: true,
      onChangeText: function onChangeText(text) {
        return setSearch(text);
      },
      value: search,
      maxLength: 64,
      autoCapitalize: "none",
      autoCorrect: false,
      containerStyle: {
        marginBottom: isMobileVersion ? 16 : 20,
        marginTop: isMobileVersion ? 16 : 24,
        marginHorizontal: isMobileVersion ? 7 : 6,
        height: isMobileVersion ? 38 : 50
      },
      returnKeyType: "search",
      showClose: search !== "",
      onPressClose: function onPressClose() {
        return setSearch("");
      },
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((ScrollView_default()), {
      bounces: !props.isAge && !props.isPrice,
      style: [MultipleCheckContainer_styles.wrapper, props.isDate ? {
        maxHeight: 600
      } : {}, isMobileVersion ? {
        paddingVertical: 0,
        paddingHorizontal: 26
      } : {}],
      children: renderItems()
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: MultipleCheckContainer_styles.footerButton,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: MultipleCheckContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: props.buttonTitleClear || t("key_button_clear"),
          style: {
            borderColor: (0,formatHelpers/* getClass */.ll)("border-black")
          },
          borderedTextColor: (0,formatHelpers/* getClass */.ll)("text-white"),
          bordered: true,
          borderRadius: 60,
          onPress: function onPress() {
            setMultiSliderValue([0, 50]);
            setAgeValue("Minimum", 17, "Or lower");
            var newData = dataList.map(function (item) {
              return MultipleCheckContainer_objectSpread(MultipleCheckContainer_objectSpread({}, item), {}, {
                isSelected: false
              });
            });
            setDataList(newData);
            props.onPressClear();
            setMarkedDate({});
            setStartingDate(null);
            setEndingDate(null);
          },
          isMobileVersion: isMobileVersion
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: MultipleCheckContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_button_apply"),
          filled: true,
          filledColor:  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 : null,
          filledTextColor:  false ? 0 : null,
          borderRadius: 60,
          onPress: function onPress() {
            onPressItem(props.isPrice ? multiSliderValue : props.isLineup || props.isEventSize || props.isCompanyHomeSize || props.isRangeValue ? dataList.filter(function (item) {
              return item.isSelected === true;
            }).map(function (item) {
              return item.value ? item.value : item.id;
            }) : props.isDate ? dateSelection === "Anytime" ? {
              isUpcoming: false,
              isAnytime: true
            } : dateSelection === "Upcoming" ? {
              isUpcoming: true,
              isAnytime: false
            } : {
              start: startingDate,
              end: endingDate || startingDate
            } : props.isAge ? ageValue : dataList.filter(function (item) {
              return item.isSelected === true;
            }).map(function (item) {
              return item.tagId ? item.tagId : item.id;
            }));
          },
          isMobileVersion: isMobileVersion
        })
      })]
    })]
  });
};

var MultipleCheckContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  wrapper: {
    maxHeight: 350,
    paddingHorizontal: 32,
    paddingVertical: 20
  },
  itemStyle: {
    marginBottom: 20
  },
  separatorLine: {
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-card-continent"),
    height: 1,
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%"
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingBottom: 14,
    marginTop: 14
  },
  row2: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("bg-icon-gray1"),
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingVertical: 14
  },
  sliderContainer: {
    paddingHorizontal: 10
  },
  sliderTitle: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.white */.wL.white,
    fontSize: 14,
    textAlign: "center"
  },
  sliderMarker: {
    backgroundColor: config/* Colors.white */.wL.white,
    height: 24,
    width: 24,
    borderRadius: 100,
    top: 5
  },
  ageContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingVertical: 16,
    position: "relative"
  },
  ageLabel: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    fontSize: 16
  },
  ageList: {
    position: "relative"
  },
  pickerItemLabel: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.grey */.wL.grey
  },
  ageItem: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    fontSize: 14
  },
  ageItemPrevNext: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grey2 */.wL.grey2,
    fontSize: 14,
    position: "absolute",
    width: 50
  },
  footerButton: {
    borderTopWidth: 1,
    borderTopColor: (0,formatHelpers/* getClass */.ll)("bg-icon-gray1"),
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingTop: 16,
    marginTop: 16,
    marginHorizontal: -16
  },
  footerItem: {
    flex: 1,
    paddingHorizontal: 8
  },
  arrowContainer: {
    width: 40,
    height: 40,
    borderWidth: 1,
    borderRadius: 60,
    borderColor: config/* Colors.grayBorder */.wL.grayBorder,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  }
});
/* harmony default export */ var MultipleCheckModal_MultipleCheckContainer = (MultipleCheckContainer);
;// CONCATENATED MODULE: ./src/components/molecules/MultipleCheckModal/index.js


function MultipleCheckModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MultipleCheckModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MultipleCheckModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MultipleCheckModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MultipleCheckModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, MultipleCheckModal_objectSpread(MultipleCheckModal_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MultipleCheckModal_MultipleCheckContainer, MultipleCheckModal_objectSpread(MultipleCheckModal_objectSpread({}, props), {}, {
      style: [{
        marginTop: 14
      }, props.isDate ? {
        minHeight: 430
      } : {}]
    }))
  }));
});
/* harmony default export */ var molecules_MultipleCheckModal = (MultipleCheckModal);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/CardInfoView.js
var CardInfoView = __webpack_require__(78576);
;// CONCATENATED MODULE: ./src/components/molecules/CardGrid/components/GridCardItem.js










var GridCardItem = function GridCardItem(props) {
  var general = props.general,
      isMobileVersion = props.isMobileVersion;
  var ITEM_WIDTH = isMobileVersion ? "90%" : (config/* Values.deviceWidth */.$m.deviceWidth - 6) / 3;
  var ITEM_HEIGHT = isMobileVersion ? (config/* Values.deviceWidth */.$m.deviceWidth - 6) / 3 : (config/* Values.deviceWidth */.$m.deviceWidth - 6) / 3;

  var onItemAction = function onItemAction(data) {
    if (props.onItemAction) {
      props.onItemAction(data);
    }
  };

  var item = props.item,
      index = props.index,
      hasMask = props.hasMask,
      hideAdd = props.hideAdd;
  var isLastItem = isMobileVersion ? index % 3 == 2 : index % 6 == 2;
  var isHeadliner = item.isHeadliner;

  var renderInfoView = function renderInfoView(_ref) {
    var item = _ref.item,
        index = _ref.index;

    if (props.renderInfoView) {
      return props.renderInfoView({
        item: item,
        index: index
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(CardInfoView/* default */.Z, {
      item: props.item,
      category: props.category,
      style: GridCardItem_styles.info,
      isMobileVersion: isMobileVersion
    });
  };

  var renderBackground = function renderBackground() {
    if (props.renderBackground) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: GridCardItem_styles.backgroundImage,
        children: props.renderBackground({
          item: item
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
      imgUrl: item.avatar,
      style: GridCardItem_styles.backgroundImage
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [GridCardItem_styles.itemContainer, isMobileVersion ? {
      width: (config/* Values.deviceWidth */.$m.deviceWidth - 9) / 3 - 3,
      height: 180,
      marginRight: 3,
      marginBottom: 3
    } : {
      width: 170,
      height: 250
    }, isLastItem && {
      marginRight: isMobileVersion ? 0 : 8
    }],
    children: [isHeadliner && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-gradient-to-l from-gradient3 via-gradient2 to-gradient1",
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      style: [GridCardItem_styles.itemContentContainer, isMobileVersion ? {
        width: ITEM_WIDTH,
        height: ITEM_HEIGHT
      } : {
        width: ITEM_WIDTH - 4,
        height: ITEM_WIDTH * 1.52 - 4
      }, !isHeadliner && GridCardItem_styles.noneHighlight],
      onPress: function onPress() {
        return onItemAction({
          type: config/* Constants.actionType.ACTION_VIEW */.gT.actionType.ACTION_VIEW,
          item: item
        });
      },
      children: [renderBackground(), hasMask && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-gradient-to-t from-realblack to-transparent",
        style: GridCardItem_styles.mask
      }), renderInfoView({
        item: item,
        index: index
      })]
    })]
  });
};

var GridCardItem_styles = StyleSheet_default().create({
  itemContainer: {
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderRadius: 8,
    marginRight: 8,
    marginBottom: 8
  },
  itemContentContainer: {
    borderRadius: 8,
    flexDirection: "column",
    backgroundColor: config/* Colors.black */.wL.black,
    justifyContent: "flex-end",
    overflow: "hidden"
  },
  noneHighlight: {
    width: "100%",
    height: "100%"
  },
  backgroundImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0
  },
  mask: {
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0
  },
  title: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white
  },
  description: {
    fontSize: 16,
    lineHeight: 18.19,
    marginLeft: 2,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.white80 */.wL.white80
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 4,
    marginBottom: 8
  },
  infoContainer: {
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: 8
  },
  plusButton: {
    position: "absolute",
    right: 6,
    top: 6,
    width: 16,
    height: 16
  },
  noneHighlightPlus: {
    right: 8,
    top: 8
  },
  plusIcon: {
    width: 7.68,
    height: 7.68
  },
  icon: {
    width: 10,
    height: 10
  }
});
/* harmony default export */ var components_GridCardItem = (GridCardItem);
;// CONCATENATED MODULE: ./src/components/molecules/CardGrid/index.js













var CardGrid = function CardGrid(props) {
  var items = props.items,
      hasMask = props.hasMask,
      hideAdd = props.hideAdd,
      isMobileVersion = props.isMobileVersion;

  var onLoadMore = function onLoadMore() {
    if (props.onLoadMore) {
      props.onLoadMore();
    }
  };

  var onRefresh = function onRefresh() {
    if (props.onRefresh) {
      props.onRefresh();
    }
  };

  var getItemLinkUrl = function getItemLinkUrl(item, category) {
    if (props.getItemLinkUrl) {
      return props.getItemLinkUrl(item);
    }

    return (0,helpers/* generateURLSlug */.ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, category);
  };

  var renderItem = function renderItem(_ref) {
    var item = _ref.item,
        index = _ref.index;

    if (props.renderItem) {
      return props.renderItem({
        item: item,
        index: index
      });
    }

    var url = getItemLinkUrl(item, props.category);
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      prefetch: false,
      href: url,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_GridCardItem, {
          item: item,
          hasMask: hasMask,
          hideAdd: hideAdd,
          index: index,
          onItemAction: props.onItemAction,
          renderInfoView: props.renderInfoView,
          renderBackground: props.renderBackground,
          category: props.category,
          isMobileVersion: isMobileVersion
        })
      })
    }, "card-" + index);
  };

  var loadingSkeleton = function loadingSkeleton(key) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "animate-pulse rounded-2xl mr-3 mb-6 overflow-hidden relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full bg-grayText h-250px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute top-0 p-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-14 h-16 bg-white3 rounded-xl"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "absolute bottom-0 p-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-36 bg-white3 h-3 rounded-md mb-3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-16 bg-white3 h-3 rounded-md mb-3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-32 bg-white3 h-3 rounded-md"
        })]
      })]
    }, "skeleton" + key);
  };

  var renderLoadingSkeletons = function renderLoadingSkeletons() {
    var skeletons = [];

    if (props.isLoading) {
      for (var i = 0; i < 6; i++) {
        skeletons.push(loadingSkeleton(i));
      }

      return skeletons;
    }

    return null;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [CardGrid_styles.container, isMobileVersion ? {
      paddingLeft: 0
    } : {}, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_es/* default */.Z, {
      dataLength: items.length,
      next: onLoadMore,
      hasMore: true,
      className: isMobileVersion ? "grid grid-cols-3" : "grid grid-cols-6",
      scrollThreshold: 0.2,
      children: [items.map(function (item, index) {
        return renderItem({
          item: item,
          index: index
        });
      }), renderLoadingSkeletons()]
    })
  });
};

var CardGrid_styles = StyleSheet_default().create({
  container: {
    alignSelf: "center"
  }
});
/* harmony default export */ var molecules_CardGrid = (CardGrid);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/SectionList/index.js
var SectionList = __webpack_require__(87355);
var SectionList_default = /*#__PURE__*/__webpack_require__.n(SectionList);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/SectionView/index.js
var SectionView = __webpack_require__(27199);
;// CONCATENATED MODULE: ./src/components/molecules/CardGrid/CardSectionGrid.js














var CardSectionGrid = function CardSectionGrid(props) {
  var items = props.items,
      hasMask = props.hasMask,
      isMobileVersion = props.isMobileVersion;

  var onLoadMore = function onLoadMore() {
    if (props.onLoadMore) {
      props.onLoadMore();
    }
  };

  var onRefresh = function onRefresh() {
    if (props.onRefresh) {
      props.onRefresh();
    }
  };

  var renderItem = function renderItem(_ref) {
    var item = _ref.item,
        index = _ref.index;
    if (!item) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      prefetch: false,
      href: (0,helpers/* generateURLSlug */.ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, props.category),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_GridCardItem, {
          item: item,
          index: index,
          hasMask: hasMask,
          onItemAction: props.onItemAction,
          renderInfoView: props.renderInfoView,
          category: props.category,
          isMobileVersion: isMobileVersion
        })
      })
    });
  };

  var renderSection = function renderSection(_ref2) {
    var item = _ref2.item,
        index = _ref2.index;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((FlatList_default()), {
      data: item.list,
      numColumns: isMobileVersion ? 3 : 6,
      renderItem: renderItem,
      keyExtractor: function keyExtractor(item, index) {
        return index.toString();
      }
    }, index + "list");
  };

  var renderSectionItem = function renderSectionItem(_ref3) {
    var section = _ref3.section;

    if (props.renderSectionItem) {
      return props.renderSectionItem(section);
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(SectionView/* default */.Z, {
      section: section,
      isMobileVersion: isMobileVersion
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [CardSectionGrid_styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((SectionList_default()), {
      numColumns: 6,
      sections: items,
      renderItem: renderSection,
      renderSectionHeader: renderSectionItem,
      refreshing: props.isLoading || false,
      keyExtractor: function keyExtractor(item, index) {
        return index.toString();
      },
      onRefresh: onRefresh,
      onEndReachedThreshold: 0.4,
      onEndReached: onLoadMore
    })
  });
};

var CardSectionGrid_styles = StyleSheet_default().create({
  container: {
    alignSelf: "center"
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
});
/* harmony default export */ var CardGrid_CardSectionGrid = (CardSectionGrid);
;// CONCATENATED MODULE: ./src/components/molecules/FollowModal/FollowContainer.js







var FollowContainer_FollowContainer = function FollowContainer(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(View, {
    style: [FollowContainer_styles.container, props.style],
    children: /*#__PURE__*/_jsx(IconizedButton, {
      buttonTitle: t("key_cancel"),
      style: [FollowContainer_styles.buttonStyle, {
        marginBottom: 16
      }],
      filled: true,
      onPress: props.onPressCancel
    })
  });
};

var FollowContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
    paddingTop: 24
  },
  plusIcon: {
    width: 14,
    height: 14,
    resizeMode: "contain",
    marginRight: 4
  }
});
/* harmony default export */ var FollowModal_FollowContainer = ((/* unused pure expression or super */ null && (FollowContainer_FollowContainer)));
;// CONCATENATED MODULE: ./src/components/molecules/FollowModal/index.js


function FollowModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FollowModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FollowModal_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FollowModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var FollowModal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function (props, ref) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(CModal, FollowModal_objectSpread(FollowModal_objectSpread({
    ref: ref
  }, props), {}, {
    title: t('key_follow'),
    icon: Images.iconPlusColored,
    children: /*#__PURE__*/_jsx(FollowContainer, FollowModal_objectSpread({}, props))
  }));
})));
/* harmony default export */ var molecules_FollowModal = ((/* unused pure expression or super */ null && (FollowModal)));
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/molecules/LocationModal/LocationContainer.js

















var LocationContainer = function LocationContainer(props) {
  var _router$query, _router$query2, _router$query3, _router$query4;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var isMobileVersion = props.isMobileVersion,
      category = props.category;
  var scrollRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(props.locationSelected),
      locationSelected = _useState[0],
      setLocationSelected = _useState[1];

  var _useState2 = (0,react.useState)(""),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      tempLocationSelected = _useState3[0],
      setTempLocationSelected = _useState3[1];

  var _useState4 = (0,react.useState)(props.distanceValue || ((router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.category) === "venues" ? 16 : (router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.category) === "festivals" ? 800 : 160)),
      distance = _useState4[0],
      setDistance = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      items = _useState5[0],
      setItems = _useState5[1];

  (0,react.useEffect)(function () {
    var delayDebounceFn = setTimeout(function () {
      onLoad(search === "");
    }, 500);
    return function () {
      return clearTimeout(delayDebounceFn);
    };
  }, [search]);

  var onLoad = function onLoad(isDefault) {
    var params = {
      keyword: search,
      withoutWorldwideVirtual: props.defaultIsEmpty,
      pageSize: 100
    };

    if (props.isCityOnly) {
      params.isCityOnly = 1;
    }

    if (props.isCountryOnly) {
      params.isCountryOnly = 1;
    }

    if (props.isShowState) {
      params.isShowState = 1;
    }

    DAO/* LocationDao.find */.c0.find(params).then(function (locations) {
      var _scrollRef$current;

      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollTo({
        y: 0,
        animated: true
      });

      if (isDefault && !props.defaultIsEmpty) {
        setItems(locations.filter(function (item) {
          return item.name === "World";
        }).concat(props.isCountryOnly ? [{
          country: "United States",
          country_id: 233,
          country_name: "United States",
          id: undefined,
          name: undefined,
          state: undefined
        }] : props.isCityOnly ? [{
          city_id: 122795,
          city_name: "New York City",
          country: "United States",
          country_id: 233,
          country_name: "United States",
          id: 122795,
          name: "New York City",
          state: "New York",
          state_name: "New York"
        }] : [{
          country: "United States",
          country_id: 233,
          country_name: "United States",
          id: undefined,
          name: undefined,
          state: undefined
        }, {
          state_id: 1452,
          state_name: "New York"
        }, {
          city_id: 122795,
          city_name: "New York City",
          country: "United States",
          country_id: 233,
          country_name: "United States",
          id: 122795,
          name: "New York City",
          state: "New York",
          state_name: "New York"
        }]).concat(locations.filter(function (item) {
          return item.name === "Virtual";
        })));
      } else {
        setItems(locations);
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [LocationContainer_styles.container, props.style],
    children: [tempLocationSelected ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [LocationContainer_styles.locationContainer, isMobileVersion ? {
        height: 40
      } : {}],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
        style: LocationContainer_styles.locationContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LocationContainer_styles.listItemName, isMobileVersion ? {
            fontSize: 14
          } : {}],
          children: tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.name
        }), (tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.state) && /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
          style: [LocationContainer_styles.listItemCountry, isMobileVersion ? {
            fontSize: 14
          } : {}, {
            paddingRight: 8
          }],
          children: [tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.state, ","]
        }), (tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.country) && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LocationContainer_styles.listItemCountry, isMobileVersion ? {
            fontSize: 14
          } : {}],
          children: tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.country
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        onPress: function onPress() {
          return setTempLocationSelected(null);
        },
        style: {
          marginRight: 4
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconClose */.rU.iconClose,
          width: 16,
          height: 16,
          layout: "fixed"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedTextInput */.LA, {
      placeholder: t("key_search"),
      bordered: true,
      onChangeText: function onChangeText(text) {
        return setSearch(text);
      },
      value: search,
      maxLength: 64,
      autoCapitalize: "none",
      autoCorrect: false,
      containerStyle: {
        marginBottom: isMobileVersion ? 16 : 20,
        marginTop: isMobileVersion ? 16 : 24,
        marginHorizontal: isMobileVersion ? 7 : 6,
        height: isMobileVersion ? 38 : 50
      },
      returnKeyType: "search",
      showClose: search !== "",
      onPressClose: function onPressClose() {
        return setSearch("");
      },
      isMobileVersion: isMobileVersion
    }), props.isDistance && tempLocationSelected && tempLocationSelected !== null && tempLocationSelected !== void 0 && tempLocationSelected.name && (tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.name) !== "World" && (tempLocationSelected === null || tempLocationSelected === void 0 ? void 0 : tempLocationSelected.name) !== "Virtual" ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [LocationContainer_styles.distanceContainer, isMobileVersion ? {
        paddingHorizontal: 40
      } : {
        paddingHorizontal: 40
      }],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: LocationContainer_styles.distanceTitleContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [LocationContainer_styles.distanceTitle, isMobileVersion ? {
            fontSize: 12
          } : {}],
          children: "Distance"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
          style: [LocationContainer_styles.distanceInfo, isMobileVersion ? {
            fontSize: 12
          } : {}],
          children: [distance, " km"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MultiSlider, {
          trackGradientColors: ["#F526D6", "#A408FE", "#44B3F8"],
          markerStyle: {
            backgroundColor: (0,formatHelpers/* getClass */.ll)("text-white"),
            height: isMobileVersion ? 16 : 24,
            width: isMobileVersion ? 16 : 24,
            borderRadius: 100,
            top: isMobileVersion ? 1 : 4
          },
          onValuesChange: function onValuesChange(value) {
            if (value && value.length > 0) {
              setDistance(value[0]);
            }
          },
          values: [distance],
          min: 0,
          max: (router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.category) === "venues" ? 16 : (router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.category) === "festivals" ? 800 : 160,
          trackStyle: {
            height: isMobileVersion ? 4 : 10,
            backgroundColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor")
          },
          containerStyle: {
            height: isMobileVersion ? 16 : 24,
            marginBottom: isMobileVersion ? 20 : 30
          },
          sliderLength: isMobileVersion ? config/* Values.deviceWidth */.$m.deviceWidth - 120 : 400
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
      ref: scrollRef,
      style: LocationContainer_styles.list,
      children: [props.defaultIsEmpty && search !== "" && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
            style: [LocationContainer_styles.listItem, isMobileVersion ? {
              paddingHorizontal: 40,
              height: "auto",
              paddingVertical: 8
            } : {}, (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) === item.country_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && item.country_id || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && item.id || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id) === item.state_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) === item.country_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id) === item.city_id && item.state_id && !item.country_id && !item.city_id && !item.id && !item.isWorldWide && !item.isVirtual || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isWorldWide) === item.isWorldWide && item.isWorldWide || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isVirtual) === item.isVirtual && item.isVirtual ? LocationContainer_styles.listItemActive : {}],
            onPress: function onPress() {
              if (props.withoutApply) {
                props.onPressApply(item, distance);
              } else {
                setLocationSelected(item);
              }
            },
            children: [item.name != undefined && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [LocationContainer_styles.listItemName, isMobileVersion ? {
                fontSize: 14
              } : {}],
              numberOfLines: 1,
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: [LocationContainer_styles.listItemState, isMobileVersion ? {
                fontSize: 14
              } : {}],
              numberOfLines: 1,
              children: [item.state_name != undefined && "".concat(item.state_name).concat(item.country_name ? "," : "", " "), item.country_name && item.country_name]
            })]
          }, index);
        })
      }), !props.defaultIsEmpty && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
            style: [LocationContainer_styles.listItem, isMobileVersion ? {
              paddingHorizontal: 40,
              height: "auto",
              paddingVertical: 8
            } : {}, (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) === item.country_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && item.country_id || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && item.id || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id) === item.state_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.id) === item.id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) === item.country_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id) === item.city_id && item.state_id && !item.country_id && !item.city_id && !item.id && !item.isWorldWide && !item.isVirtual || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isWorldWide) === item.isWorldWide && item.isWorldWide || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isVirtual) === item.isVirtual && item.isVirtual ? LocationContainer_styles.listItemActive : {}],
            onPress: function onPress() {
              if (props.withoutApply) {
                props.onPressApply(item, distance);
              } else {
                setLocationSelected(item);
              }
            },
            children: [item.name != undefined && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [LocationContainer_styles.listItemName, isMobileVersion ? {
                fontSize: 14
              } : {}],
              numberOfLines: 1,
              children: item.name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: [LocationContainer_styles.listItemState, isMobileVersion ? {
                fontSize: 14
              } : {}],
              numberOfLines: 1,
              children: [item.state_name != undefined && "".concat(item.state_name).concat(item.country_name ? "," : "", " "), item.country_name && item.country_name]
            })]
          }, index);
        })
      })]
    }), !props.withoutApply && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: LocationContainer_styles.footerButton,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: LocationContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_button_cancel"),
          borderRadius: 60,
          style: [LocationContainer_styles.buttonStyle, {
            borderColor: (0,formatHelpers/* getClass */.ll)("border-black")
          }],
          bordered: true,
          borderedTextColor: (0,formatHelpers/* getClass */.ll)("text-white"),
          onPress: props.onPressCancel,
          fontSize: isMobileVersion ? 12 : 16,
          isMobileVersion: isMobileVersion
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: LocationContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_button_apply"),
          style: LocationContainer_styles.buttonStyle,
          filled: true,
          filledColor:  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 : null,
          filledTextColor:  false ? 0 : null,
          borderRadius: 60,
          disabled: locationSelected === null || locationSelected === "",
          onPress: function onPress() {
            return props.isDistance && tempLocationSelected === null && locationSelected !== null && locationSelected !== void 0 && locationSelected.name && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.name) !== "World" && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.name) !== "Virtual" ? setTempLocationSelected(locationSelected) : props.onPressApply(locationSelected, distance);
          },
          fontSize: isMobileVersion ? 12 : 16,
          isMobileVersion: isMobileVersion
        })
      })]
    })]
  });
};

var LocationContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  titleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  title: {
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontSize: 16,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  titleIcon: {
    width: 16,
    height: 16,
    resizeMode: "contain",
    marginRight: 8
  },
  locationContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderWidth: 1,
    borderColor: (0,formatHelpers/* getClass */.ll)("border-spliterLine"),
    borderRadius: 60,
    paddingVertical: 9,
    paddingHorizontal: 16,
    marginTop: 24,
    marginBottom: 30,
    height: 50,
    marginHorizontal: 6
  },
  locationContent: {
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: config/* Colors.placeholder */.wL.placeholder
  },
  locationIconClose: {
    width: 14,
    height: 14,
    resizeMode: "contain",
    marginRight: 4
  },
  distanceContainer: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor"),
    borderTopWidth: 1,
    marginHorizontal: -16,
    paddingHorizontal: 16,
    paddingTop: 28,
    paddingBottom: 18,
    marginBottom: -20
  },
  distanceTitleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20
  },
  distanceTitle: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontSize: 16
  },
  distanceInfo: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.placeholder */.wL.placeholder,
    fontSize: 14
  },
  list: {
    marginHorizontal: -16,
    maxHeight: 200
  },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    marginBottom: 4,
    height: 40,
    paddingHorizontal: 48
  },
  listItemActive: {
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-listItemActive")
  },
  listItemName: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontSize: 16,
    paddingRight: 8
  },
  listItemState: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.placeholder */.wL.placeholder,
    fontSize: 16,
    paddingRight: 8,
    flex: 1
  },
  listItemCountry: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.placeholder */.wL.placeholder,
    fontSize: 16
  },
  footerButton: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor"),
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingTop: 20,
    marginHorizontal: -16,
    marginBottom: -14,
    marginTop: 4,
    flex: 1
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  buttonStyle: {
    marginBottom: 16
  }
});
/* harmony default export */ var LocationModal_LocationContainer = (LocationContainer);
;// CONCATENATED MODULE: ./src/components/molecules/LocationModal/index.js


function LocationModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LocationModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LocationModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LocationModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LocationModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, LocationModal_objectSpread(LocationModal_objectSpread({
    ref: ref
  }, props), {}, {
    icon: config/* Images.iconLocationPin */.rU.iconLocationPin,
    title: props.titleModal || t("key_location"),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationModal_LocationContainer, LocationModal_objectSpread({}, props))
  }));
});
/* harmony default export */ var molecules_LocationModal = (LocationModal);
;// CONCATENATED MODULE: ./src/components/molecules/Media/components/FullScreenImageModal.js






 // import Orientation, {
//   OrientationType,
//   useOrientationChange,
// } from "react-native-orientation-locker";
// import PhotoView from "react-native-photo-view";






var FullScreenImageModal = function FullScreenImageModal(props) {
  var _useState = (0,react.useState)("PORTRAIT"),
      orientation = _useState[0],
      setOrientation = _useState[1];

  var getSafeAreaStyle = function getSafeAreaStyle(orientation) {// if (orientation == OrientationType.PORTRAIT) {
    //   return {
    //     marginTop: Values.statusBarHeight,
    //     marginBottom: Values.bottomSpace,
    //   };
    // } else if (orientation == OrientationType["LANDSCAPE-LEFT"]) {
    //   return {
    //     marginLeft: Values.statusBarHeight,
    //     marginRight: Values.bottomSpace,
    //   };
    // } else if (orientation == OrientationType["LANDSCAPE-RIGHT"]) {
    //   return {
    //     paddingRight: Values.statusBarHeight,
    //     marginLeft: Values.bottomSpace,
    //   };
    // }
  };

  (0,react.useEffect)(function () {
    if (props.isVisible) {// Orientation.unlockAllOrientations();
    } else {// Orientation.lockToPortrait();
    }
  }, [props.isVisible]); // useOrientationChange((orientation) => {
  //   setOrientation(orientation);
  // });

  var imageView = function imageView() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
      imgUrl: props.image,
      style: FullScreenImageModal_styles.backgroundVideo,
      objectFit: "contain"
    });
  };

  var renderCloseButton = function renderCloseButton() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      style: {
        width: 60,
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: 14,
        right: 14
      },
      onPress: function onPress() {
        if (props.closeModal) {
          props.closeModal();
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        source: config/* Images.iconClose */.rU.iconClose,
        width: 30,
        height: 30,
        layout: "fixed"
      })
    });
  };

  var containerStyle = getSafeAreaStyle(orientation);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((Modal_default()), {
    animationType: "fade",
    supportedOrientations: ["portrait", "landscape"],
    transparent: true,
    onRequestClose: function onRequestClose() {
      return props.closeModal();
    },
    visible: props.isVisible,
    style: {
      margin: 0
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        flex: 1,
        backgroundColor: "black"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: [{
          flex: 1,
          backgroundColor: "black"
        }, containerStyle],
        children: [imageView(), renderCloseButton()]
      })
    })
  });
};

var FullScreenImageModal_styles = StyleSheet_default().create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    height: 200
  },
  imgContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  },
  videoPlayerIcon: {
    width: 60,
    height: 60,
    resizeMode: "contain"
  },
  ModalOutsideContainer: {
    flex: 1
  },
  ModalContainer: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  ModalWrapper: {
    flex: 1,
    backgroundColor: "black"
  },
  portraitWrapper: {
    marginTop: config/* Values.statusBarHeight */.$m.statusBarHeight,
    marginBottom: config/* Values.bottomSpace */.$m.bottomSpace
  },
  ModalBox: {
    width: "85%",
    backgroundColor: "#fff",
    paddingTop: 10,
    paddingHorizontal: 6,
    borderRadius: 4,
    opacity: 1
  },
  VideoPlayerContainer: {
    width: "100%",
    height: 150
  },
  VideoTitle: {
    paddingVertical: 8,
    fontSize: 18,
    textAlign: "center"
  },
  closeButton: {
    position: "absolute",
    right: 16,
    top: 16,
    width: 30,
    height: 30,
    backgroundColor: "#00000050",
    borderRadius: 15
  },
  imageFull: {
    width: "100%",
    height: "100%"
  },
  backgroundVideo: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "black"
  }
});
/* harmony default export */ var components_FullScreenImageModal = (FullScreenImageModal);
;// CONCATENATED MODULE: ./src/components/molecules/Media/components/ImagePreview.js














var ImagePreview = function ImagePreview(props) {
  var _useState = (0,react.useState)(false),
      isShowModal = _useState[0],
      setIsShowModal = _useState[1];

  if (!props.item) return null;
  var isFull = props.isFull,
      isAutoHeight = props.isAutoHeight,
      height = props.height,
      width = props.width;
  var image = props.item.image;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      activeOpacity: 1,
      onPress: function onPress() {
        setIsShowModal(true);
      },
      style: [ImagePreview_styles.container, props.style],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        imgUrl: image,
        width: width,
        height: height,
        layout: "fixed",
        style: {
          flex: 1
        },
        isAutoHeight: isAutoHeight,
        objectFit: isFull ? "contain" : "cover"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FullScreenImageModal, {
        image: image,
        isVisible: isShowModal,
        closeModal: function closeModal() {
          setIsShowModal(false);
        }
      })]
    })
  });
};

var ImagePreview_styles = StyleSheet_default().create({
  container: {
    backgroundColor: config/* Colors.black */.wL.black,
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center"
  }
});
/* harmony default export */ var components_ImagePreview = (ImagePreview);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Image/index.js
var Image = __webpack_require__(94965);
var Image_default = /*#__PURE__*/__webpack_require__.n(Image);
;// CONCATENATED MODULE: ./src/components/atoms/CVideoPlayer.js


 // import VideoPlayer from 'react-native-video'
// import { VLCPlayer } from 'react-native-vlc-media-player'

var CVideoPlayer = function CVideoPlayer(props) {
  // return <VideoPlayer {...props} />
  // return <VLCPlayer {...props} videoAspectRatio="16:9" />
  return null;
};

/* harmony default export */ var atoms_CVideoPlayer = (CVideoPlayer);
;// CONCATENATED MODULE: ./src/components/molecules/Media/components/VideoPreview.js
















var VideoPreview = function VideoPreview(props) {
  var _useState = (0,react.useState)(false),
      isOpenMedia = _useState[0],
      setIsOpenMedia = _useState[1];

  if (!props.item) return null;
  var isFull = props.isFull,
      isPlay = props.isPlay;
  var _props$item = props.item,
      image = _props$item.image,
      isLink = _props$item.isLink;
  var videoUrl = props.item.video;
  var isYoutubeUrl = videoUrl != null && videoUrl.includes("www.youtube.com");
  var isFacebookUrl = videoUrl != null && videoUrl.includes("www.facebook.com");

  var toggleMediaModal = function toggleMediaModal() {
    if (!isOpenMedia && isLink) {
      onOpenExternalLink(videoUrl);
    } else {
      setIsOpenMedia(!isOpenMedia);
    }
  };

  var onOpenExternalLink = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url) {
      var win;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              win = window.open(url, "_blank");
              win.focus();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onOpenExternalLink(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var isPlayVideo = isPlay || isOpenMedia;

  if (isYoutubeUrl || isFacebookUrl) {
    isPlayVideo = false;
  }

  var renderVideoPlayer = function renderVideoPlayer(_videoUrl) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CVideoPlayer, {
      source: {
        uri: _videoUrl
      },
      style: VideoPreview_styles.thumbImage,
      useTextureView: false,
      playInBackground: true,
      disableFocus: true,
      controls: false
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    activeOpacity: 1,
    style: [VideoPreview_styles.container, props.style],
    children: [isPlayVideo ? renderVideoPlayer(videoUrl) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
      imgUrl: image,
      style: VideoPreview_styles.thumbImage,
      resizeMode: isFull ? "contain" : "cover"
    }), !isPlayVideo && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      onPress: function onPress() {
        toggleMediaModal();
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Image_default()), {
        source: config/* Images.iconPlayButton */.rU.iconPlayButton,
        style: VideoPreview_styles.playIcon,
        resizeMode: "contain",
        alt: "icon play"
      })
    })]
  });
};

var VideoPreview_styles = StyleSheet_default().create({
  container: {
    backgroundColor: "black",
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center"
  },
  thumbImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  },
  playIcon: {
    width: 40,
    height: 40
  }
});
/* harmony default export */ var components_VideoPreview = (VideoPreview);
;// CONCATENATED MODULE: ./src/components/molecules/Media/index.js













var Media = function Media(props) {
  if (!props.item) return null;
  var isFull = props.isFull,
      item = props.item,
      isPlay = props.isPlay,
      isAutoHeight = props.isAutoHeight,
      height = props.height,
      width = props.width;
  var mediaType = item.mediaType;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [Media_styles.container, props.style],
    children: [mediaType == config/* Constants.mediaType.MEDIA_TYPE_IMAGE */.gT.mediaType.MEDIA_TYPE_IMAGE && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ImagePreview, {
      style: [{
        flex: 1,
        justifyContent: "center"
      }, props.mediaStyle],
      item: item,
      height: height,
      width: width,
      isAutoHeight: isAutoHeight,
      isFull: isFull
    }), mediaType == config/* Constants.mediaType.MEDIA_TYPE_VIDEO */.gT.mediaType.MEDIA_TYPE_VIDEO && /*#__PURE__*/(0,jsx_runtime.jsx)(components_VideoPreview, {
      style: [{
        flex: 1
      }, props.mediaStyle],
      item: item,
      isPlay: isPlay
    })]
  });
};

var Media_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center"
  }
});
/* harmony default export */ var molecules_Media = (Media);
;// CONCATENATED MODULE: ./src/components/molecules/BottomActionBar/BottomActionItem.js








var BottomActionItem_BottomActionItem = function BottomActionItem(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var item = props.item;
  if (!item) return null;
  var disabled = item.disabled,
      icon = item.icon;
  return /*#__PURE__*/_jsx(TouchableOpacity, {
    style: [BottomActionItem_styles.container, props.style],
    onPress: function onPress() {
      if (props.onPressItem) {
        props.onPressItem(item);
      }
    },
    disabled: disabled,
    children: icon && /*#__PURE__*/_jsx(CImage, {
      style: BottomActionItem_styles.icon,
      source: icon,
      tintColor: disabled ? Colors.white20 : null,
      resizeMode: "contain"
    })
  });
};

var BottomActionItem_styles = StyleSheet_default().create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  },
  icon: {
    width: 20,
    height: 20
  }
});
/* harmony default export */ var BottomActionBar_BottomActionItem = ((/* unused pure expression or super */ null && (BottomActionItem_BottomActionItem)));
;// CONCATENATED MODULE: ./src/components/molecules/BottomActionBar/index.js










var BottomActionBar = function BottomActionBar(props) {
  var items = props.items;

  var renderItems = function renderItems() {
    if (!items) return null;
    return items.map(function (item, index) {
      return /*#__PURE__*/_jsx(BottomActionItem, {
        item: item,
        onPressItem: props.onPressItem
      }, index + "action-item");
    });
  };

  return /*#__PURE__*/_jsx(View, {
    style: BottomActionBar_styles.container,
    children: renderItems()
  });
};

var BottomActionBar_styles = StyleSheet_default().create({
  container: {
    height: 52,
    alignSelf: "stretch",
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginTop: -25,
    flexDirection: "row"
  },
  menuItemContainer: {
    flex: 1
  }
});
/* harmony default export */ var molecules_BottomActionBar = ((/* unused pure expression or super */ null && (BottomActionBar)));
;// CONCATENATED MODULE: ./src/components/molecules/AlertModal/index.js


function AlertModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function AlertModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AlertModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AlertModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var AlertModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var isMobileVersion = props.isMobileVersion;

  var _useState = (0,react.useState)(props.hideButtonOk || false),
      hideButton = _useState[0],
      setHideButton = _useState[1];

  var _useState2 = (0,react.useState)(props.title || ""),
      title = _useState2[0],
      setTitle = _useState2[1];

  var _useState3 = (0,react.useState)(props.description || ""),
      description = _useState3[0],
      setDescription = _useState3[1];

  var _useState4 = (0,react.useState)(props.customContent || null),
      customContent = _useState4[0],
      setCustomContent = _useState4[1];

  var alertModalRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      alert: function alert() {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var customContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        setTitle(title);
        setDescription(description);
        setCustomContent(customContent);
        alertModalRef.current.showModal();
      },
      hideModal: function hideModal() {
        alertModalRef.current.hideModal();
      }
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(atoms/* CModal */.Tk, AlertModal_objectSpread(AlertModal_objectSpread({
    ref: alertModalRef,
    title: title
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: AlertModal_styles.container,
      children: customContent ? customContent : /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [AlertModal_styles.text, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 15
        } : {}],
        children: description
      })
    }), hideButton !== null && hideButton !== void 0 ? hideButton : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        width: "100%"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
        buttonTitle: "OK",
        style: [{
          marginTop: 32,
          flex: 1
        }],
        filled: true,
        onPress: function onPress() {
          return alertModalRef.current.hideModal();
        }
      })
    })]
  }));
});
var AlertModal_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    alignItems: "center",
    marginTop: 14
  },
  text: {
    fontSize: 16,
    lineHeight: 15,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    textAlign: "center",
    marginBottom: 16
  }
});
/* harmony default export */ var molecules_AlertModal = (AlertModal);
;// CONCATENATED MODULE: ./src/components/molecules/NotificationSwitch/index.js




 // import { Switch } from "react-native-switch";




var NotificationSwitch = function NotificationSwitch(_ref) {
  var title = _ref.title,
      defaultValue1 = _ref.defaultValue1,
      defaultValue2 = _ref.defaultValue2,
      setDefaultValue1 = _ref.setDefaultValue1,
      setDefaultValue2 = _ref.setDefaultValue2,
      hideSwitch2 = _ref.hideSwitch2;
  return /*#__PURE__*/_jsxs(View, {
    style: {
      marginBottom: 20
    },
    children: [/*#__PURE__*/_jsx(Text, {
      style: NotificationSwitch_styles.itemTitle,
      children: title
    }), /*#__PURE__*/_jsxs(View, {
      style: {
        backgroundColor: Colors.grayBackground,
        paddingHorizontal: 25,
        paddingVertical: 20,
        borderRadius: 16,
        marginTop: 10
      },
      children: [/*#__PURE__*/_jsx(View, {
        style: {
          flexDirection: "row",
          justifyContent: "space-between"
        },
        children: /*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: 16,
            color: Colors.white,
            fontFamily: Fonts.primaryRegular,
            textAlignVertical: "center"
          },
          children: "Push notifications"
        })
      }), !hideSwitch2 && /*#__PURE__*/_jsx(View, {
        style: {
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 25
        },
        children: /*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: 16,
            color: Colors.white,
            fontFamily: Fonts.primaryRegular,
            textAlignVertical: "center"
          },
          children: "E-mail"
        })
      })]
    })]
  });
};

/* harmony default export */ var molecules_NotificationSwitch = ((/* unused pure expression or super */ null && (NotificationSwitch)));
var NotificationSwitch_styles = StyleSheet_default().create({
  itemTitle: {
    fontSize: 14,
    lineHeight: 15,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/ConfirmationModal/index.js


function ConfirmationModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConfirmationModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConfirmationModal_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConfirmationModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var ConfirmationModal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(CModal, ConfirmationModal_objectSpread(ConfirmationModal_objectSpread({
    ref: ref
  }, props), {}, {
    title: props.title,
    children: /*#__PURE__*/_jsxs(View, {
      style: ConfirmationModal_styles.container,
      children: [/*#__PURE__*/_jsx(View, {
        style: {
          alignItems: "center",
          marginBottom: 20
        },
        children: /*#__PURE__*/_jsx(Text, {
          style: ConfirmationModal_styles.h3,
          children: props.desc
        })
      }), /*#__PURE__*/_jsxs(View, {
        style: {
          flexDirection: "row",
          justifyContent: "space-evenly",
          width: "100%",
          borderTopColor: Colors.tabBottomColor,
          borderTopWidth: 1
        },
        children: [/*#__PURE__*/_jsx(TouchableOpacity, {
          style: [ConfirmationModal_styles.modalButtonContainer, {
            backgroundColor: Colors.black,
            borderColor: Colors.white30,
            borderWidth: 1
          }],
          onPress: props.leftButtonAction,
          children: /*#__PURE__*/_jsx(Text, {
            style: [ConfirmationModal_styles.modalButtonText, {
              color: Colors.white
            }],
            children: props.leftButtonText
          })
        }), /*#__PURE__*/_jsx(TouchableOpacity, {
          style: ConfirmationModal_styles.modalButtonContainer,
          onPress: props.rightButtonAction,
          children: /*#__PURE__*/_jsx(Text, {
            style: [ConfirmationModal_styles.modalButtonText, {
              color: Colors.black
            }],
            children: props.rightButtonText
          })
        })]
      })]
    })
  }));
})));
/* harmony default export */ var molecules_ConfirmationModal = ((/* unused pure expression or super */ null && (ConfirmationModal)));
var ConfirmationModal_styles = StyleSheet_default().create({
  container: {
    marginTop: 15
  },
  modalTitle: {
    color: config/* Colors.white */.wL.white,
    fontSize: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    marginBottom: 10,
    textAlign: "center"
  },
  h3: {
    color: config/* Colors.white */.wL.white,
    fontSize: 16,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    lineHeight: 18,
    textAlign: "center"
  },
  modalButtonContainer: {
    paddingVertical: 8,
    width: "45%",
    backgroundColor: config/* Colors.white */.wL.white,
    borderRadius: 60,
    marginTop: 14,
    justifyContent: "center",
    alignItems: "center"
  },
  modalButtonText: {
    fontSize: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  iconClose: {
    position: "absolute",
    right: 18,
    top: 18
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/VerificationCodeModal/containers/VerificationCodeContainer.js










var VerificationCodeContainer_VerificationCodeContainer = function VerificationCodeContainer(props) {
  var description = props.description,
      onClose = props.onClose,
      onResend = props.onResend;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(""),
      code = _useState[0],
      setCode = _useState[1];

  var onSubmit = function onSubmit() {
    if (props.onSubmit) {
      props.onSubmit(code);
    }
  };

  return /*#__PURE__*/_jsxs(View, {
    style: [VerificationCodeContainer_styles.container, props.style],
    children: [/*#__PURE__*/_jsx(View, {
      style: VerificationCodeContainer_styles.titleContainer,
      children: /*#__PURE__*/_jsx(Text, {
        style: VerificationCodeContainer_styles.title,
        children: description
      })
    }), /*#__PURE__*/_jsx(IconizedTextInput, {
      placeholder: t("key_placeholder_verification_code"),
      bordered: true,
      onChangeText: function onChangeText(text) {
        setCode(text);
      },
      value: code,
      maxLength: 6,
      autoCapitalize: "none",
      autoCorrect: false,
      containerStyle: {},
      keyboardType: "numeric"
    }), /*#__PURE__*/_jsx(View, {
      style: VerificationCodeContainer_styles.infoContainer,
      children: /*#__PURE__*/_jsxs(Text, {
        style: VerificationCodeContainer_styles.info,
        children: [t("key_label_resend"), " ", /*#__PURE__*/_jsx(Text, {
          style: VerificationCodeContainer_styles.infoBold,
          onPress: onResend,
          children: t("key_action_resend")
        })]
      })
    }), /*#__PURE__*/_jsxs(View, {
      style: VerificationCodeContainer_styles.footerButton,
      children: [/*#__PURE__*/_jsx(View, {
        style: VerificationCodeContainer_styles.footerItem,
        children: /*#__PURE__*/_jsx(IconizedButton, {
          buttonTitle: t("key_button_cancel"),
          bordered: true,
          onPress: onClose
        })
      }), /*#__PURE__*/_jsx(View, {
        style: VerificationCodeContainer_styles.footerItem,
        children: /*#__PURE__*/_jsx(IconizedButton, {
          buttonTitle: t("key_button_confirm"),
          filled: true,
          onPress: onSubmit
        })
      })]
    })]
  });
};

var VerificationCodeContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  itemStyle: {
    marginBottom: 14
  },
  titleContainer: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center"
  },
  title: {
    color: config/* Colors.white50 */.wL.white50,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    textAlign: "center"
  },
  infoContainer: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center"
  },
  info: {
    color: config/* Colors.white50 */.wL.white50,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    textAlign: "center"
  },
  infoBold: {
    color: config/* Colors.white */.wL.white,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 20,
    textAlign: "center"
  },
  menuItemContainer: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center",
    borderTopWidth: 1,
    borderTopColor: config/* Colors.tabBottomColor */.wL.tabBottomColor
  },
  menuItemText: {
    color: config/* Colors.white */.wL.white,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    textAlign: "center"
  },
  footerButton: {
    borderTopWidth: 1,
    borderTopColor: config/* Colors.grayBackground */.wL.grayBackground,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingTop: 16,
    marginTop: 16,
    marginHorizontal: -16
  },
  footerItem: {
    flex: 1,
    paddingHorizontal: 8
  }
});
/* harmony default export */ var containers_VerificationCodeContainer = ((/* unused pure expression or super */ null && (VerificationCodeContainer_VerificationCodeContainer)));
;// CONCATENATED MODULE: ./src/components/molecules/VerificationCodeModal/index.js


function VerificationCodeModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VerificationCodeModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VerificationCodeModal_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VerificationCodeModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var VerificationCodeModal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(CModal, VerificationCodeModal_objectSpread(VerificationCodeModal_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx(VerificationCodeContainer, VerificationCodeModal_objectSpread({}, props))
  }));
})));
/* harmony default export */ var molecules_VerificationCodeModal = ((/* unused pure expression or super */ null && (VerificationCodeModal)));
// EXTERNAL MODULE: ./node_modules/react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js
var use_dropdown_menu = __webpack_require__(19768);
;// CONCATENATED MODULE: ./src/components/molecules/PlaylistModal/PlaylistContainer.js


function PlaylistContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlaylistContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlaylistContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlaylistContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var PlaylistContainer = function PlaylistContainer(props) {
  var _items$find;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      items = props.items;

  var _useState = (0,react.useState)("followed"),
      value = _useState[0],
      setValue = _useState[1];

  var _useDropdownMenu = (0,use_dropdown_menu/* default */.Z)(1),
      buttonProps = _useDropdownMenu.buttonProps,
      itemProps = _useDropdownMenu.itemProps,
      isOpen = _useDropdownMenu.isOpen,
      setIsOpen = _useDropdownMenu.setIsOpen;

  var onPressConfirm = function onPressConfirm() {
    if (props.onPressConfirm) {
      props.onPressConfirm(value);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [PlaylistContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [PlaylistContainer_styles.wrapper, isMobileVersion ? {
        paddingVertical: 0,
        paddingHorizontal: 0
      } : {}],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex relative",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", PlaylistContainer_objectSpread(PlaylistContainer_objectSpread({}, buttonProps), {}, {
          className: "bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 p-1px rounded-full w-full cursor-pointer",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-center bg-black text-white font-semibold text-center capitalize rounded-full cursor-pointer",
            style: {
              height: isMobileVersion ? 32 : 50,
              fontSize: isMobileVersion ? 12 : 16
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mr-6",
              children: ((_items$find = items.find(function (i) {
                return i.tagId === value;
              })) === null || _items$find === void 0 ? void 0 : _items$find.label) || "Followed Artists"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: config/* Images.iconArrowExpandedGray */.rU.iconArrowExpandedGray,
              resizeMode: "contain",
              width: 18,
              height: 10,
              alt: "Discover festivals with"
            })]
          })
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(isOpen ? "visible" : "", " flex flex-col bg-black absolute top-[55px] left-0 rounded-2xl z-[999] max-h-250px overflow-y-auto w-full border border-spliterLine py-4"),
          role: "menu",
          children: items.map(function (item, index) {
            if (item.isTextOnly) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: {
                  color: config/* Colors.grayText2 */.wL.grayText2,
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                  fontSize: isMobileVersion ? 12 : 14,
                  lineHeight: isMobileVersion ? 16 : 18,
                  textAlign: "center",
                  marginVertical: 10
                },
                children: item.label
              });
            } else {
              return /*#__PURE__*/(0,react.createElement)("div", PlaylistContainer_objectSpread(PlaylistContainer_objectSpread({}, itemProps[index]), {}, {
                key: index,
                className: "".concat(isMobileVersion ? "text-xs" : "text-base", " font-regular text-center text-white py-2 cursor-pointer transition-all hover:bg-grayBackground ").concat(value === item.tagId ? "bg-grayBackground" : ""),
                onClick: function onClick() {
                  setValue(item.tagId);
                  setIsOpen(false);
                }
              }), item.label);
            }
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: PlaylistContainer_styles.footerButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: PlaylistContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: "CONFIRM",
          colored: true,
          borderRadius: 60,
          onPress: function onPress() {
            onPressConfirm();
          },
          isMobileVersion: isMobileVersion,
          style: isMobileVersion ? {
            height: 33
          } : {}
        })
      })
    })]
  });
};

var PlaylistContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  wrapper: {
    maxHeight: 350,
    paddingHorizontal: 32,
    paddingVertical: 20
  },
  itemStyle: {
    marginBottom: 20
  },
  separatorLine: {
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    height: 1,
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%"
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingBottom: 14,
    marginTop: 14
  },
  row2: {
    borderTopColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingVertical: 14
  },
  sliderContainer: {
    paddingHorizontal: 10
  },
  sliderTitle: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.white */.wL.white,
    fontSize: 14,
    textAlign: "center"
  },
  sliderMarker: {
    backgroundColor: config/* Colors.white */.wL.white,
    height: 24,
    width: 24,
    borderRadius: 100,
    top: 5
  },
  ageContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingVertical: 16,
    position: "relative"
  },
  ageLabel: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    fontSize: 16
  },
  ageList: {
    position: "relative"
  },
  pickerItemLabel: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.grey */.wL.grey
  },
  ageItem: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    fontSize: 14
  },
  ageItemPrevNext: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grey2 */.wL.grey2,
    fontSize: 14,
    position: "absolute",
    width: 50
  },
  footerButton: {
    borderTopWidth: 1,
    borderTopColor: config/* Colors.grayBackground */.wL.grayBackground,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingTop: 12,
    marginTop: 16,
    marginBottom: -6,
    marginHorizontal: -16,
    position: "relative",
    zIndex: -1
  },
  footerItem: {
    flex: 1,
    paddingHorizontal: 8
  },
  arrowContainer: {
    width: 40,
    height: 40,
    borderWidth: 1,
    borderRadius: 60,
    borderColor: config/* Colors.grayBorder */.wL.grayBorder,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  }
});
/* harmony default export */ var PlaylistModal_PlaylistContainer = (PlaylistContainer);
;// CONCATENATED MODULE: ./src/components/molecules/PlaylistModal/index.js


function PlaylistModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlaylistModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlaylistModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlaylistModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlaylistModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, PlaylistModal_objectSpread(PlaylistModal_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlaylistModal_PlaylistContainer, PlaylistModal_objectSpread(PlaylistModal_objectSpread({}, props), {}, {
      style: {
        marginTop: 14
      }
    }))
  }));
});
/* harmony default export */ var molecules_PlaylistModal = (PlaylistModal);
;// CONCATENATED MODULE: ./src/components/molecules/index.js























/***/ }),

/***/ 19834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77058);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85112);
/* harmony import */ var _components_atoms_DotSplitedViews__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35295);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);














var LineupStatusView = function LineupStatusView(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var artistCount = props.artistCount,
      headlinerCount = props.headlinerCount,
      stageCount = props.stageCount,
      isMobileVersion = props.isMobileVersion,
      isMatchedLineup = props.isMatchedLineup;
  var artistCountTxt = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(artistCount);
  var headLinerCountTxt = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(headlinerCount);
  var stateCountTxt = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(stageCount);
  var items = [{
    count: artistCountTxt,
    label: t("key_lineup_artists")
  }, {
    count: headLinerCountTxt,
    label: isMatchedLineup ? "Match" : t("key_lineup_headliners")
  }];

  if (stageCount) {
    items.push({
      count: stateCountTxt,
      label: t("key_lineup_stages")
    });
  }

  var renderItemView = function renderItemView(count, label, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: styles.rowContainer,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default()), {
        style: [styles.numberStyle, isMobileVersion ? {
          fontSize: 10
        } : {}, isMatchedLineup ? {
          fontSize: isMobileVersion ? 10 : 16,
          lineHeight: isMobileVersion ? 14 : 20
        } : {}],
        children: count
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_7___default()), {
        style: [styles.textStyle, isMobileVersion ? {
          fontSize: 10
        } : {}, isMatchedLineup ? {
          fontSize: isMobileVersion ? 10 : 16,
          lineHeight: isMobileVersion ? 14 : 20
        } : {}],
        children: label
      })]
    }, "item" + index);
  };

  var renderViews = function renderViews(items) {
    return items.map(function (item, index) {
      return renderItemView(item.count, item.label, index);
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
    style: [styles.container, props.style],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atoms_DotSplitedViews__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      views: renderViews(items),
      dotStyle: styles.blackDot,
      isMobileVersion: isMobileVersion
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  container: {
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    height: 50
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  text: {
    fontSize: 20,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white
  },
  label: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    fontSize: 20,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white
  },
  dot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white
  },
  blackDot: {
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.grayText */ .wL.grayText
  },
  numberStyle: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    fontSize: 20,
    lineHeight: 24,
    marginRight: 6,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white
  },
  textStyle: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    fontSize: 20,
    lineHeight: 18,
    color: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.white */ .wL.white
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (LineupStatusView);

/***/ })

}]);